
(function($, DX, undefined) {
    var ui = DX.ui;    
    var MapBoxGL_URL = "https://api.tiles.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js";
    var MapBoxGL_CSS_URL = "https://api.tiles.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.css";
    //var mapServerBaseUrl="https://mapgen.westus.cloudapp.azure.com/styles/";
    var mapServerBaseUrl="https://maps.actransit.org/map/styles/";

    //var TILES_URL="https://ipaeio.actransit.org/maps/images/osm-bright/{z}/{x}/{y}.png";
    //var TILES_URL="https://ipaeio.actransit.org/maps/images/klokantech-basic/{z}/{x}/{y}.png";
    var Tile_BaseFormat="{z}/{x}/{y}.png"
    var osmMapsLoader;
    ui.registerMapProvider("osm.vector", ui.MapProvider.inherit({
        _mapType: function(type) {            
            var mapTypes = {
                osmbright: 'osm-bright',//google.maps.MapTypeId.HYBRID,
                klokantechbasic:'klokantech-basic', // google.maps.MapTypeId.ROADMAP
                positron:'positron' ,
                osmliberty:'OSM-Liberty',
                act:'act'
            };
            return mapTypes[type] || mapTypes.osmbright
        },
        _movementMode: function(type) {
            var movementTypes = {
                driving: google.maps.TravelMode.DRIVING,
                walking: google.maps.TravelMode.WALKING
            };
            return movementTypes[type] || movementTypes.driving
        },
        _resolveLocation: function(location) {
            var d = $.Deferred();
            if (typeof location === "string") {
                //var geocoder = new google.maps.Geocoder;
                //geocoder.geocode({address: location}, function(results, status) {
                //    if (status === google.maps.GeocoderStatus.OK)
                //        d.resolve(results[0].geometry.location)
                //})
            }
            else if ($.isArray(location))
                d.resolve([location[1], location[0]]);
            else if ($.isPlainObject(location) && $.isNumeric(location.lat) && $.isNumeric(location.lng))
                d.resolve([location.lng,location.lat]);
            return d.promise()
        },
        _normalizeLocation: function(location) {
            return {
                lat: location.lat(),
                lng: location.lng()
            }
        },
        
        load: function() {
            if (!osmMapsLoader) {
                osmMapsLoader = $.Deferred();

                $('<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: MapBoxGL_CSS_URL,
                    crossorigin:''                    
                }).appendTo('head');

                var newScript = document.createElement("script");
                newScript.onerror = function () { throw new URIError("The script " + oError.target.src + " didn't load correctly."); };
                newScript.onload = this._mapReady;
                $(newScript).appendTo('head');
                newScript.src = MapBoxGL_URL;
            }
            this._markers = [];
            this._routes = [];
            return osmMapsLoader.promise()
        },
        _mapReady: function() {
            //try {
            //    delete window[GOOGLE_MAP_READY]
            //}
            //catch(e) {
            //    window[GOOGLE_MAP_READY] = undefined
            //}
            osmMapsLoader.resolve()
        },
        render: function () {            
            var self = this;
            var deferred = $.Deferred(),
                initPromise = $.Deferred(),
                controls = this._option("controls");
            var options = {
                zoom: this._option("zoom"),
                center: [37.80549, -122.268763],
                mapTypeId: this._mapType(this._option("osmtype")),
                osmMapUrl:this._option("osmmapurl"),
                layers:this._option("layers") || [],
                panControl: controls,
                zoomControl: controls,
                mapTypeControl: controls,
                streetViewControl: controls
            };

            var popup = new mapboxgl.Popup({
                closeButton: true
                });
            // var bounds=[38.5600,-123.5237,36.9478,-120.6200];
            // var corner1 = L.latLng(bounds[0],bounds[1]); 
			// var corner2 = L.latLng(bounds[2],bounds[3]);
            // var boundsRestrictions = L.latLngBounds(corner1, corner2);
            
            var z= options["zoom"];
            var c= options['center'];
            var center=[c[1],c[0]]
            var mapServerUrl=mapServerBaseUrl +  options["mapTypeId"] + "/style.json";
           
            this._map = new mapboxgl.Map({
                container: this._$container[0],
                style: mapServerUrl,
                center:center,
                zoo:12
                });

            var map=this._map;
            map.on('load', function(){
                if (options['layers'].length){
                    for(var i=0;i<options['layers'].length;i++){
                        var layer=options['layers'][i];
                        if (layer && layer.enabled){
                            map.addSource(layer.name, {
                                "type": layer.type,
                                "data":layer.data
                            });      
                            map.loadImage(layer.icon, function (error, image) {
                                map.addImage(layer.name, image);
                                map.addLayer({
                                    'id':  layer.name + '-zoomedin',
                                    'type': 'symbol',
                                    'source': layer.name,
                                    "layout": {
                                        "text-field": "{name}",
                                        "text-padding": 0,
                                        "text-font": ["Metropolis Regular", "Noto Sans Regular", "Roboto Condensed Italic"],
                                        "text-anchor": "top",
                                        "text-size": 10,
                                        "text-offset": [
                                            0,
                                            1
                                        ],
                                        "icon-image": layer.name,
                                        "icon-size": 0.2,
                                    },
                                    "minzoom": 14,
                                    "maxzoom": 24
                                });
                                map.addLayer({
                                    'id': layer.name + '-zoomedout',
                                    'type': 'symbol',
                                    'source': layer.name,
                                    "layout": {
                                        "icon-image": layer.name,
                                        "icon-size": 0.15,
                                        "text-max-width": 12,
                                    },
                                    "minzoom": 12,
                                    "maxzoom": 14
                                });                        
                            });    
                        }
                    }
                }
                var fmouseMove=function(e){
                    // Change the cursor style as a UI indicator.                    
                    map.getCanvas().style.cursor = 'pointer';                     
                    // Populate the popup and set its coordinates based on the feature.
                    var feature = e.features[0];
                    //var t="https://www.google.com/maps?ll=' + feature.geometry.coordinates[1] + ',' + feature.geometry.coordinates[0] + '&z=22&t=m&hl=en-US&gl=US&mapclient=apiv3&cid=10492673287981522438"
                    var t='https://www.google.com/maps/search/' + encodeURI(feature.properties.name) + '/@' + feature.geometry.coordinates[1] + ',' + feature.geometry.coordinates[0] + ',20z';
                    //var t='https://www.google.com/maps/place/' + encodeURI(feature.properties.name) + '/?ll=' + feature.geometry.coordinates[1] + ',' + feature.geometry.coordinates[0] + '&z=22&t=m&hl=en-US';
                    //var t='https://www.google.com/maps/place/' + encodeURI(feature.properties.name) + '/@' + feature.geometry.coordinates[1] + ',' + feature.geometry.coordinates[0] + ',22z'
                    var title= sanitizeHTML(feature.properties.name) ;
                    if (feature.properties.abbrev)
                        title+='(' + sanitizeHTML(feature.properties.abbrev) + ')';
                    title +='<br/> <a target="_blank" href="' + t + '">View on Google Maps</a> ';
                    popup.setLngLat(feature.geometry.coordinates)
                    .setHTML(title)                    
                    .addTo(map);
                };
                var fmouseLeave=function(e){
                    map.getCanvas().style.cursor = '';
                    popup.remove();                    
                };

                map.on('click', 'poi_z14', fmouseMove);                     
                //map.on('mouseleave', 'poi_z14', fmouseLeave);                
                map.on('click', 'poi_z15', fmouseMove);                     
                //map.on('mouseleave', 'poi_z15', fmouseLeave);                
                map.on('click', 'poi_z16', fmouseMove);                     
                //map.on('mouseleave', 'poi_z16', fmouseLeave);                

                initPromise.resolve();
                //return $.proxy(initPromise.resolve, initPromise)
            });
            map.setCenter(center);
            map.setZoom(z);
            //klokantech-basic/style.json

            //this._map = L.map(this._$container[0],{maxBounds:boundsRestrictions}).on('load', $.proxy(initPromise.resolve, initPromise)).setView(c, z);
            // this._map = L.map(this._$container[0]).on('load', function(){
            //     self._map.setView(c, z);
            //     setTimeout(() => {
            //         $.proxy(initPromise.resolve, initPromise)();    
            //     }, 1000);
                
            // });
            
           // var TILES_URL=options['osmMapUrl'] + options["mapTypeId"] + "/" + Tile_BaseFormat;

            // L.tileLayer(TILES_URL, {
            //     attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            //     //center: L.latLng(center[0], center[1]),
            //     maxZoom: 18,
            //     minZoom: 9,
            //     //maxBounds: boundsRestrictions,
            //     id: 'mapbox.streets',
            //     accessToken: 'your.mapbox.access.token'
            // }).addTo(this._map);

            //this._map = new google.maps.Map(this._$container[0], options);
            //var listner = google.maps.event.addListener(this._map, 'idle', $.proxy(initPromise.resolve, initPromise));
            //var listner = this._map.on('load', $.proxy(initPromise.resolve, initPromise));
                        
            this._zoomChangeListener = this._map.on('zoomend', $.proxy(this._handleZoomChange, this));
            //this._centerChangeListener = google.maps.event.addListener(this._map, 'center_changed', $.proxy(this._handleCenterChange, this));
            this._clickListener = this._map.on('click', $.proxy(this._handleClickAction, this));
            var locationPromise = this._renderLocation();
            var markersPromise = this._refreshMarkers();
            var routesPromise = this._renderRoutes();            
            $.when(initPromise, locationPromise, markersPromise, routesPromise).done(function () {
                self._map.off('load');
                //google.maps.event.removeListener(listner);
                
                deferred.resolve(true)
            });
            return deferred.promise();
        },
        updateDimensions: function () {
            this._map.fire('resize');
            //google.maps.event.trigger(this._map, 'resize');
            return $.Deferred().resolve().promise()
        },
        updateMapType: function() {            
            //this._map.setMapTypeId(this._mapType(this._option("type")));
            return $.Deferred().resolve().promise()
        },
        updateOsmMapType: function(){
            if (this._map){
                var style=this._mapType(this._option("osmtype"));
                var mapServerUrl=mapServerBaseUrl +  style + "/style.json";
                this._map.setStyle(mapServerUrl);
            }
                
            //console.log('updateMapType ' + this._mapType(this._option("osmtype")));
            return $.Deferred().resolve().promise()
        },
        updateLocation: function() {
            return this._renderLocation()
        },
        _handleCenterChange: function() {
            var center = this._map.getCenter();
            this._option("location", this._normalizeLocation(center))
        },
        _renderLocation: function() {
            var deferred = $.Deferred();
            var self = this;
            this._resolveLocation(this._option("location")).done(function (location) {
                //var z = self._map.getZoom();
                //self._map.setView(location, z);
                //self._map.setCenter( [-122.269675, 37.806221]);
                self._map.setCenter(location);
                //self._map.setZoom(17);
                //self._map.setCenter(location);
                //self._map.setCenter(location);
                deferred.resolve()                

            });
            return deferred.promise()
        },
        _handleZoomChange: function () {            
            var z=this._map.getZoom();
            //console.log("OSM, _handleZoomChange, zoom:" + z);
            this._option("zoom", z)
        },
        updateZoom: function() {
            //console.log("OSM, UpdateZoom!");
            this._map.setZoom(this._option("zoom"));
            return $.Deferred().resolve().promise()
        },
        updateControls: function() {
            //console.log("OSM, controls!");
            var controls = this._option("controls");
            this._map.setOptions({
                panControl: controls,
                zoomControl: controls,
                mapTypeControl: controls,
                streetViewControl: controls
            });
            return $.Deferred().resolve().promise()
        },
        _clearBounds: function() {
            this._bounds = null
        },
        _extendBounds: function(location) {
            if (this._bounds)
                this._bounds.extend(location);
            else {
                this._bounds = new google.maps.LatLngBounds;
                this._bounds.extend(location)
            }
        },
        _fitBounds: function () {
            var autoAdjust = this._option("autoAdjust")
            if (!autoAdjust || !this._bounds)
                return;
            //console.log("OSM firBounds!!");
            this._map.fitBounds(this._bounds)
        },
        updateMarkers: function() {
            return this._refreshMarkers()
        },
        _refreshMarkers: function() {
            this._clearMarkers();
            return this._renderMarkers()
        },
        _clearMarkers: function() {
            var self = this;
            this._clearBounds();
            $.each(this._markers, function(_, marker) {
                marker.instance.setMap(null);
                if (marker.listner)
                    google.maps.event.removeListener(marker.listner)
            });
            this._markers = []
        },
        addMarkers: function(options) {
            return this._renderMarkers(options)
        },
        _renderMarkers: function(options) {
            options = options || this._option("markers");
            var deferred = $.Deferred(),
                self = this;
            var markerPromises = $.map(options, function(markerOptions) {
                return self._addMarker(markerOptions)
            });
            $.when.apply($, markerPromises).done(function() {
                var instances = $.map($.makeArray(arguments), function(marker) {
                    return marker.instance
                });
                deferred.resolve(false, instances)                
            });
            deferred.done(function() {
                self._fitBounds()
            });
            return deferred.promise()
        },
        _addMarker: function(options) {
            var self = this;
            return this._renderMarker(options).done(function(marker) {
                self._markers.push(marker)
            })
        },
        _renderMarker: function(options) {
            var d = $.Deferred(),
                self = this;
            this._resolveLocation(options.location).done(function(location) {
                console.log(location);
                var marker = new Marker().setLngLat(location).addTo(this._map);
                var listner;
                var infoWindow = self._renderTooltip(marker, options.tooltip);
                // if (options.clickAction || options.tooltip) {
                //     var markerClickAction = self._createAction(options.clickAction || $.noop);
                //     listner = google.maps.event.addListener(marker, "click", function() {
                //         markerClickAction({location: self._normalizeLocation(location), marker: marker});
                //         if (infoWindow)
                //             infoWindow.open(self._map, marker)
                //     })
                // }
                self._extendBounds(location);
                d.resolve({
                    instance: marker,
                    listner: listner
                })
            });
            return d.promise()
        },
      
        _renderTooltip: function(marker, options) {
            if (!options)
                return;
            options = this._parseTooltipOptions(options);
            var infoWindow = new google.maps.InfoWindow({content: options.text});
            if (options.visible)
                infoWindow.open(this._map, marker);
            return infoWindow
        },
        updateRoutes: function() {
            return this._refreshRoutes()
        },
        addRoutes: function(options) {
            return this._renderRoutes()
        },
        _refreshRoutes: function() {
            this._clearRoutes();
            return this._renderRoutes()
        },
        _clearRoutes: function() {
            var self = this;
            $.each(this._routes, function(_, route) {
                route.setMap(null)
            });
            this._routes = []
        },
        _renderRoutes: function(options) {
            options = options || this._option("routes");
            var deferred = $.Deferred(),
                self = this;
            var routePromises = $.map(options, function(routeOptions) {
                return self._addRoute(routeOptions)
            });
            $.when.apply($, routePromises).done(function() {
                deferred.resolve(false, $.makeArray(arguments))                
            });
            return deferred.promise()
        },
        _addRoute: function(options) {
            var self = this;
            return this._renderRoute(options).done(function(route) {
                self._routes.push(route)
            })
        },
        _renderRoute: function(options) {
            var d = $.Deferred(),
                self = this,
                directionsService = new google.maps.DirectionsService;
            var points = $.map(options.locations, function(point) {
                return self._resolveLocation(point)
            });
            $.when.apply($, points).done(function() {
                var locations = $.makeArray(arguments),
                    origin = locations.shift(),
                    destination = locations.pop(),
                    waypoints = $.map(locations, function(location) {
                        return {
                            location: location,
                            stopover: true
                        }
                    });
                var request = {
                    origin: origin,
                    destination: destination,
                    waypoints: waypoints,
                    optimizeWaypoints: true,
                    travelMode: self._movementMode(options.mode)
                };
                directionsService.route(request, function(response, status) {
                    if (status === google.maps.DirectionsStatus.OK) {
                        var color = new DX.Color(options.color || self._defaultRouteColor()).toHex(),
                            directionOptions = {
                                directions: response,
                                map: self._map,
                                suppressMarkers: true,
                                preserveViewport: true,
                                polylineOptions: {
                                    strokeWeight: options.weight || self._defaultRouteWeight(),
                                    strokeOpacity: options.opacity || self._defaultRouteOpacity(),
                                    strokeColor: color
                                }
                            };
                        var route = new google.maps.DirectionsRenderer(directionOptions);
                        d.resolve(route)
                    }
                })
            });
            return d.promise()
        },
        clean: function() {
            try{
                if (this._map) {                
                    this._map.off('zoomend',this._zoomChangeListener);
                    this._map.off('click',this._handleClickAction);
                    this._clearMarkers();
                    this._clearRoutes();
                    delete this._map;
                    this._$container.empty()
                }    
            }
            catch(e){
                console.error(e);
            }
        },
        cancelEvents: true
    }));
    if (!ui.dxMap.__internals)
        ui.dxMap.__internals = {};
    var prevRemapConstant = ui.dxMap.__internals.remapConstant || $.noop;
    ui.dxMap.__internals.remapConstant = function(variable, newValue) {
        switch (variable) {
            case "LEAFLET_URL":
                LEAFLET_URL = newValue;
                break;
            default:
                prevRemapConstant.apply(this, arguments)
        }
    }
})(jQuery, DevExpress);
// ServiceURL.js
var mainDomain = "http://www.actransit.org";
var wordPressHosts = ["http://webtest01", "http://webtest03", "http://www.actransit.org"];
var tlsMode = location.protocol == "https:";
var service = window.location.host; function bin2hex(b) { return b.match(/.{4}/g).reduce(function (acc, i) { return acc + parseInt(i, 2).toString(16).toUpperCase(); }, ''); }
var busTimeBase = "https://api.actransit.org/transit/actrealtime/";
var busTimeSchedule = "https://api.actransit.org/transit/"; // = base;
var busTimeApiToken = bin2hex("01001001100001101100001111011000011001100100001011001101100111011100000010011101101100010010010111001010110010001011111111110001"); // PROD
if (service.indexOf("localhost") >= 0) {
    service = "https" + (tlsMode ? "s" : "") + "://testapi.actransit.org/mobile/";
    //service = "http" + (tlsMode ? "s" : "") + "://localhost/ACTransit.Mobile.API/";
    //service = "http" + (tlsMode ? "s" : "") + "://localhost:61831/";
    mainDomain = "http://webtest01";
    busTimeBase = "https://testapi.actransit.org/transit/actrealtime/";
    busTimeSchedule = "https://testapi.actransit.org/transit/"; // = base;
    busTimeApiToken = bin2hex("01001001100001101100001111011000011001100100001011001101100111011100000010011101101100010010010111001010110010001011111111111010"); // TEST

    //service = window.location.protocol + "//" + window.location.host.replace(":" + window.location.port, "") + "/ACTransit.Mobile.API/"; // IIS (localhost)
    //service = window.location.protocol + "//" + window.location.host.replace(window.location.port, window.location.port - 1) + "/mobile/"; // api is on :port-1, IIS Express (localhost)    
} else if (service.indexOf("mdev") >= 0) {
    service = "http" + (tlsMode ? "s" : "") + "://devapi.actransit.org/mobile/";
    mainDomain = "http://webtest01";
} else if (service.indexOf("ipaeio") >= 0 || service.indexOf("mtest") >= 0) {
    service = "http" + (tlsMode ? "s" : "") + "://testapi.actransit.org/mobile/";
    mainDomain = "http://webtest03";
    busTimeBase = "https://testapi.actransit.org/transit/actrealtime/";
    busTimeSchedule = "https://testapi.actransit.org/transit/"; // = base;
    busTimeApiToken = bin2hex("01001001100001101100001111011000011001100100001011001101100111011100000010011101101100010010010111001010110010001011111111111010"); // TEST
    //var busTimeBase = service + "bustime/";  //"http://webtest01.actransit.org/";
    //var busTimeBase = "http://localhost/ACTransit.Transit.API/actrealtime/";
} else {
    service = "http" + (tlsMode ? "s" : "") + "://m.actransit.org/api/"; //"http://api.actransit.org/mobile/"
}

var virtualDirectoryName=(window.location.href.indexOf("/test/")>=0?"/test":(window.location.href.indexOf("/demo/")>=0?"/demo":""));
var vehicleMotionEnabled=true;
var utility= {

}

var OccupancyImages={empty:'manyseatsavailable.png',manySeatsAvailable:'manyseatsavailable.png',fewSeatsAvailable:'fewseatsavailable.png',full:'full.png'};
var BusTimePredictionLegend = [
    {
        key:"",
        keyValue:"",
        text:"Not Crowded",
        backgroundColor:'',
        image:'images/bustime/' + OccupancyImages.manySeatsAvailable,
        help:'Not Crowded' 
    },
    {
        key:"",
        keyValue:"",
        text:"Some Crowding",
        backgroundColor:'',
        image:'images/bustime/' + OccupancyImages.fewSeatsAvailable,
        help:'Some Crowding'  
    },
    {
        key:"",
        keyValue:"",
        text:"Crowded",
        backgroundColor:'',
        image:'images/bustime/' + OccupancyImages.full,
        help:'Crowded'
    },    
    {
        key: "prdctdn",
        key2: "typ",
        keyValue: "Due",
        keyValue2: "A",
        text: "Arriving",
        backgroundColor: "#7CB0FF",
        image:'',
        help: 'or Due: A bus is approaching the selected stop in less than 2 minutes.'
    },    
    {
        key: "prdctdn",
        key2: "typ",
        keyValue: "Due",
        keyValue2: "D",
        text: "Departing",
        backgroundColor: "#7CB0FF",
        image:'',
        help: 'or Due: A bus is departing the selected stop in less than 2 minutes.'
    },    
    {
        key: "dyn",
        keyValue: "1",
        text: "Canceled",
        backgroundColor: "#F00",
        image:'',
        help: "or Cncl: This trip has been canceled. The prediction is no longer valid."
    },
    {
        key: "prdctdn",
        keyValue: "DLY",
        text: "Delayed",
        backgroundColor: "#FFEE82",
        image:'',
        help: "or Dlay: Something has happened which is delaying this vehicle and its predictions. A vehicle is categorized as “delayed” when it doesn't move for 10 minutes."
    },
    {
        key: "dyn",
        keyValue: "4",
        text: "Will Not Stop",
        backgroundColor: "#FF7B47",
        image:'',
        help: "or Skip: This vehicle will only stop at the selected stop to drop off passengers."
    },

    {
        key: "dyn",
        keyValue: "3",
        text: "Changed",
        backgroundColor: "#FF60D2",
        image:'',
        help: "Changed: Trip has been changed. The prediction is not valid anymore."
    }
];
var sanitizeHTML = function (str) {
	var temp = document.createElement('div');
	temp.textContent = str;
	return temp.innerHTML;
};

function getRemainingTime (item) {      
    if (item == null || typeof item.prdctdn === "undefined" || item.prdctdn == null)
        return "";
    if (BusTimePredictionLegend == null || typeof BusTimePredictionLegend === "undefined")
        return item.prdctdn;

        
    for (var i = 0; i < BusTimePredictionLegend.length; i++) {
        var obj = BusTimePredictionLegend[i];
        
        if (typeof item[obj.key2] !== "undefined" && item[obj.key2] != null && typeof item[obj.key] !== "undefined" && item[obj.key] != null) {
            if (obj.keyValue != null && item[obj.key].toString().toLowerCase() == obj.keyValue.toString().toLowerCase() &&
                obj.keyValue2 != null && item[obj.key2].toString().toLowerCase() == obj.keyValue2.toString().toLowerCase()
            ){
                return obj.text;                
            }
        }
        else if (typeof item[obj.key] !== "undefined" && item[obj.key] != null) {
            if (obj.keyValue != null && item[obj.key].toString().toLowerCase() == obj.keyValue.toString().toLowerCase())
                return obj.text;            
        }
    }
    
    return item.prdctdn + " min";
}
function getRemainingTimeColor (item) {
    if (item == null || typeof item.prdctdn === "undefined" || item.prdctdn == null)
        return "";
    if (BusTimePredictionLegend == null || typeof BusTimePredictionLegend === "undefined")
        return item.prdctdn;

    for (var i = 0; i < BusTimePredictionLegend.length; i++) {
        var obj = BusTimePredictionLegend[i];
        if (typeof item[obj.key2] !== "undefined" && item[obj.key2] != null && typeof item[obj.key] !== "undefined" && item[obj.key] != null) {
            if (item[obj.key] == obj.keyValue && item[obj.key2] == obj.keyValue2)
                return obj.backgroundColor;
        }
        else if (typeof item[obj.key] !== "undefined" && item[obj.key] != null) {
            if (item[obj.key] == obj.keyValue)
                return obj.backgroundColor;
        }
    }

    return "default";
}

function dateDaysDiff(date1, date2) {
    var dt1 = new Date(date1);
    var dt2 = new Date(date2);
    return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
}

function checkReloadSite() {
    window.setInterval(function () {
        var date = new Date();
        var currentDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
        if (window.localStorage.getItem('lastSiteReload')) {
            var lastDate = window.localStorage.getItem('lastSiteReload');
            var daysDiff = Math.abs(dateDaysDiff(currentDate, lastDate));
            console.log("LastSiteReload @ " + lastDate + ", days since: " + daysDiff);
            if (daysDiff > 7) {
                window.localStorage.setItem('lastSiteReload', currentDate);
                window.location.reload(true);
            }
        } else {
            window.localStorage.setItem('lastSiteReload', currentDate);
        }
    }, 60 * 1000);
}

checkReloadSite();

var offline=false;
window.addEventListener('online', function(){offline=false;});
window.addEventListener('offline',function(){offline=true;});
setInterval(function(){
    if (offline) 
        $(".offline").show();
    else 
    $(".offline").hide();
}, 2000);

function getError(obj){
    if (obj==null)
        return "";
    if (typeof obj==='string') return obj;
    if (typeof obj.msg!=='undefined')
        return obj.msg;
    if (typeof obj.err!=='undefined')
        return obj.err;
    console.log("Could not get the error message from the error object!");
    console.error(obj);
    return '';
}


var HOME = { lat: 37.8054133, lng: -122.2707171, zoom: 18, API_KEY: 'AIzaSyBMZ5FTf5NglxeU8I9OcunMkPmBqW3uO7o' }; // AC Transit General Office

var errorMessage = "No data to display";
var mapsVersion = 27;
var homeUrl = window.location.href;
jQuery.support.cors = true;
window.setTimeout(function () {
    $.ajax({
        type: "GET",
        url: service + 'lines/settings',
        async: false,
        data: null,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        tryCount: 0,
        retryLimit: 3,
        success: function (result) {
            mainDomain = result.MainSiteUrl;
            mapsVersion = Math.max(mapsVersion, result.Version);
        },
        error: function (xhr, textStatus, errorThrown) {
            this.tryCount++;
            if (this.tryCount <= this.retryLimit) {
                $.ajax(this); //try again
                return;
            }
        }
    });
}, 1);


var bookMarksKey="bookmarks";
function addToBookMarks(url){
    if (typeof (Storage) !== "undefined") {
        var bookMarks=getBookMarks();
        for(var i=0;i<bookMarks.length;i++){
            if (bookMarks[i]==url) return;
        }
        if (bookMarks.length>=10){
            alert("You cann't have more than 10 favorites.")
            return;
        }
            
        bookMarks.push(url);
        localStorage.setItem(bookMarksKey, JSON.stringify(bookMarks));
    };
}
function removeBookMark(url){
    if (typeof (Storage) !== "undefined") {
        var bookMarks=getBookMarks();
        var changed=false;
        for(var i=0;i<bookMarks.length;i++){
            if (bookMarks[i]==url) {
                bookMarks.splice(i,1);
                changed=true;
                break;
            }
        }
        if (changed)
            localStorage.setItem(bookMarksKey, JSON.stringify(bookMarks));
    };
}

function isBookMarked(url){
    if (typeof (Storage) !== "undefined") {
        var bookMarks=getBookMarks();
        for(var i=0;i<bookMarks.length;i++){
            if (bookMarks[i]==url) return true;
        }
    };
    return false;
}
function getBookMarks(){
    if (typeof (Storage) !== "undefined") {
        var bookMarksStr=localStorage.getItem(bookMarksKey);
        if (typeof bookMarksStr!=='undefined' && bookMarksKey!='')
            return JSON.parse(bookMarksStr) || [];
    };
    return [];
}
function onTitleClicked (e){
    if (AcTransitMobi.app.currentViewModel && AcTransitMobi.app.currentViewModel.onTitleClicked);
        AcTransitMobi.app.currentViewModel.onTitleClicked(e);
}
function getNumberOutOfString(str) {
    //if (isNaN(str) && str.length==1) return ["",str];
    if (isNaN(str) && str.length == 1) return [str, ""];
    if (!isNaN(str)) return [str, ""];

    var index = -1;
    for (var i = 0; i < str.length; i++) {
        if (isNaN(str[i])) {
            index = i;
            break;
        }
    }
    if (index == 0)
        return [str, ""];
    return [str.substring(0, index), str.substring(index, str.length)];
}
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.replace(new RegExp(search, 'g'), replacement);
    };
}
//if (!String.prototype.groupBy) {
//    String.prototype.groupBy = function (search, replacement) {
//        var target = this;
//        return target.replace(new RegExp(search, 'g'), replacement);
//    };
//}
if (!Array.prototype.routeSort) {
    Object.defineProperty(Array.prototype, 'routeSort', {
        value: function (column) {
            column = column || 'rt';
            this.sort(function (route1, route2) {
                var result;
                var a = route1[column];
                var b = route2[column];
                //var a = route1.rt;
                //var b = route2.rt;

                if (isNaN(a) && isNaN(b)) {
                    if (a === b)
                        reesult = 0;
                    else if (typeof a === typeof b)
                        result = a < b ? -1 : 1;
                    else
                        result = typeof a < typeof b ? -1 : 1;
                }
                else if (isNaN(a) || isNaN(b)) {
                    var aS = getNumberOutOfString(a);
                    var bS = getNumberOutOfString(b);
                    //console.log("the Route: " + a + ", [0]:" + aS[0] + ", [1]:" + aS[1]);
                    var a0 = aS[0];
                    var b0 = bS[0];
                    var a1 = aS[1];
                    var b1 = bS[1];

                    if (a0 === b0) {
                        if (a1 === b1)
                            result = 0;
                        else if (typeof a1 === typeof b1)
                            result = a1 < b1 ? -1 : 1;
                        else
                            result = typeof a1 < typeof b1 ? -1 : 1;
                    }
                    else if (typeof a0 === typeof b0) {
                        if (!isNaN(a0) && !isNaN(b0)) {
                            a0 = parseInt(a0, 10);
                            b0 = parseInt(b0, 10);
                        }
                        result = a0 < b0 ? -1 : 1;
                    }
                    else
                        result = typeof a0 < typeof b0 ? -1 : 1;
                }
                else {
                    a = parseInt(a, 10);
                    b = parseInt(b, 10);
                    if (a === b)
                        result = 0;
                    else if (typeof a === typeof b)
                        result = a < b ? -1 : 1;
                    else
                        result = typeof a < typeof b ? -1 : 1;
                }
                //console.log("route1:" + a + ", route2:" + b + ", result:" + result);
                return result;
            });
            return this;
        }
    });
}
if (!Array.prototype.distinctBy) {
    Array.prototype.distinctBy = function (columns) {
        columns = columns || [];
        var grouped = {};
        var res = [];
        var i, j;
        for (i = 0; i < this.length; i++) {
            var distinctColName = "";
            for (j = 0; j < columns.length; j++) {
                var colName = columns[j];
                var colValue = this[i][colName] || "";
                colValue = colValue.replace(/:/, "_:_");
                if (distinctColName !== '') distinctColName += ":";
                distinctColName += colValue;
            }
            if (typeof grouped[distinctColName] === 'undefined' || grouped[distinctColName] == null)
                grouped[distinctColName] = this[i] ;            
        }
        for (var key in grouped) {
            if (grouped.hasOwnProperty(key)) {
                res.push(grouped[key]);
            }
        }
        return res;
    }
}

//this function is created solely per Aaron request to filter our more than one stop per route and direction in the nearby page.
if (!Array.prototype.distinctByForGroupBy) {
    Array.prototype.distinctByForGroupBy = function (groupedByColumnArray /*usually something like items*/,columns) {
        columns = columns || [];
        var grouped= {};
        var i, j, k;

        for (i = 0; i < this.length; i++) {
            var newItems = [];
            var items = this[i][groupedByColumnArray];
            //console.log(items);
            for (j = 0; j < items.length; j++) {
                var distinctColName = "";
                for (k = 0; k < columns.length; k++) {
                    var colName = columns[k];
                    var colValue = items[j][colName] || "";
                    colValue = colValue.replace(/:/, "_:_");
                    if (distinctColName !== '') distinctColName += ":";
                    distinctColName += colValue;
                }                                
                if (typeof grouped[distinctColName] === 'undefined' || grouped[distinctColName] == null) {
                    grouped[distinctColName] =  this[i].stpid;//this[i].key;
                    newItems.push(items[j]);
                } else if (grouped[distinctColName] == this[i].stpid /*this[i].key*/) {
                    newItems.push(items[j]);
                }
                    
            }
            this[i][groupedByColumnArray] = newItems;            
        }        
    }
}

if (!Array.prototype.groupBy) {
    Array.prototype.groupBy = function (column, additionalColumn) {
        additionalColumn = additionalColumn || null;
        var grouped = {};
        var res = [];
        for (var i = 0; i < this.length; i++) {
            var colValue = this[i][column];
            if (typeof grouped[colValue] === 'undefined' || grouped[colValue] == null)
                grouped[colValue] = [];
            grouped[colValue].push(this[i]);
        }
        for (var key in grouped) {
            if (grouped.hasOwnProperty(key)) {
                var items=grouped[key];
                //var obj = {
                //    key: key,
                //    items: grouped[key]
                //};
                if (additionalColumn != null && items != null && items.length > 0) {
                    var grouped2 = items.groupBy(additionalColumn);
                    for (var key2 in grouped2) {                        
                        if (grouped2.hasOwnProperty(key2)) {
                            var o = grouped2[key2];
                            var obj= {
                                key: key,
                                key2: o.key,
                                items: o.items
                            }
                            obj[column] = key;
                            obj[additionalColumn] = o.key;
                            res.push(obj);
                        }
                    }                    
                }
                else if (additionalColumn != null) {
                    var obj = {
                        key: key,
                        key2: "",
                        items: grouped[key]
                    }
                    obj[column] = key;
                    obj[additionalColumn] = null;
                    res.push(obj);
                }
                else {
                    var obj = {
                        key: key,
                        key2: "",
                        items: grouped[key]
                    }
                    obj[column] = key;
                    res.push(obj);
                }
                
            }
        }
        //console.log(res);

        //console.log("group by " + column);
        //console.log(res);
        return res;
    }
}
if (!Array.prototype.filter){
    Array.prototype.filter = function(func, thisArg) {
      'use strict';
      if ( ! ((typeof func === 'Function' || typeof func === 'function') && this) )
          throw new TypeError();
     
      var len = this.length >>> 0,
          res = new Array(len), // preallocate array
          t = this, c = 0, i = -1;
      if (thisArg === undefined){
        while (++i !== len){
          // checks to see if the key was set
          if (i in this){
            if (func(t[i], i, t)){
              res[c++] = t[i];
            }
          }
        }
      }
      else{
        while (++i !== len){
          // checks to see if the key was set
          if (i in this){
            if (func.call(thisArg, t[i], i, t)){
              res[c++] = t[i];
            }
          }
        }
      }
     
      res.length = c; // shrink down array to proper size
      return res;
    };
  }
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(callback /*, thisArg*/ ) {
        var T, k;
        if (this == null) {
            throw new TypeError('this is null or not defined');
        }
        // 1. Let O be the result of calling toObject() passing the
        // |this| value as the argument.
        var O = Object(this);
        // 2. Let lenValue be the result of calling the Get() internal
        // method of O with the argument "length".
        // 3. Let len be toUint32(lenValue).
        var len = O.length >>> 0;
        // 4. If isCallable(callback) is false, throw a TypeError exception. 
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }
        // 5. If thisArg was supplied, let T be thisArg; else let
        // T be undefined.
        if (arguments.length > 1) {
            T = arguments[1];
        }
        // 6. Let k be 0.
        k = 0;
        // 7. Repeat while k < len.
        while (k < len) {
            var kValue;
            // a. Let Pk be ToString(k).
            //    This is implicit for LHS operands of the in operator.
            // b. Let kPresent be the result of calling the HasProperty
            //    internal method of O with argument Pk.
            //    This step can be combined with c.
            // c. If kPresent is true, then
            if (k in O) {
                // i. Let kValue be the result of calling the Get internal
                // method of O with argument Pk.
                kValue = O[k];
                // ii. Call the Call internal method of callback with T as
                // the this value and argument list containing kValue, k, and O.
                callback.call(T, kValue, k, O);
            }
            // d. Increase k by 1.
            k++;
        }
        // 8. return undefined.
    };
}

/*=============================================================================
	Author:			Eric M. Barnard - @ericmbarnard								
	License:		MIT (http://opensource.org/licenses/mit-license.php)		
																				
	Description:	Validation Library for KnockoutJS							
	Version:		2.0.3											
===============================================================================
*/
/*globals require: false, exports: false, define: false, ko: false */

(function (factory) {
    // Module systems magic dance.

    if (typeof require === "function" && typeof exports === "object" && typeof module === "object") {
        // CommonJS or Node: hard-coded dependency on "knockout"
        factory(require("knockout"), exports);
    } else if (typeof define === "function" && define["amd"]) {
        // AMD anonymous module with hard-coded dependency on "knockout"
        define(["knockout", "exports"], factory);
    } else {
        // <script> tag: use the global `ko` object, attaching a `mapping` property
        factory(ko, ko.validation = {});
    }
}(function (ko, exports) {

    if (typeof (ko) === 'undefined') {
        throw new Error('Knockout is required, please ensure it is loaded before loading this validation plug-in');
    }

    // create our namespace object
    ko.validation = exports;

    var kv = ko.validation,
		koUtils = ko.utils,
		unwrap = koUtils.unwrapObservable,
		forEach = koUtils.arrayForEach,
		extend = koUtils.extend;
    ;/*global ko: false*/

    var defaults = {
        registerExtenders: true,
        messagesOnModified: true,
        errorsAsTitle: true,            // enables/disables showing of errors as title attribute of the target element.
        errorsAsTitleOnModified: false, // shows the error when hovering the input field (decorateElement must be true)
        messageTemplate: null,
        insertMessages: true,           // automatically inserts validation messages as <span></span>
        parseInputAttributes: false,    // parses the HTML5 validation attribute from a form element and adds that to the object
        writeInputAttributes: false,    // adds HTML5 input validation attributes to form elements that ko observable's are bound to
        decorateInputElement: false,         // false to keep backward compatibility
        decorateElementOnModified: true,// true to keep backward compatibility
        errorClass: null,               // single class for error message and element
        errorElementClass: 'validationElement',  // class to decorate error element
        errorMessageClass: 'validationMessage',  // class to decorate error message
        allowHtmlMessages: false,		// allows HTML in validation messages
        grouping: {
            deep: false,        //by default grouping is shallow
            observable: true,   //and using observables
            live: false		    //react to changes to observableArrays if observable === true
        },
        validate: {
            // throttle: 10
        }
    };

    // make a copy  so we can use 'reset' later
    var configuration = extend({}, defaults);

    configuration.html5Attributes = ['required', 'pattern', 'min', 'max', 'step'];
    configuration.html5InputTypes = ['email', 'number', 'date'];

    configuration.reset = function () {
        extend(configuration, defaults);
    };

    kv.configuration = configuration;
    ; kv.utils = (function () {
        var seedId = new Date().getTime();

        var domData = {}; //hash of data objects that we reference from dom elements
        var domDataKey = '__ko_validation__';

        return {
            isArray: function (o) {
                return o.isArray || Object.prototype.toString.call(o) === '[object Array]';
            },
            isObject: function (o) {
                return o !== null && typeof o === 'object';
            },
            isNumber: function (o) {
                return !isNaN(o);
            },
            isObservableArray: function (instance) {
                return !!instance &&
                        typeof instance["remove"] === "function" &&
                        typeof instance["removeAll"] === "function" &&
                        typeof instance["destroy"] === "function" &&
                        typeof instance["destroyAll"] === "function" &&
                        typeof instance["indexOf"] === "function" &&
                        typeof instance["replace"] === "function";
            },
            values: function (o) {
                var r = [];
                for (var i in o) {
                    if (o.hasOwnProperty(i)) {
                        r.push(o[i]);
                    }
                }
                return r;
            },
            getValue: function (o) {
                return (typeof o === 'function' ? o() : o);
            },
            hasAttribute: function (node, attr) {
                return node.getAttribute(attr) !== null;
            },
            getAttribute: function (element, attr) {
                return element.getAttribute(attr);
            },
            setAttribute: function (element, attr, value) {
                return element.setAttribute(attr, value);
            },
            isValidatable: function (o) {
                return !!(o && o.rules && o.isValid && o.isModified);
            },
            insertAfter: function (node, newNode) {
                node.parentNode.insertBefore(newNode, node.nextSibling);
            },
            newId: function () {
                return seedId += 1;
            },
            getConfigOptions: function (element) {
                var options = kv.utils.contextFor(element);

                return options || kv.configuration;
            },
            setDomData: function (node, data) {
                var key = node[domDataKey];

                if (!key) {
                    node[domDataKey] = key = kv.utils.newId();
                }

                domData[key] = data;
            },
            getDomData: function (node) {
                var key = node[domDataKey];

                if (!key) {
                    return undefined;
                }

                return domData[key];
            },
            contextFor: function (node) {
                switch (node.nodeType) {
                    case 1:
                    case 8:
                        var context = kv.utils.getDomData(node);
                        if (context) { return context; }
                        if (node.parentNode) { return kv.utils.contextFor(node.parentNode); }
                        break;
                }
                return undefined;
            },
            isEmptyVal: function (val) {
                if (val === undefined) {
                    return true;
                }
                if (val === null) {
                    return true;
                }
                if (val === "") {
                    return true;
                }
            },
            getOriginalElementTitle: function (element) {
                var savedOriginalTitle = kv.utils.getAttribute(element, 'data-orig-title'),
                    currentTitle = element.title,
                    hasSavedOriginalTitle = kv.utils.hasAttribute(element, 'data-orig-title');

                return hasSavedOriginalTitle ?
                    savedOriginalTitle : currentTitle;
            },
            async: function (expr) {
                if (window.setImmediate) { window.setImmediate(expr); }
                else { window.setTimeout(expr, 0); }
            },
            forEach: function (object, callback) {
                if (kv.utils.isArray(object)) {
                    return forEach(object, callback);
                }
                for (var prop in object) {
                    if (object.hasOwnProperty(prop)) {
                        callback(object[prop], prop);
                    }
                }
            }
        };
    }());; var api = (function () {

        var isInitialized = 0,
            configuration = kv.configuration,
            utils = kv.utils;

        function cleanUpSubscriptions(context) {
            forEach(context.subscriptions, function (subscription) {
                subscription.dispose();
            });
            context.subscriptions = [];
        }

        function dispose(context) {
            if (context.options.deep) {
                forEach(context.flagged, function (obj) {
                    delete obj.__kv_traversed;
                });
                context.flagged.length = 0;
            }

            if (!context.options.live) {
                cleanUpSubscriptions(context);
            }
        }

        function runTraversal(obj, context) {
            context.validatables = [];
            cleanUpSubscriptions(context);
            traverseGraph(obj, context);
            dispose(context);
        }

        function traverseGraph(obj, context, level) {
            var objValues = [],
                val = obj.peek ? obj.peek() : obj;

            if (obj.__kv_traversed === true) {
                return;
            }

            if (context.options.deep) {
                obj.__kv_traversed = true;
                context.flagged.push(obj);
            }

            //default level value depends on deep option.
            level = (level !== undefined ? level : context.options.deep ? 1 : -1);

            // if object is observable then add it to the list
            if (ko.isObservable(obj)) {
                // ensure it's validatable but don't extend validatedObservable because it
                // would overwrite isValid property.
                if (!obj.errors && !utils.isValidatable(obj)) {
                    obj.extend({ validatable: true });
                }
                context.validatables.push(obj);

                if (context.options.live && utils.isObservableArray(obj)) {
                    context.subscriptions.push(obj.subscribe(function () {
                        context.graphMonitor.valueHasMutated();
                    }));
                }
            }

            //get list of values either from array or object but ignore non-objects
            // and destroyed objects
            if (val && !val._destroy) {
                if (utils.isArray(val)) {
                    objValues = val;
                }
                else if (utils.isObject(val)) {
                    objValues = utils.values(val);
                }
            }

            //process recursively if it is deep grouping
            if (level !== 0) {
                utils.forEach(objValues, function (observable) {
                    //but not falsy things and not HTML Elements
                    if (observable && !observable.nodeType && (!ko.isComputed(observable) || observable.rules)) {
                        traverseGraph(observable, context, level + 1);
                    }
                });
            }
        }

        function collectErrors(array) {
            var errors = [];
            forEach(array, function (observable) {
                // Do not collect validatedObservable errors
                if (utils.isValidatable(observable) && !observable.isValid()) {
                    // Use peek because we don't want a dependency for 'error' property because it
                    // changes before 'isValid' does. (Issue #99)
                    errors.push(observable.error.peek());
                }
            });
            return errors;
        }

        return {
            //Call this on startup
            //any config can be overridden with the passed in options
            init: function (options, force) {
                //done run this multiple times if we don't really want to
                if (isInitialized > 0 && !force) {
                    return;
                }

                //because we will be accessing options properties it has to be an object at least
                options = options || {};
                //if specific error classes are not provided then apply generic errorClass
                //it has to be done on option so that options.errorClass can override default
                //errorElementClass and errorMessage class but not those provided in options
                options.errorElementClass = options.errorElementClass || options.errorClass || configuration.errorElementClass;
                options.errorMessageClass = options.errorMessageClass || options.errorClass || configuration.errorMessageClass;

                extend(configuration, options);

                if (configuration.registerExtenders) {
                    kv.registerExtenders();
                }

                isInitialized = 1;
            },

            // resets the config back to its original state
            reset: kv.configuration.reset,

            // recursively walks a viewModel and creates an object that
            // provides validation information for the entire viewModel
            // obj -> the viewModel to walk
            // options -> {
            //	  deep: false, // if true, will walk past the first level of viewModel properties
            //	  observable: false // if true, returns a computed observable indicating if the viewModel is valid
            // }
            group: function group(obj, options) { // array of observables or viewModel
                options = extend(extend({}, configuration.grouping), options);

                var context = {
                    options: options,
                    graphMonitor: ko.observable(),
                    flagged: [],
                    subscriptions: [],
                    validatables: []
                };

                var result = null;

                //if using observables then traverse structure once and add observables
                if (options.observable) {
                    result = ko.computed(function () {
                        context.graphMonitor(); //register dependency
                        runTraversal(obj, context);
                        return collectErrors(context.validatables);
                    });
                }
                else { //if not using observables then every call to error() should traverse the structure
                    result = function () {
                        runTraversal(obj, context);
                        return collectErrors(context.validatables);
                    };
                }

                result.showAllMessages = function (show) { // thanks @heliosPortal
                    if (show === undefined) {//default to true
                        show = true;
                    }

                    result.forEach(function (observable) {
                        if (utils.isValidatable(observable)) {
                            observable.isModified(show);
                        }
                    });
                };

                result.isAnyMessageShown = function () {
                    var invalidAndModifiedPresent;

                    invalidAndModifiedPresent = !!result.find(function (observable) {
                        return utils.isValidatable(observable) && !observable.isValid() && observable.isModified();
                    });
                    return invalidAndModifiedPresent;
                };

                result.filter = function (predicate) {
                    predicate = predicate || function () { return true; };
                    // ensure we have latest changes
                    result();

                    return koUtils.arrayFilter(context.validatables, predicate);
                };

                result.find = function (predicate) {
                    predicate = predicate || function () { return true; };
                    // ensure we have latest changes
                    result();

                    return koUtils.arrayFirst(context.validatables, predicate);
                };

                result.forEach = function (callback) {
                    callback = callback || function () { };
                    // ensure we have latest changes
                    result();

                    forEach(context.validatables, callback);
                };

                result.map = function (mapping) {
                    mapping = mapping || function (item) { return item; };
                    // ensure we have latest changes
                    result();

                    return koUtils.arrayMap(context.validatables, mapping);
                };

                /**
                 * @private You should not rely on this method being here.
                 * It's a private method and it may change in the future.
                 *
                 * @description Updates the validated object and collects errors from it.
                 */
                result._updateState = function (newValue) {
                    if (!utils.isObject(newValue)) {
                        throw new Error('An object is required.');
                    }
                    obj = newValue;
                    if (options.observable) {
                        context.graphMonitor.valueHasMutated();
                    }
                    else {
                        runTraversal(newValue, context);
                        return collectErrors(context.validatables);
                    }
                };
                return result;
            },

            formatMessage: function (message, params, observable) {
                if (utils.isObject(params) && params.typeAttr) {
                    params = params.value;
                }
                if (typeof message === 'function') {
                    return message(params, observable);
                }
                var replacements = unwrap(params);
                if (replacements == null) {
                    replacements = [];
                }
                if (!utils.isArray(replacements)) {
                    replacements = [replacements];
                }
                return message.replace(/{(\d+)}/gi, function (match, index) {
                    if (typeof replacements[index] !== 'undefined') {
                        return replacements[index];
                    }
                    return match;
                });
            },

            // addRule:
            // This takes in a ko.observable and a Rule Context - which is just a rule name and params to supply to the validator
            // ie: kv.addRule(myObservable, {
            //		  rule: 'required',
            //		  params: true
            //	  });
            //
            addRule: function (observable, rule) {
                observable.extend({ validatable: true });

                var hasRule = !!koUtils.arrayFirst(observable.rules(), function (item) {
                    return item.rule && item.rule === rule.rule;
                });

                if (!hasRule) {
                    //push a Rule Context to the observables local array of Rule Contexts
                    observable.rules.push(rule);
                }
                return observable;
            },

            // addAnonymousRule:
            // Anonymous Rules essentially have all the properties of a Rule, but are only specific for a certain property
            // and developers typically are wanting to add them on the fly or not register a rule with the 'kv.rules' object
            //
            // Example:
            // var test = ko.observable('something').extend{(
            //	  validation: {
            //		  validator: function(val, someOtherVal){
            //			  return true;
            //		  },
            //		  message: "Something must be really wrong!',
            //		  params: true
            //	  }
            //  )};
            addAnonymousRule: function (observable, ruleObj) {
                if (ruleObj['message'] === undefined) {
                    ruleObj['message'] = 'Error';
                }

                //make sure onlyIf is honoured
                if (ruleObj.onlyIf) {
                    ruleObj.condition = ruleObj.onlyIf;
                }

                //add the anonymous rule to the observable
                kv.addRule(observable, ruleObj);
            },

            addExtender: function (ruleName) {
                ko.extenders[ruleName] = function (observable, params) {
                    //params can come in a few flavors
                    // 1. Just the params to be passed to the validator
                    // 2. An object containing the Message to be used and the Params to pass to the validator
                    // 3. A condition when the validation rule to be applied
                    //
                    // Example:
                    // var test = ko.observable(3).extend({
                    //	  max: {
                    //		  message: 'This special field has a Max of {0}',
                    //		  params: 2,
                    //		  onlyIf: function() {
                    //					  return specialField.IsVisible();
                    //				  }
                    //	  }
                    //  )};
                    //
                    if (params && (params.message || params.onlyIf)) { //if it has a message or condition object, then its an object literal to use
                        return kv.addRule(observable, {
                            rule: ruleName,
                            message: params.message,
                            params: utils.isEmptyVal(params.params) ? true : params.params,
                            condition: params.onlyIf
                        });
                    } else {
                        return kv.addRule(observable, {
                            rule: ruleName,
                            params: params
                        });
                    }
                };
            },

            // loops through all kv.rules and adds them as extenders to
            // ko.extenders
            registerExtenders: function () { // root extenders optional, use 'validation' extender if would cause conflicts
                if (configuration.registerExtenders) {
                    for (var ruleName in kv.rules) {
                        if (kv.rules.hasOwnProperty(ruleName)) {
                            if (!ko.extenders[ruleName]) {
                                kv.addExtender(ruleName);
                            }
                        }
                    }
                }
            },

            //creates a span next to the @element with the specified error class
            insertValidationMessage: function (element) {
                var span = document.createElement('SPAN');
                span.className = utils.getConfigOptions(element).errorMessageClass;
                utils.insertAfter(element, span);
                return span;
            },

            // if html-5 validation attributes have been specified, this parses
            // the attributes on @element
            parseInputValidationAttributes: function (element, valueAccessor) {
                forEach(kv.configuration.html5Attributes, function (attr) {
                    if (utils.hasAttribute(element, attr)) {

                        var params = element.getAttribute(attr) || true;

                        if (attr === 'min' || attr === 'max') {
                            // If we're validating based on the min and max attributes, we'll
                            // need to know what the 'type' attribute is set to
                            var typeAttr = element.getAttribute('type');
                            if (typeof typeAttr === "undefined" || !typeAttr) {
                                // From http://www.w3.org/TR/html-markup/input:
                                //   An input element with no type attribute specified represents the
                                //   same thing as an input element with its type attribute set to "text".
                                typeAttr = "text";
                            }
                            params = { typeAttr: typeAttr, value: params };
                        }

                        kv.addRule(valueAccessor(), {
                            rule: attr,
                            params: params
                        });
                    }
                });

                var currentType = element.getAttribute('type');
                forEach(kv.configuration.html5InputTypes, function (type) {
                    if (type === currentType) {
                        kv.addRule(valueAccessor(), {
                            rule: (type === 'date') ? 'dateISO' : type,
                            params: true
                        });
                    }
                });
            },

            // writes html5 validation attributes on the element passed in
            writeInputValidationAttributes: function (element, valueAccessor) {
                var observable = valueAccessor();

                if (!observable || !observable.rules) {
                    return;
                }

                var contexts = observable.rules(); // observable array

                // loop through the attributes and add the information needed
                forEach(kv.configuration.html5Attributes, function (attr) {
                    var ctx = koUtils.arrayFirst(contexts, function (ctx) {
                        return ctx.rule && ctx.rule.toLowerCase() === attr.toLowerCase();
                    });

                    if (!ctx) {
                        return;
                    }

                    // we have a rule matching a validation attribute at this point
                    // so lets add it to the element along with the params
                    ko.computed({
                        read: function () {
                            var params = ko.unwrap(ctx.params);

                            // we have to do some special things for the pattern validation
                            if (ctx.rule === "pattern" && params instanceof RegExp) {
                                // we need the pure string representation of the RegExpr without the //gi stuff
                                params = params.source;
                            }

                            element.setAttribute(attr, params);
                        },
                        disposeWhenNodeIsRemoved: element
                    });
                });

                contexts = null;
            },

            //take an existing binding handler and make it cause automatic validations
            makeBindingHandlerValidatable: function (handlerName) {
                var init = ko.bindingHandlers[handlerName].init;

                ko.bindingHandlers[handlerName].init = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

                    init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

                    return ko.bindingHandlers['validationCore'].init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
                };
            },

            // visit an objects properties and apply validation rules from a definition
            setRules: function (target, definition) {
                var setRules = function (target, definition) {
                    if (!target || !definition) { return; }

                    for (var prop in definition) {
                        if (!definition.hasOwnProperty(prop)) { continue; }
                        var ruleDefinitions = definition[prop];

                        //check the target property exists and has a value
                        if (!target[prop]) { continue; }
                        var targetValue = target[prop],
                            unwrappedTargetValue = unwrap(targetValue),
                            rules = {},
                            nonRules = {};

                        for (var rule in ruleDefinitions) {
                            if (!ruleDefinitions.hasOwnProperty(rule)) { continue; }
                            if (kv.rules[rule]) {
                                rules[rule] = ruleDefinitions[rule];
                            } else {
                                nonRules[rule] = ruleDefinitions[rule];
                            }
                        }

                        //apply rules
                        if (ko.isObservable(targetValue)) {
                            targetValue.extend(rules);
                        }

                        //then apply child rules
                        //if it's an array, apply rules to all children
                        if (unwrappedTargetValue && utils.isArray(unwrappedTargetValue)) {
                            for (var i = 0; i < unwrappedTargetValue.length; i++) {
                                setRules(unwrappedTargetValue[i], nonRules);
                            }
                            //otherwise, just apply to this property
                        } else {
                            setRules(unwrappedTargetValue, nonRules);
                        }
                    }
                };
                setRules(target, definition);
            }
        };

    }());

    // expose api publicly
    extend(ko.validation, api);
    ;//Validation Rules:
    // You can view and override messages or rules via:
    // kv.rules[ruleName]
    //
    // To implement a custom Rule, simply use this template:
    // kv.rules['<custom rule name>'] = {
    //      validator: function (val, param) {
    //          <custom logic>
    //          return <true or false>;
    //      },
    //      message: '<custom validation message>' //optionally you can also use a '{0}' to denote a placeholder that will be replaced with your 'param'
    // };
    //
    // Example:
    // kv.rules['mustEqual'] = {
    //      validator: function( val, mustEqualVal ){
    //          return val === mustEqualVal;
    //      },
    //      message: 'This field must equal {0}'
    // };
    //
    kv.rules = {};
    kv.rules['required'] = {
        validator: function (val, required) {
            var testVal;

            if (val === undefined || val === null) {
                return !required;
            }

            testVal = val;
            if (typeof (val) === 'string') {
                if (String.prototype.trim) {
                    testVal = val.trim();
                }
                else {
                    testVal = val.replace(/^\s+|\s+$/g, '');
                }
            }

            if (!required) {// if they passed: { required: false }, then don't require this
                return true;
            }

            return ((testVal + '').length > 0);
        },
        message: 'This field is required.'
    };

    function minMaxValidatorFactory(validatorName) {
        var isMaxValidation = validatorName === "max";

        return function (val, options) {
            if (kv.utils.isEmptyVal(val)) {
                return true;
            }

            var comparisonValue, type;
            if (options.typeAttr === undefined) {
                // This validator is being called from javascript rather than
                // being bound from markup
                type = "text";
                comparisonValue = options;
            } else {
                type = options.typeAttr;
                comparisonValue = options.value;
            }

            // From http://www.w3.org/TR/2012/WD-html5-20121025/common-input-element-attributes.html#attr-input-min,
            // if the value is parseable to a number, then the minimum should be numeric
            if (!isNaN(comparisonValue) && !(comparisonValue instanceof Date)) {
                type = "number";
            }

            var regex, valMatches, comparisonValueMatches;
            switch (type.toLowerCase()) {
                case "week":
                    regex = /^(\d{4})-W(\d{2})$/;
                    valMatches = val.match(regex);
                    if (valMatches === null) {
                        throw new Error("Invalid value for " + validatorName + " attribute for week input.  Should look like " +
                            "'2000-W33' http://www.w3.org/TR/html-markup/input.week.html#input.week.attrs.min");
                    }
                    comparisonValueMatches = comparisonValue.match(regex);
                    // If no regex matches were found, validation fails
                    if (!comparisonValueMatches) {
                        return false;
                    }

                    if (isMaxValidation) {
                        return (valMatches[1] < comparisonValueMatches[1]) || // older year
                            // same year, older week
                            ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] <= comparisonValueMatches[2]));
                    } else {
                        return (valMatches[1] > comparisonValueMatches[1]) || // newer year
                            // same year, newer week
                            ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] >= comparisonValueMatches[2]));
                    }
                    break;

                case "month":
                    regex = /^(\d{4})-(\d{2})$/;
                    valMatches = val.match(regex);
                    if (valMatches === null) {
                        throw new Error("Invalid value for " + validatorName + " attribute for month input.  Should look like " +
                            "'2000-03' http://www.w3.org/TR/html-markup/input.month.html#input.month.attrs.min");
                    }
                    comparisonValueMatches = comparisonValue.match(regex);
                    // If no regex matches were found, validation fails
                    if (!comparisonValueMatches) {
                        return false;
                    }

                    if (isMaxValidation) {
                        return ((valMatches[1] < comparisonValueMatches[1]) || // older year
                            // same year, older month
                            ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] <= comparisonValueMatches[2])));
                    } else {
                        return (valMatches[1] > comparisonValueMatches[1]) || // newer year
                            // same year, newer month
                            ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] >= comparisonValueMatches[2]));
                    }
                    break;

                case "number":
                case "range":
                    if (isMaxValidation) {
                        return (!isNaN(val) && parseFloat(val) <= parseFloat(comparisonValue));
                    } else {
                        return (!isNaN(val) && parseFloat(val) >= parseFloat(comparisonValue));
                    }
                    break;

                default:
                    if (isMaxValidation) {
                        return val <= comparisonValue;
                    } else {
                        return val >= comparisonValue;
                    }
            }
        };
    }

    kv.rules['min'] = {
        validator: minMaxValidatorFactory("min"),
        message: 'Please enter a value greater than or equal to {0}.'
    };

    kv.rules['max'] = {
        validator: minMaxValidatorFactory("max"),
        message: 'Please enter a value less than or equal to {0}.'
    };

    kv.rules['minLength'] = {
        validator: function (val, minLength) {
            if (kv.utils.isEmptyVal(val)) { return true; }
            var normalizedVal = kv.utils.isNumber(val) ? ('' + val) : val;
            return normalizedVal.length >= minLength;
        },
        message: 'Please enter at least {0} characters.'
    };

    kv.rules['maxLength'] = {
        validator: function (val, maxLength) {
            if (kv.utils.isEmptyVal(val)) { return true; }
            var normalizedVal = kv.utils.isNumber(val) ? ('' + val) : val;
            return normalizedVal.length <= maxLength;
        },
        message: 'Please enter no more than {0} characters.'
    };

    kv.rules['pattern'] = {
        validator: function (val, regex) {
            return kv.utils.isEmptyVal(val) || val.toString().match(regex) !== null;
        },
        message: 'Please check this value.'
    };

    kv.rules['step'] = {
        validator: function (val, step) {

            // in order to handle steps of .1 & .01 etc.. Modulus won't work
            // if the value is a decimal, so we have to correct for that
            if (kv.utils.isEmptyVal(val) || step === 'any') { return true; }
            var dif = (val * 100) % (step * 100);
            return Math.abs(dif) < 0.00001 || Math.abs(1 - dif) < 0.00001;
        },
        message: 'The value must increment by {0}.'
    };

    kv.rules['email'] = {
        validator: function (val, validate) {
            if (!validate) { return true; }

            //I think an empty email address is also a valid entry
            //if one want's to enforce entry it should be done with 'required: true'
            return kv.utils.isEmptyVal(val) || (
                // jquery validate regex - thanks Scott Gonzalez
                validate && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(val)
            );
        },
        message: 'Please enter a proper email address.'
    };

    kv.rules['date'] = {
        validator: function (value, validate) {
            if (!validate) { return true; }
            return kv.utils.isEmptyVal(value) || (validate && !/Invalid|NaN/.test(new Date(value)));
        },
        message: 'Please enter a proper date.'
    };

    kv.rules['dateISO'] = {
        validator: function (value, validate) {
            if (!validate) { return true; }
            return kv.utils.isEmptyVal(value) || (validate && /^\d{4}[-/](?:0?[1-9]|1[012])[-/](?:0?[1-9]|[12][0-9]|3[01])$/.test(value));
        },
        message: 'Please enter a proper date.'
    };

    kv.rules['number'] = {
        validator: function (value, validate) {
            if (!validate) { return true; }
            return kv.utils.isEmptyVal(value) || (validate && /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value));
        },
        message: 'Please enter a number.'
    };

    kv.rules['digit'] = {
        validator: function (value, validate) {
            if (!validate) { return true; }
            return kv.utils.isEmptyVal(value) || (validate && /^\d+$/.test(value));
        },
        message: 'Please enter a digit.'
    };

    kv.rules['phoneUS'] = {
        validator: function (phoneNumber, validate) {
            if (!validate) { return true; }
            if (kv.utils.isEmptyVal(phoneNumber)) { return true; } // makes it optional, use 'required' rule if it should be required
            if (typeof (phoneNumber) !== 'string') { return false; }
            phoneNumber = phoneNumber.replace(/\s+/g, "");
            return validate && phoneNumber.length > 9 && phoneNumber.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
        },
        message: 'Please specify a valid phone number.'
    };

    kv.rules['equal'] = {
        validator: function (val, params) {
            var otherValue = params;
            return val === kv.utils.getValue(otherValue);
        },
        message: 'Values must equal.'
    };

    kv.rules['notEqual'] = {
        validator: function (val, params) {
            var otherValue = params;
            return val !== kv.utils.getValue(otherValue);
        },
        message: 'Please choose another value.'
    };

    //unique in collection
    // options are:
    //    collection: array or function returning (observable) array
    //              in which the value has to be unique
    //    valueAccessor: function that returns value from an object stored in collection
    //              if it is null the value is compared directly
    //    external: set to true when object you are validating is automatically updating collection
    kv.rules['unique'] = {
        validator: function (val, options) {
            var c = kv.utils.getValue(options.collection),
                external = kv.utils.getValue(options.externalValue),
                counter = 0;

            if (!val || !c) { return true; }

            koUtils.arrayFilter(c, function (item) {
                if (val === (options.valueAccessor ? options.valueAccessor(item) : item)) { counter++; }
            });
            // if value is external even 1 same value in collection means the value is not unique
            return counter < (!!external ? 1 : 2);
        },
        message: 'Please make sure the value is unique.'
    };


    //now register all of these!
    (function () {
        kv.registerExtenders();
    }());
    ;// The core binding handler
    // this allows us to setup any value binding that internally always
    // performs the same functionality
    ko.bindingHandlers['validationCore'] = (function () {

        return {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var config = kv.utils.getConfigOptions(element);
                var observable = valueAccessor();

                // parse html5 input validation attributes, optional feature
                if (config.parseInputAttributes) {
                    kv.utils.async(function () { kv.parseInputValidationAttributes(element, valueAccessor); });
                }

                // if requested insert message element and apply bindings
                if (config.insertMessages && kv.utils.isValidatable(observable)) {

                    // insert the <span></span>
                    var validationMessageElement = kv.insertValidationMessage(element);

                    // if we're told to use a template, make sure that gets rendered
                    if (config.messageTemplate) {
                        ko.renderTemplate(config.messageTemplate, { field: observable }, null, validationMessageElement, 'replaceNode');
                    } else {
                        ko.applyBindingsToNode(validationMessageElement, { validationMessage: observable });
                    }
                }

                // write the html5 attributes if indicated by the config
                if (config.writeInputAttributes && kv.utils.isValidatable(observable)) {

                    kv.writeInputValidationAttributes(element, valueAccessor);
                }

                // if requested, add binding to decorate element
                if (config.decorateInputElement && kv.utils.isValidatable(observable)) {
                    ko.applyBindingsToNode(element, { validationElement: observable });
                }
            }
        };

    }());

    // override for KO's default 'value', 'checked', 'textInput' and selectedOptions bindings
    kv.makeBindingHandlerValidatable("value");
    kv.makeBindingHandlerValidatable("checked");
    if (ko.bindingHandlers.textInput) {
        kv.makeBindingHandlerValidatable("textInput");
    }
    kv.makeBindingHandlerValidatable("selectedOptions");


    ko.bindingHandlers['validationMessage'] = { // individual error message, if modified or post binding
        update: function (element, valueAccessor) {
            var obsv = valueAccessor(),
                config = kv.utils.getConfigOptions(element),
                val = unwrap(obsv),
                msg = null,
                isModified = false,
                isValid = false;

            if (obsv === null || typeof obsv === 'undefined') {
                throw new Error('Cannot bind validationMessage to undefined value. data-bind expression: ' +
                    element.getAttribute('data-bind'));
            }

            isModified = obsv.isModified && obsv.isModified();
            isValid = obsv.isValid && obsv.isValid();

            var error = null;
            if (!config.messagesOnModified || isModified) {
                error = isValid ? null : obsv.error;
            }

            var isVisible = !config.messagesOnModified || isModified ? !isValid : false;
            var isCurrentlyVisible = element.style.display !== "none";

            if (config.allowHtmlMessages) {
                koUtils.setHtml(element, error);
            } else {
                ko.bindingHandlers.text.update(element, function () { return error; });
            }

            if (isCurrentlyVisible && !isVisible) {
                element.style.display = 'none';
            } else if (!isCurrentlyVisible && isVisible) {
                element.style.display = '';
            }
        }
    };

    ko.bindingHandlers['validationElement'] = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var obsv = valueAccessor(),
                config = kv.utils.getConfigOptions(element),
                val = unwrap(obsv),
                msg = null,
                isModified = false,
                isValid = false;

            if (obsv === null || typeof obsv === 'undefined') {
                throw new Error('Cannot bind validationElement to undefined value. data-bind expression: ' +
                    element.getAttribute('data-bind'));
            }

            isModified = obsv.isModified && obsv.isModified();
            isValid = obsv.isValid && obsv.isValid();

            // create an evaluator function that will return something like:
            // css: { validationElement: true }
            var cssSettingsAccessor = function () {
                var css = {};

                var shouldShow = ((!config.decorateElementOnModified || isModified) ? !isValid : false);

                // css: { validationElement: false }
                css[config.errorElementClass] = shouldShow;

                return css;
            };

            //add or remove class on the element;
            ko.bindingHandlers.css.update(element, cssSettingsAccessor, allBindingsAccessor);
            if (!config.errorsAsTitle) { return; }

            ko.bindingHandlers.attr.update(element, function () {
                var
                    hasModification = !config.errorsAsTitleOnModified || isModified,
                    title = kv.utils.getOriginalElementTitle(element);

                if (hasModification && !isValid) {
                    return { title: obsv.error, 'data-orig-title': title };
                } else if (!hasModification || isValid) {
                    return { title: title, 'data-orig-title': null };
                }
            });
        }
    };

    // ValidationOptions:
    // This binding handler allows you to override the initial config by setting any of the options for a specific element or context of elements
    //
    // Example:
    // <div data-bind="validationOptions: { insertMessages: true, messageTemplate: 'customTemplate', errorMessageClass: 'mySpecialClass'}">
    //      <input type="text" data-bind="value: someValue"/>
    //      <input type="text" data-bind="value: someValue2"/>
    // </div>
    ko.bindingHandlers['validationOptions'] = (function () {
        return {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var options = unwrap(valueAccessor());
                if (options) {
                    var newConfig = extend({}, kv.configuration);
                    extend(newConfig, options);

                    //store the validation options on the node so we can retrieve it later
                    kv.utils.setDomData(element, newConfig);
                }
            }
        };
    }());
    ;// Validation Extender:
    // This is for creating custom validation logic on the fly
    // Example:
    // var test = ko.observable('something').extend{(
    //      validation: {
    //          validator: function(val, someOtherVal){
    //              return true;
    //          },
    //          message: "Something must be really wrong!',
    //          params: true
    //      }
    //  )};
    ko.extenders['validation'] = function (observable, rules) { // allow single rule or array
        forEach(kv.utils.isArray(rules) ? rules : [rules], function (rule) {
            // the 'rule' being passed in here has no name to identify a core Rule,
            // so we add it as an anonymous rule
            // If the developer is wanting to use a core Rule, but use a different message see the 'addExtender' logic for examples
            kv.addAnonymousRule(observable, rule);
        });
        return observable;
    };

    //This is the extender that makes a Knockout Observable also 'Validatable'
    //examples include:
    // 1. var test = ko.observable('something').extend({validatable: true});
    // this will ensure that the Observable object is setup properly to respond to rules
    //
    // 2. test.extend({validatable: false});
    // this will remove the validation properties from the Observable object should you need to do that.
    ko.extenders['validatable'] = function (observable, options) {
        if (!kv.utils.isObject(options)) {
            options = { enable: options };
        }

        if (!('enable' in options)) {
            options.enable = true;
        }

        if (options.enable && !kv.utils.isValidatable(observable)) {
            var config = kv.configuration.validate || {};
            var validationOptions = {
                throttleEvaluation: options.throttle || config.throttle
            };

            observable.error = ko.observable(null); // holds the error message, we only need one since we stop processing validators when one is invalid

            // observable.rules:
            // ObservableArray of Rule Contexts, where a Rule Context is simply the name of a rule and the params to supply to it
            //
            // Rule Context = { rule: '<rule name>', params: '<passed in params>', message: '<Override of default Message>' }
            observable.rules = ko.observableArray(); //holds the rule Contexts to use as part of validation

            //in case async validation is occurring
            observable.isValidating = ko.observable(false);

            //the true holder of whether the observable is valid or not
            observable.__valid__ = ko.observable(true);

            observable.isModified = ko.observable(false);

            // a semi-protected observable
            observable.isValid = ko.computed(observable.__valid__);

            //manually set error state
            observable.setError = function (error) {
                var previousError = observable.error.peek();
                var previousIsValid = observable.__valid__.peek();

                observable.error(error);
                observable.__valid__(false);

                if (previousError !== error && !previousIsValid) {
                    // if the observable was not valid before then isValid will not mutate,
                    // hence causing any grouping to not display the latest error.
                    observable.isValid.notifySubscribers();
                }
            };

            //manually clear error state
            observable.clearError = function () {
                observable.error(null);
                observable.__valid__(true);
                return observable;
            };

            //subscribe to changes in the observable
            var h_change = observable.subscribe(function () {
                observable.isModified(true);
            });

            // we use a computed here to ensure that anytime a dependency changes, the
            // validation logic evaluates
            var h_obsValidationTrigger = ko.computed(extend({
                read: function () {
                    var obs = observable(),
                        ruleContexts = observable.rules();

                    kv.validateObservable(observable);

                    return true;
                }
            }, validationOptions));

            extend(h_obsValidationTrigger, validationOptions);

            observable._disposeValidation = function () {
                //first dispose of the subscriptions
                observable.isValid.dispose();
                observable.rules.removeAll();
                h_change.dispose();
                h_obsValidationTrigger.dispose();

                delete observable['rules'];
                delete observable['error'];
                delete observable['isValid'];
                delete observable['isValidating'];
                delete observable['__valid__'];
                delete observable['isModified'];
                delete observable['setError'];
                delete observable['clearError'];
                delete observable['_disposeValidation'];
            };
        } else if (options.enable === false && observable._disposeValidation) {
            observable._disposeValidation();
        }
        return observable;
    };

    function validateSync(observable, rule, ctx) {
        //Execute the validator and see if its valid
        if (!rule.validator(observable(), (ctx.params === undefined ? true : unwrap(ctx.params)))) { // default param is true, eg. required = true

            //not valid, so format the error message and stick it in the 'error' variable
            observable.setError(kv.formatMessage(
                        ctx.message || rule.message,
                        unwrap(ctx.params),
                        observable));
            return false;
        } else {
            return true;
        }
    }

    function validateAsync(observable, rule, ctx) {
        observable.isValidating(true);

        var callBack = function (valObj) {
            var isValid = false,
                msg = '';

            if (!observable.__valid__()) {

                // since we're returning early, make sure we turn this off
                observable.isValidating(false);

                return; //if its already NOT valid, don't add to that
            }

            //we were handed back a complex object
            if (valObj['message']) {
                isValid = valObj.isValid;
                msg = valObj.message;
            } else {
                isValid = valObj;
            }

            if (!isValid) {
                //not valid, so format the error message and stick it in the 'error' variable
                observable.error(kv.formatMessage(
                    msg || ctx.message || rule.message,
                    unwrap(ctx.params),
                    observable));
                observable.__valid__(isValid);
            }

            // tell it that we're done
            observable.isValidating(false);
        };

        kv.utils.async(function () {
            //fire the validator and hand it the callback
            rule.validator(observable(), ctx.params === undefined ? true : unwrap(ctx.params), callBack);
        });
    }

    kv.validateObservable = function (observable) {
        var i = 0,
            rule, // the rule validator to execute
            ctx, // the current Rule Context for the loop
            ruleContexts = observable.rules(), //cache for iterator
            len = ruleContexts.length; //cache for iterator

        for (; i < len; i++) {

            //get the Rule Context info to give to the core Rule
            ctx = ruleContexts[i];

            // checks an 'onlyIf' condition
            if (ctx.condition && !ctx.condition()) {
                continue;
            }

            //get the core Rule to use for validation
            rule = ctx.rule ? kv.rules[ctx.rule] : ctx;

            if (rule['async'] || ctx['async']) {
                //run async validation
                validateAsync(observable, rule, ctx);

            } else {
                //run normal sync validation
                if (!validateSync(observable, rule, ctx)) {
                    return false; //break out of the loop
                }
            }
        }
        //finally if we got this far, make the observable valid again!
        observable.clearError();
        return true;
    };
    ;
    var _locales = {};
    var _currentLocale;

    kv.defineLocale = function (name, values) {
        if (name && values) {
            _locales[name.toLowerCase()] = values;
            return values;
        }
        return null;
    };

    kv.locale = function (name) {
        if (name) {
            name = name.toLowerCase();

            if (_locales.hasOwnProperty(name)) {
                kv.localize(_locales[name]);
                _currentLocale = name;
            }
            else {
                throw new Error('Localization ' + name + ' has not been loaded.');
            }
        }
        return _currentLocale;
    };

    //quick function to override rule messages
    kv.localize = function (msgTranslations) {
        var rules = kv.rules;

        //loop the properties in the object and assign the msg to the rule
        for (var ruleName in msgTranslations) {
            if (rules.hasOwnProperty(ruleName)) {
                rules[ruleName].message = msgTranslations[ruleName];
            }
        }
    };

    // Populate default locale (this will make en-US.js somewhat redundant)
    (function () {
        var localeData = {};
        var rules = kv.rules;

        for (var ruleName in rules) {
            if (rules.hasOwnProperty(ruleName)) {
                localeData[ruleName] = rules[ruleName].message;
            }
        }
        kv.defineLocale('en-us', localeData);
    })();

    // No need to invoke locale because the messages are already defined along with the rules for en-US
    _currentLocale = 'en-us';
    ;/**
 * Possible invocations:
 * 		applyBindingsWithValidation(viewModel)
 * 		applyBindingsWithValidation(viewModel, options)
 * 		applyBindingsWithValidation(viewModel, rootNode)
 *		applyBindingsWithValidation(viewModel, rootNode, options)
 */
    ko.applyBindingsWithValidation = function (viewModel, rootNode, options) {
        var node = document.body,
            config;

        if (rootNode && rootNode.nodeType) {
            node = rootNode;
            config = options;
        }
        else {
            config = rootNode;
        }

        kv.init();

        if (config) {
            config = extend(extend({}, kv.configuration), config);
            kv.utils.setDomData(node, config);
        }

        ko.applyBindings(viewModel, node);
    };

    //override the original applyBindings so that we can ensure all new rules and what not are correctly registered
    var origApplyBindings = ko.applyBindings;
    ko.applyBindings = function (viewModel, rootNode) {

        kv.init();

        origApplyBindings(viewModel, rootNode);
    };

    ko.validatedObservable = function (initialValue, options) {
        if (!options && !kv.utils.isObject(initialValue)) {
            return ko.observable(initialValue).extend({ validatable: true });
        }

        var obsv = ko.observable(initialValue);
        obsv.errors = kv.group(kv.utils.isObject(initialValue) ? initialValue : {}, options);
        obsv.isValid = ko.observable(obsv.errors().length === 0);

        if (ko.isObservable(obsv.errors)) {
            obsv.errors.subscribe(function (errors) {
                obsv.isValid(errors.length === 0);
            });
        }
        else {
            ko.computed(obsv.errors).subscribe(function (errors) {
                obsv.isValid(errors.length === 0);
            });
        }

        obsv.subscribe(function (newValue) {
            if (!kv.utils.isObject(newValue)) {
                /*
                 * The validation group works on objects.
                 * Since the new value is a primitive (scalar, null or undefined) we need
                 * to create an empty object to pass along.
                 */
                newValue = {};
            }
            // Force the group to refresh
            obsv.errors._updateState(newValue);
            obsv.isValid(obsv.errors().length === 0);
        });

        return obsv;
    };
    ;
}));


// chosen.jquery.js -->

// Chosen, a Select Box Enhancer for jQuery and Prototype
// by Patrick Filler for Harvest, http://getharvest.com
//
// Version 1.0.0
// Full source at https://github.com/harvesthq/chosen
// Copyright (c) 2011 Harvest http://getharvest.com

// MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
// This file is generated by `grunt build`, do not edit it by hand.
(function () {
    var $, AbstractChosen, Chosen, SelectParser, _ref,
      __hasProp = {}.hasOwnProperty,
      __extends = function (child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

    SelectParser = (function () {
        function SelectParser() {
            this.options_index = 0;
            this.parsed = [];
        }

        SelectParser.prototype.add_node = function (child) {
            if (child.nodeName.toUpperCase() === "OPTGROUP") {
                return this.add_group(child);
            } else {
                return this.add_option(child);
            }
        };

        SelectParser.prototype.add_group = function (group) {
            var group_position, option, _i, _len, _ref, _results;

            group_position = this.parsed.length;
            this.parsed.push({
                array_index: group_position,
                group: true,
                label: this.escapeExpression(group.label),
                children: 0,
                disabled: group.disabled
            });
            _ref = group.childNodes;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                _results.push(this.add_option(option, group_position, group.disabled));
            }
            return _results;
        };

        SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
            if (option.nodeName.toUpperCase() === "OPTION") {
                if (option.text !== "") {
                    if (group_position !== null) {
                        this.parsed[group_position].children += 1;
                    }
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        value: option.value,
                        text: option.text,
                        html: option.innerHTML,
                        selected: option.selected,
                        disabled: group_disabled === true ? group_disabled : option.disabled,
                        group_array_index: group_position,
                        classes: option.className,
                        style: option.style.cssText
                    });
                } else {
                    this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        empty: true
                    });
                }
                return this.options_index += 1;
            }
        };

        SelectParser.prototype.escapeExpression = function (text) {
            var map, unsafe_chars;

            if ((text === null) || text === false) {
                return "";
            }
            if (!/[\&\<\>\"\'\`]/.test(text)) {
                return text;
            }
            map = {
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            };
            unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
            return text.replace(unsafe_chars, function (chr) {
                return map[chr] || "&amp;";
            });
        };

        return SelectParser;

    })();

    SelectParser.select_to_array = function (select) {
        var child, parser, _i, _len, _ref;

        parser = new SelectParser();
        _ref = select.childNodes;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            child = _ref[_i];
            parser.add_node(child);
        }
        return parser.parsed;
    };

    AbstractChosen = (function () {
        function AbstractChosen(form_field, options) {
            this.form_field = form_field;
            this.options = options !== null ? options : {};
            if (!AbstractChosen.browser_is_supported()) {
                return;
            }
            this.is_multiple = this.form_field.multiple;
            this.set_default_text();
            this.set_default_values();
            this.setup();
            this.set_up_html();
            this.register_observers();
        }

        AbstractChosen.prototype.set_default_values = function () {
            var _this = this;

            this.click_test_action = function (evt) {
                return _this.test_active_click(evt);
            };
            this.activate_action = function (evt) {
                return _this.activate_field(evt);
            };
            this.active_field = false;
            this.mouse_on_container = false;
            this.results_showing = false;
            this.result_highlighted = null;
            this.result_single_selected = null;
            this.allow_single_deselect = (this.options.allow_single_deselect !== null) && (this.form_field.options[0] !== null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
            this.disable_search_threshold = this.options.disable_search_threshold || 0;
            this.disable_search = this.options.disable_search || false;
            this.enable_split_word_search = this.options.enable_split_word_search !== null ? this.options.enable_split_word_search : true;
            this.group_search = this.options.group_search !== null ? this.options.group_search : true;
            this.search_contains = this.options.search_contains || false;
            this.single_backstroke_delete = this.options.single_backstroke_delete !== null ? this.options.single_backstroke_delete : true;
            this.max_selected_options = this.options.max_selected_options || Infinity;
            this.inherit_select_classes = this.options.inherit_select_classes || false;
            this.display_selected_options = this.options.display_selected_options !== null ? this.options.display_selected_options : true;
            return this.display_disabled_options = this.options.display_disabled_options !== null ? this.options.display_disabled_options : true;
        };

        AbstractChosen.prototype.set_default_text = function () {
            if (this.form_field.getAttribute("data-placeholder")) {
                this.default_text = this.form_field.getAttribute("data-placeholder");
            } else if (this.is_multiple) {
                this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
            } else {
                this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
            }
            return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
        };

        AbstractChosen.prototype.mouse_enter = function () {
            return this.mouse_on_container = true;
        };

        AbstractChosen.prototype.mouse_leave = function () {
            return this.mouse_on_container = false;
        };

        AbstractChosen.prototype.input_focus = function (evt) {
            var _this = this;

            if (this.is_multiple) {
                if (!this.active_field) {
                    return setTimeout((function () {
                        return _this.container_mousedown();
                    }), 50);
                }
            } else {
                if (!this.active_field) {
                    return this.activate_field();
                }
            }
        };

        AbstractChosen.prototype.input_blur = function (evt) {
            var _this = this;

            if (!this.mouse_on_container) {
                this.active_field = false;
                return setTimeout((function () {
                    return _this.blur_test();
                }), 100);
            }
        };

        AbstractChosen.prototype.results_option_build = function (options) {
            var content, data, _i, _len, _ref;

            content = '';
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                data = _ref[_i];
                if (data.group) {
                    content += this.result_add_group(data);
                } else {
                    content += this.result_add_option(data);
                }
                if (options !== null ? options.first : void 0) {
                    if (data.selected && this.is_multiple) {
                        this.choice_build(data);
                    } else if (data.selected && !this.is_multiple) {
                        this.single_set_selected_text(data.text);
                    }
                }
            }
            return content;
        };

        AbstractChosen.prototype.result_add_option = function (option) {
            var classes, style;

            if (!option.search_match) {
                return '';
            }
            if (!this.include_option_in_results(option)) {
                return '';
            }
            classes = [];
            if (!option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("active-result");
            }
            if (option.disabled && !(option.selected && this.is_multiple)) {
                classes.push("disabled-result");
            }
            if (option.selected) {
                classes.push("result-selected");
            }
            if (option.group_array_index !== null) {
                classes.push("group-option");
            }
            if (option.classes !== "") {
                classes.push(option.classes);
            }
            style = option.style.cssText !== "" ? " style=\"" + option.style + "\"" : "";
            return "<li class=\"" + (classes.join(' ')) + "\"" + style + " data-option-array-index=\"" + option.array_index + "\">" + option.search_text + "</li>";
        };

        AbstractChosen.prototype.result_add_group = function (group) {
            if (!(group.search_match || group.group_match)) {
                return '';
            }
            if (!(group.active_options > 0)) {
                return '';
            }
            return "<li class=\"group-result\">" + group.search_text + "</li>";
        };

        AbstractChosen.prototype.results_update_field = function () {
            this.set_default_text();
            if (!this.is_multiple) {
                this.results_reset_cleanup();
            }
            this.result_clear_highlight();
            this.result_single_selected = null;
            this.results_build();
            if (this.results_showing) {
                return this.winnow_results();
            }
        };

        AbstractChosen.prototype.results_toggle = function () {
            if (this.results_showing) {
                return this.results_hide();
            } else {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.results_search = function (evt) {
            if (this.results_showing) {
                return this.winnow_results();
            } else {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.winnow_results = function () {
            var escapedSearchText, option, regex, regexAnchor, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;

            this.no_results_clear();
            results = 0;
            searchText = this.get_search_text();
            escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            regexAnchor = this.search_contains ? "" : "^";
            regex = new RegExp(regexAnchor + escapedSearchText, 'i');
            zregex = new RegExp(escapedSearchText, 'i');
            _ref = this.results_data;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                option.search_match = false;
                results_group = null;
                if (this.include_option_in_results(option)) {
                    if (option.group) {
                        option.group_match = false;
                        option.active_options = 0;
                    }
                    if ((option.group_array_index !== null) && this.results_data[option.group_array_index]) {
                        results_group = this.results_data[option.group_array_index];
                        if (results_group.active_options === 0 && results_group.search_match) {
                            results += 1;
                        }
                        results_group.active_options += 1;
                    }
                    if (!(option.group && !this.group_search)) {
                        option.search_text = option.group ? option.label : option.html;
                        option.search_match = this.search_string_match(option.search_text, regex);
                        if (option.search_match && !option.group) {
                            results += 1;
                        }
                        if (option.search_match) {
                            if (searchText.length) {
                                startpos = option.search_text.search(zregex);
                                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                            }
                            if (results_group !== null) {
                                results_group.group_match = true;
                            }
                        } else if ((option.group_array_index !== null) && this.results_data[option.group_array_index].search_match) {
                            option.search_match = true;
                        }
                    }
                }
            }
            this.result_clear_highlight();
            if (results < 1 && searchText.length) {
                this.update_results_content("");
                return this.no_results(searchText);
            } else {
                this.update_results_content(this.results_option_build());
                return this.winnow_results_set_highlight();
            }
        };

        AbstractChosen.prototype.search_string_match = function (search_string, regex) {
            var part, parts, _i, _len;

            if (regex.test(search_string)) {
                return true;
            } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
                parts = search_string.replace(/\[|\]/g, "").split(" ");
                if (parts.length) {
                    for (_i = 0, _len = parts.length; _i < _len; _i++) {
                        part = parts[_i];
                        if (regex.test(part)) {
                            return true;
                        }
                    }
                }
            }
        };

        AbstractChosen.prototype.choices_count = function () {
            var option, _i, _len, _ref;

            if (this.selected_option_count !== null) {
                return this.selected_option_count;
            }
            this.selected_option_count = 0;
            _ref = this.form_field.options;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                if (option.selected) {
                    this.selected_option_count += 1;
                }
            }
            return this.selected_option_count;
        };

        AbstractChosen.prototype.choices_click = function (evt) {
            evt.preventDefault();
            if (!(this.results_showing || this.is_disabled)) {
                return this.results_show();
            }
        };

        AbstractChosen.prototype.keyup_checker = function (evt) {
            var stroke, _ref;

            stroke = (_ref = evt.which) !== null ? _ref : evt.keyCode;
            this.search_field_scale();
            switch (stroke) {
                case 8:
                    if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
                        return this.keydown_backstroke();
                    } else if (!this.pending_backstroke) {
                        this.result_clear_highlight();
                        return this.results_search();
                    }
                    break;
                case 13:
                    evt.preventDefault();
                    if (this.results_showing) {
                        return this.result_select(evt);
                    }
                    break;
                case 27:
                    if (this.results_showing) {
                        this.results_hide();
                    }
                    return true;
                case 9:
                case 38:
                case 40:
                case 16:
                case 91:
                case 17:
                    break;
                default:
                    return this.results_search();
            }
        };

        AbstractChosen.prototype.container_width = function () {
            if (this.options.width !== null) {
                return this.options.width;
            } else {
                return "" + this.form_field.offsetWidth + "px";
            }
        };

        AbstractChosen.prototype.include_option_in_results = function (option) {
            if (this.is_multiple && (!this.display_selected_options && option.selected)) {
                return false;
            }
            if (!this.display_disabled_options && option.disabled) {
                return false;
            }
            if (option.empty) {
                return false;
            }
            return true;
        };

        AbstractChosen.browser_is_supported = function () {
            if (window.navigator.appName === "Microsoft Internet Explorer") {
                return document.documentMode >= 8;
            }
            if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
                return false;
            }
            if (/Android/i.test(window.navigator.userAgent)) {
                if (/Mobile/i.test(window.navigator.userAgent)) {
                    return false;
                }
            }
            return true;
        };

        AbstractChosen.default_multiple_text = "Select Some Options";

        AbstractChosen.default_single_text = "Select an Option";

        AbstractChosen.default_no_result_text = "No results match";

        return AbstractChosen;

    })();

    $ = jQuery;

    $.fn.extend({
        chosen: function (options) {
            if (!AbstractChosen.browser_is_supported()) {
                return this;
            }
            return this.each(function (input_field) {
                var $this, chosen;

                $this = $(this);
                chosen = $this.data('chosen');
                if (options === 'destroy' && chosen) {
                    chosen.destroy();
                } else if (!chosen) {
                    $this.data('chosen', new Chosen(this, options));
                }
            });
        }
    });

    Chosen = (function (_super) {
        __extends(Chosen, _super);

        function Chosen() {
            _ref = Chosen.__super__.constructor.apply(this, arguments);
            return _ref;
        }

        Chosen.prototype.setup = function () {
            this.form_field_jq = $(this.form_field);
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
        };

        Chosen.prototype.set_up_html = function () {
            var container_classes, container_props;

            container_classes = ["chosen-container"];
            container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
            if (this.inherit_select_classes && this.form_field.className) {
                container_classes.push(this.form_field.className);
            }
            if (this.is_rtl) {
                container_classes.push("chosen-rtl");
            }
            container_props = {
                'class': container_classes.join(' '),
                'style': "width: " + (this.container_width()) + ";",
                'title': this.form_field.title
            };
            if (this.form_field.id.length) {
                container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
            }
            this.container = $("<div />", container_props);
            if (this.is_multiple) {
                this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
            } else {
                this.container.html('<a class="chosen-single chosen-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
            }
            this.form_field_jq.hide().after(this.container);
            this.dropdown = this.container.find('div.chosen-drop').first();
            this.search_field = this.container.find('input').first();
            this.search_results = this.container.find('ul.chosen-results').first();
            this.search_field_scale();
            this.search_no_results = this.container.find('li.no-results').first();
            if (this.is_multiple) {
                this.search_choices = this.container.find('ul.chosen-choices').first();
                this.search_container = this.container.find('li.search-field').first();
            } else {
                this.search_container = this.container.find('div.chosen-search').first();
                this.selected_item = this.container.find('.chosen-single').first();
            }
            this.results_build();
            this.set_tab_index();
            this.set_label_behavior();
            return this.form_field_jq.trigger("chosen:ready", {
                chosen: this
            });
        };

        Chosen.prototype.register_observers = function () {
            var _this = this;

            this.container.bind('mousedown.chosen', function (evt) {
                _this.container_mousedown(evt);
            });
            this.container.bind('mouseup.chosen', function (evt) {
                _this.container_mouseup(evt);
            });
            this.container.bind('mouseenter.chosen', function (evt) {
                _this.mouse_enter(evt);
            });
            this.container.bind('mouseleave.chosen', function (evt) {
                _this.mouse_leave(evt);
            });
            this.search_results.bind('mouseup.chosen', function (evt) {
                _this.search_results_mouseup(evt);
            });
            this.search_results.bind('mouseover.chosen', function (evt) {
                _this.search_results_mouseover(evt);
            });
            this.search_results.bind('mouseout.chosen', function (evt) {
                _this.search_results_mouseout(evt);
            });
            this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function (evt) {
                _this.search_results_mousewheel(evt);
            });
            this.form_field_jq.bind("chosen:updated.chosen", function (evt) {
                _this.results_update_field(evt);
            });
            this.form_field_jq.bind("chosen:activate.chosen", function (evt) {
                _this.activate_field(evt);
            });
            this.form_field_jq.bind("chosen:open.chosen", function (evt) {
                _this.container_mousedown(evt);
            });
            this.search_field.bind('blur.chosen', function (evt) {
                _this.input_blur(evt);
            });
            this.search_field.bind('keyup.chosen', function (evt) {
                _this.keyup_checker(evt);
            });
            this.search_field.bind('keydown.chosen', function (evt) {
                _this.keydown_checker(evt);
            });
            this.search_field.bind('focus.chosen', function (evt) {
                _this.input_focus(evt);
            });
            if (this.is_multiple) {
                return this.search_choices.bind('click.chosen', function (evt) {
                    _this.choices_click(evt);
                });
            } else {
                return this.container.bind('click.chosen', function (evt) {
                    evt.preventDefault();
                });
            }
        };

        Chosen.prototype.destroy = function () {
            $(document).unbind("click.chosen", this.click_test_action);
            if (this.search_field[0].tabIndex) {
                this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
            }
            this.container.remove();
            this.form_field_jq.removeData('chosen');
            return this.form_field_jq.show();
        };

        Chosen.prototype.search_field_disabled = function () {
            this.is_disabled = this.form_field_jq[0].disabled;
            if (this.is_disabled) {
                this.container.addClass('chosen-disabled');
                this.search_field[0].disabled = true;
                if (!this.is_multiple) {
                    this.selected_item.unbind("focus.chosen", this.activate_action);
                }
                return this.close_field();
            } else {
                this.container.removeClass('chosen-disabled');
                this.search_field[0].disabled = false;
                if (!this.is_multiple) {
                    return this.selected_item.bind("focus.chosen", this.activate_action);
                }
            }
        };

        Chosen.prototype.container_mousedown = function (evt) {
            if (!this.is_disabled) {
                if (evt && evt.type === "mousedown" && !this.results_showing) {
                    evt.preventDefault();
                }
                if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
                    if (!this.active_field) {
                        if (this.is_multiple) {
                            this.search_field.val("");
                        }
                        $(document).bind('click.chosen', this.click_test_action);
                        this.results_show();
                    } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
                        evt.preventDefault();
                        this.results_toggle();
                    }
                    return this.activate_field();
                }
            }
        };

        Chosen.prototype.container_mouseup = function (evt) {
            if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
                return this.results_reset(evt);
            }
        };

        Chosen.prototype.search_results_mousewheel = function (evt) {
            var delta, _ref1, _ref2;

            delta = -((_ref1 = evt.originalEvent) != null ? _ref1.wheelDelta : void 0) || ((_ref2 = evt.originialEvent) != null ? _ref2.detail : void 0);
            if (delta != null) {
                evt.preventDefault();
                if (evt.type === 'DOMMouseScroll') {
                    delta = delta * 40;
                }
                return this.search_results.scrollTop(delta + this.search_results.scrollTop());
            }
        };

        Chosen.prototype.blur_test = function (evt) {
            if (!this.active_field && this.container.hasClass("chosen-container-active")) {
                return this.close_field();
            }
        };

        Chosen.prototype.close_field = function () {
            $(document).unbind("click.chosen", this.click_test_action);
            this.active_field = false;
            this.results_hide();
            this.container.removeClass("chosen-container-active");
            this.clear_backstroke();
            this.show_search_field_default();
            return this.search_field_scale();
        };

        Chosen.prototype.activate_field = function () {
            this.container.addClass("chosen-container-active");
            this.active_field = true;
            this.search_field.val(this.search_field.val());
            return this.search_field.focus();
        };

        Chosen.prototype.test_active_click = function (evt) {
            if (this.container.is($(evt.target).closest('.chosen-container'))) {
                return this.active_field = true;
            } else {
                return this.close_field();
            }
        };

        Chosen.prototype.results_build = function () {
            this.parsing = true;
            this.selected_option_count = null;
            this.results_data = SelectParser.select_to_array(this.form_field);
            if (this.is_multiple) {
                this.search_choices.find("li.search-choice").remove();
            } else if (!this.is_multiple) {
                this.single_set_selected_text();
                if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
                    this.search_field[0].readOnly = true;
                    this.container.addClass("chosen-container-single-nosearch");
                } else {
                    this.search_field[0].readOnly = false;
                    this.container.removeClass("chosen-container-single-nosearch");
                }
            }
            this.update_results_content(this.results_option_build({
                first: true
            }));
            this.search_field_disabled();
            this.show_search_field_default();
            this.search_field_scale();
            return this.parsing = false;
        };

        Chosen.prototype.result_do_highlight = function (el) {
            var high_bottom, high_top, maxHeight, visible_bottom, visible_top;

            if (el.length) {
                this.result_clear_highlight();
                this.result_highlight = el;
                this.result_highlight.addClass("highlighted");
                maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
                visible_top = this.search_results.scrollTop();
                visible_bottom = maxHeight + visible_top;
                high_top = this.result_highlight.position().top + this.search_results.scrollTop();
                high_bottom = high_top + this.result_highlight.outerHeight();
                if (high_bottom >= visible_bottom) {
                    return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
                } else if (high_top < visible_top) {
                    return this.search_results.scrollTop(high_top);
                }
            }
        };

        Chosen.prototype.result_clear_highlight = function () {
            if (this.result_highlight) {
                this.result_highlight.removeClass("highlighted");
            }
            return this.result_highlight = null;
        };

        Chosen.prototype.results_show = function () {
            if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                this.form_field_jq.trigger("chosen:maxselected", {
                    chosen: this
                });
                return false;
            }
            this.container.addClass("chosen-with-drop");
            this.form_field_jq.trigger("chosen:showing_dropdown", {
                chosen: this
            });
            this.results_showing = true;
            this.search_field.focus();
            this.search_field.val(this.search_field.val());
            return this.winnow_results();
        };

        Chosen.prototype.update_results_content = function (content) {
            return this.search_results.html(content);
        };

        Chosen.prototype.results_hide = function () {
            if (this.results_showing) {
                this.result_clear_highlight();
                this.container.removeClass("chosen-with-drop");
                this.form_field_jq.trigger("chosen:hiding_dropdown", {
                    chosen: this
                });
            }
            return this.results_showing = false;
        };

        Chosen.prototype.set_tab_index = function (el) {
            var ti;

            if (this.form_field.tabIndex) {
                ti = this.form_field.tabIndex;
                this.form_field.tabIndex = -1;
                return this.search_field[0].tabIndex = ti;
            }
        };

        Chosen.prototype.set_label_behavior = function () {
            var _this = this;

            this.form_field_label = this.form_field_jq.parents("label");
            if (!this.form_field_label.length && this.form_field.id.length) {
                this.form_field_label = $("label[for='" + this.form_field.id + "']");
            }
            if (this.form_field_label.length > 0) {
                return this.form_field_label.bind('click.chosen', function (evt) {
                    if (_this.is_multiple) {
                        return _this.container_mousedown(evt);
                    } else {
                        return _this.activate_field();
                    }
                });
            }
        };

        Chosen.prototype.show_search_field_default = function () {
            if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
                this.search_field.val(this.default_text);
                return this.search_field.addClass("default");
            } else {
                this.search_field.val("");
                return this.search_field.removeClass("default");
            }
        };

        Chosen.prototype.search_results_mouseup = function (evt) {
            var target;

            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target.length) {
                this.result_highlight = target;
                this.result_select(evt);
                return this.search_field.focus();
            }
        };

        Chosen.prototype.search_results_mouseover = function (evt) {
            var target;

            target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
            if (target) {
                return this.result_do_highlight(target);
            }
        };

        Chosen.prototype.search_results_mouseout = function (evt) {
            if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
                return this.result_clear_highlight();
            }
        };

        Chosen.prototype.choice_build = function (item) {
            var choice, close_link,
              _this = this;

            choice = $('<li />', {
                "class": "search-choice"
            }).html("<span>" + item.html + "</span>");
            if (item.disabled) {
                choice.addClass('search-choice-disabled');
            } else {
                close_link = $('<a />', {
                    "class": 'search-choice-close',
                    'data-option-array-index': item.array_index
                });
                close_link.bind('click.chosen', function (evt) {
                    return _this.choice_destroy_link_click(evt);
                });
                choice.append(close_link);
            }
            return this.search_container.before(choice);
        };

        Chosen.prototype.choice_destroy_link_click = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (!this.is_disabled) {
                return this.choice_destroy($(evt.target));
            }
        };

        Chosen.prototype.choice_destroy = function (link) {
            if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
                this.show_search_field_default();
                if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
                    this.results_hide();
                }
                link.parents('li').first().remove();
                return this.search_field_scale();
            }
        };

        Chosen.prototype.results_reset = function () {
            this.form_field.options[0].selected = true;
            this.selected_option_count = null;
            this.single_set_selected_text();
            this.show_search_field_default();
            this.results_reset_cleanup();
            this.form_field_jq.trigger("change");
            if (this.active_field) {
                return this.results_hide();
            }
        };

        Chosen.prototype.results_reset_cleanup = function () {
            this.current_selectedIndex = this.form_field.selectedIndex;
            return this.selected_item.find("abbr").remove();
        };

        Chosen.prototype.result_select = function (evt) {
            var high, item, selected_index;

            if (this.result_highlight) {
                high = this.result_highlight;
                this.result_clear_highlight();
                if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                    this.form_field_jq.trigger("chosen:maxselected", {
                        chosen: this
                    });
                    return false;
                }
                if (this.is_multiple) {
                    high.removeClass("active-result");
                } else {
                    if (this.result_single_selected) {
                        this.result_single_selected.removeClass("result-selected");
                        selected_index = this.result_single_selected[0].getAttribute('data-option-array-index');
                        this.results_data[selected_index].selected = false;
                    }
                    this.result_single_selected = high;
                }
                high.addClass("result-selected");
                item = this.results_data[high[0].getAttribute("data-option-array-index")];
                item.selected = true;
                this.form_field.options[item.options_index].selected = true;
                this.selected_option_count = null;
                if (this.is_multiple) {
                    this.choice_build(item);
                } else {
                    this.single_set_selected_text(item.text);
                }
                if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
                    this.results_hide();
                }
                this.search_field.val("");
                if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
                    this.form_field_jq.trigger("change", {
                        'selected': this.form_field.options[item.options_index].value
                    });
                }
                this.current_selectedIndex = this.form_field.selectedIndex;
                return this.search_field_scale();
            }
        };

        Chosen.prototype.single_set_selected_text = function (text) {
            if (text == null) {
                text = this.default_text;
            }
            if (text === this.default_text) {
                this.selected_item.addClass("chosen-default");
            } else {
                this.single_deselect_control_build();
                this.selected_item.removeClass("chosen-default");
            }
            return this.selected_item.find("span").text(text);
        };

        Chosen.prototype.result_deselect = function (pos) {
            var result_data;

            result_data = this.results_data[pos];
            if (!this.form_field.options[result_data.options_index].disabled) {
                result_data.selected = false;
                this.form_field.options[result_data.options_index].selected = false;
                this.selected_option_count = null;
                this.result_clear_highlight();
                if (this.results_showing) {
                    this.winnow_results();
                }
                this.form_field_jq.trigger("change", {
                    deselected: this.form_field.options[result_data.options_index].value
                });
                this.search_field_scale();
                return true;
            } else {
                return false;
            }
        };

        Chosen.prototype.single_deselect_control_build = function () {
            if (!this.allow_single_deselect) {
                return;
            }
            if (!this.selected_item.find("abbr").length) {
                this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
            }
            return this.selected_item.addClass("chosen-single-with-deselect");
        };

        Chosen.prototype.get_search_text = function () {
            if (this.search_field.val() === this.default_text) {
                return "";
            } else {
                return $('<div/>').text($.trim(this.search_field.val())).html();
            }
        };

        Chosen.prototype.winnow_results_set_highlight = function () {
            var do_high, selected_results;

            selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
            do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
            if (do_high != null) {
                return this.result_do_highlight(do_high);
            }
        };

        Chosen.prototype.no_results = function (terms) {
            var no_results_html;

            no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
            no_results_html.find("span").first().html(terms);
            return this.search_results.append(no_results_html);
        };

        Chosen.prototype.no_results_clear = function () {
            return this.search_results.find(".no-results").remove();
        };

        Chosen.prototype.keydown_arrow = function () {
            var next_sib;

            if (this.results_showing && this.result_highlight) {
                next_sib = this.result_highlight.nextAll("li.active-result").first();
                if (next_sib) {
                    return this.result_do_highlight(next_sib);
                }
            } else {
                return this.results_show();
            }
        };

        Chosen.prototype.keyup_arrow = function () {
            var prev_sibs;

            if (!this.results_showing && !this.is_multiple) {
                return this.results_show();
            } else if (this.result_highlight) {
                prev_sibs = this.result_highlight.prevAll("li.active-result");
                if (prev_sibs.length) {
                    return this.result_do_highlight(prev_sibs.first());
                } else {
                    if (this.choices_count() > 0) {
                        this.results_hide();
                    }
                    return this.result_clear_highlight();
                }
            }
        };

        Chosen.prototype.keydown_backstroke = function () {
            var next_available_destroy;

            if (this.pending_backstroke) {
                this.choice_destroy(this.pending_backstroke.find("a").first());
                return this.clear_backstroke();
            } else {
                next_available_destroy = this.search_container.siblings("li.search-choice").last();
                if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
                    this.pending_backstroke = next_available_destroy;
                    if (this.single_backstroke_delete) {
                        return this.keydown_backstroke();
                    } else {
                        return this.pending_backstroke.addClass("search-choice-focus");
                    }
                }
            }
        };

        Chosen.prototype.clear_backstroke = function () {
            if (this.pending_backstroke) {
                this.pending_backstroke.removeClass("search-choice-focus");
            }
            return this.pending_backstroke = null;
        };

        Chosen.prototype.keydown_checker = function (evt) {
            var stroke, _ref1;

            stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
            this.search_field_scale();
            if (stroke !== 8 && this.pending_backstroke) {
                this.clear_backstroke();
            }
            switch (stroke) {
                case 8:
                    this.backstroke_length = this.search_field.val().length;
                    break;
                case 9:
                    if (this.results_showing && !this.is_multiple) {
                        this.result_select(evt);
                    }
                    this.mouse_on_container = false;
                    break;
                case 13:
                    evt.preventDefault();
                    break;
                case 38:
                    evt.preventDefault();
                    this.keyup_arrow();
                    break;
                case 40:
                    evt.preventDefault();
                    this.keydown_arrow();
                    break;
            }
        };

        Chosen.prototype.search_field_scale = function () {
            var div, f_width, h, style, style_block, styles, w, _i, _len;

            if (this.is_multiple) {
                h = 0;
                w = 0;
                style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
                styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
                for (_i = 0, _len = styles.length; _i < _len; _i++) {
                    style = styles[_i];
                    style_block += style + ":" + this.search_field.css(style) + ";";
                }
                div = $('<div />', {
                    'style': style_block
                });
                div.text(this.search_field.val());
                $('body').append(div);
                w = div.width() + 25;
                div.remove();
                f_width = this.container.outerWidth();
                if (w > f_width - 10) {
                    w = f_width - 10;
                }
                return this.search_field.css({
                    'width': w + 'px'
                });
            }
        };

        return Chosen;

    })(AbstractChosen);

}).call(this);

// Mapv3.js -->

function loadMap(route) {
    var self = this;

    var mapCanvas = document.getElementById("map-canvas");
    var ACT_MAPTYPE_ID = 'ACT MAP';
    var ORIGIN_LAT = 37.8567;
    var ORIGIN_LNG = -122.255;
    var MIN_ZOOM = 12;
    var MAX_ZOOM = 15;
    var MAX_PAN = 10;
    var API_KEY = "AIzaSyBMZ5FTf5NglxeU8I9OcunMkPmBqW3uO7o";
    var SENSOR = "false";

    if (typeof route !== "string")
        route = line;

    var map;
    var imageMapType;
    self.initialize = function () {
        var bounds = {
            12: [[656, 657], [1581, 1582]],
            13: [[1313, 1315], [3162, 3164]],
            14: [[2626, 2631], [6324, 6328]],
            15: [[5252, 5263], [12648, 12656]]
        };

        function long2tile(lon, zoom) {
            return (Math.floor((lon + 180) / 360 * Math.pow(2, zoom)));
        }
        function lat2tile(lat, zoom) {
            return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom)));
        }
        function tile2long(x, z) {
            return (x / Math.pow(2, z) * 360 - 180);
        }
        function tile2lat(y, z) {
            var n = Math.PI - 2 * Math.PI * y / Math.pow(2, z);
            return (180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))));
        }

        var strictBounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(tile2lat(lat2tile(ORIGIN_LAT, 15) + MAX_PAN, 15), tile2long(long2tile(ORIGIN_LNG, 15) - MAX_PAN, 15)),
            new google.maps.LatLng(tile2lat(lat2tile(ORIGIN_LAT, 15) - MAX_PAN, 15), tile2long(long2tile(ORIGIN_LNG, 15) + MAX_PAN, 15))
        );

        var mapOptions = {
            zoom: MIN_ZOOM,
            center: strictBounds.getCenter(),
            maxZoom: MAX_ZOOM,
            minZoom: MIN_ZOOM,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, ACT_MAPTYPE_ID]
            },
            mapTypeId: ACT_MAPTYPE_ID,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.LARGE,
                position: google.maps.ControlPosition.LEFT_CENTER
            },
            panControl: false,
            scaleControl: false,
            streetViewControl: false,
            overviewMapControl: false
        };

        var mapTypeOptions = {
            name: ACT_MAPTYPE_ID,
            maxZoom: MAX_ZOOM,
            minZoom: MIN_ZOOM,
            getTileUrl: function (coord, zoom) {
                if (zoom < MIN_ZOOM || zoom > MAX_ZOOM ||
                    bounds[zoom][0][0] > coord.x || coord.x > bounds[zoom][0][1] ||
                    bounds[zoom][1][0] > coord.y || coord.y > bounds[zoom][1][1]) {
                    return mainDomain + "/maps/images/maptiles/white.gif";
                }

                return [mainDomain + "/maps/images/maptiles/version_" + mapsVersion + "/" + route + "/" + zoom + "/" + coord.x + "_" + coord.y + "_" + zoom + ".gif"].join('');
            },
            tileSize: new google.maps.Size(256, 256)

        };
        map = new google.maps.Map(mapCanvas, mapOptions);
        imageMapType = new google.maps.ImageMapType(mapTypeOptions);

        map.mapTypes.set(ACT_MAPTYPE_ID, imageMapType);
        map.overlayMapTypes.push(null);
        map.overlayMapTypes.setAt("0", imageMapType);
        map.overlayMapTypes.setAt("0", null);
        google.maps.event.addListenerOnce(map, 'idle', function () {
            var canvas = document.getElementById('map-canvas');
            if (canvas) {
                var mapCopyright = document.getElementById('map-canvas').getElementsByTagName("a");
                $(mapCopyright).click(function () {
                    return false;
                });
            }
        });
        map.fitBounds(strictBounds);

        var lastValidCenter = map.getCenter();

        var moveOnMap = function () {
            if (strictBounds.contains(map.getCenter())) {
                // still within valid bounds, so save the last valid position
                lastValidCenter = map.getCenter();
                return;
            }

            // not valid anymore => return to last valid position
            map.panTo(lastValidCenter);
        }

        google.maps.event.addListener(map, 'center_changed', moveOnMap);
        google.maps.event.addListener(map, 'dragend', moveOnMap);
    }
    self.loadScript = function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=' + API_KEY + '&sensor=' + SENSOR + '&callback=initialize';
        document.body.appendChild(script);
    }
    self.loadScript();
}

// DeepLink.js -->

DeepLink = (function () { // Singleton           
    var instance;
    function init() {
        // Private methods and variables
        var option = {};
        var defaultOption =
        {
            contentElement: "",
            scrollTopElement: "",
            initialUrl: "",
            isPanelVisible: false,
            catchClickReady: null,
            onLoaded: null
        }
        var isCatching = false;
        var lastRootElementsCount = 0;
        var lastLoadedUrl;
        var deepLinkKey = "deeplinks";
        var testHasUrl;
        function mergeOptions(options) {
            if (typeof options === "undefined") return;
            if (typeof options.contentElement === "string")
                option.contentElement = options.contentElement;
            if (typeof options.scrollTopElement === "string")
                option.scrollTopElement = options.scrollTopElement;
            if (typeof options.initialUrl === "string")
                option.initialUrl = options.initialUrl;
            if (typeof options.isPanelVisible === "function")
                option.isPanelVisible = options.isPanelVisible;
            if (typeof options.catchClickReady === "function")
                option.catchClickReady = options.catchClickReady;
            if (typeof lastLoadedUrl === "undefined")
                lastLoadedUrl = option.initialUrl;
            if (typeof options.onLoaded === "function")
                option.onLoaded = options.onLoaded;
        }
        function catchContentChanged(options) {
            mergeOptions(options);
            $(option.contentElement).bind('DOMNodeInserted', catchClick);
        }
        function catchClickDestroy() {
            var rootElements = $(option.contentElement + " a[href*='" + window.service + "']");
            if (rootElements.length == lastRootElementsCount) // prevent load loops
                return;
            unbindEventHandler(rootElements);
        }
        function catchClick(options) {
            mergeOptions(options);
            var fragmentElements = $(option.contentElement + " a[href^='#']");
            bindFragmentIds(fragmentElements);
            var rootElements = $(option.contentElement + " a[href*='" + window.service + "']");
            if (rootElements.length == lastRootElementsCount) // prevent load loops
                return;
            lastRootElementsCount = rootElements.length;
            bindEventHandler(rootElements);
            loadStyle();
            if (typeof option.catchClickReady === "function") {
                option.catchClickReady(this);
            }
        }
        function bindEventHandler(rootElements) {
            isCatching = false;
            rootElements.bind("click", function (e) {
                if (isCatching) return false;
                var nextUrl = e.currentTarget.href;
                if (nextUrl.indexOf(window.service) < 0) return true; // for non-AJAX sites
                isCatching = true;
                clearLastRootElementsCount();
                e.preventDefault();
                loadUrl(nextUrl, true);
                return false;
            });
        }
        function bindFragmentIds(rootElements) {
            rootElements.each(function (index, element) {
                element.id = element.href.split('#')[1]; // element.id = anything after #
            }).bind("click", function (eventObject) {
                var aTag = $("a[name='" + eventObject.currentTarget.id + "']");
                if (aTag.length != 1) return;
                $(option.scrollTopElement).dxScrollView("instance").scrollTo(aTag.position().top);
            }).removeAttr("href");
        }
        function unbindEventHandler(rootElements) {
            isCatching = false;
            rootElements.unbind("click");
        }
        function moveToMenu() {
            var ul = $("ul:first-child");
            if (ul.length > 0) {
                var sourceIndex = $(option.contentElement).html().indexOf(ul.html())
                if (sourceIndex < 100) {
                    self.moveClass = new ACTransit.MenuButton(ul);
                    self.moveClass.undo();
                    self.moveClass.moveToMenu();
                }
            }
        }
        function loadUrl(nextUrl, shouldPushUrl) {
            lastLoadedUrl = nextUrl;
            if (typeof option.isPanelVisible === "function")
                option.isPanelVisible(true);
            $.ajax({
                url: nextUrl,
                type: "GET",
                crossDomain: true,
                data: null,
                dataType: "json",
                success: function (data) {
                    try {
                        window.utils.triggerGA('/index.html' + option.contentElement, nextUrl.replace(window.service, ''));
                        var view = $(option.contentElement);
                        view.html(utils.fixContent(data.Content));
                        if (typeof option.onLoaded === "function")
                            option.onLoaded();
                        catchClick();
                        if (shouldPushUrl)
                            pushUrl(nextUrl);
                        isCatching = false;
                        var sv = $(option.scrollTopElement);
                        if (sv.length == 1) {
                            window.scrollTo(0, 0);
                            sv.dxScrollView("instance").scrollTo(0);
                            moveToMenu();
                        }
                    } catch (e) { }
                    if (typeof option.isPanelVisible === "function")
                        option.isPanelVisible(false);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    catchClick();
                    if (typeof option.isPanelVisible === "function")
                        option.isPanelVisible(false);
                }
            });
        }
        function getUrls() {
            var storage = localStorage.getItem(deepLinkKey);
            return storage == null ? [] : JSON.parse(storage);
        }
        function pushUrl(url) {
            if (!window.Features.supportsLocalStorage()) return false;
            var urls = getUrls();
            testHasUrl = url;
            if (urls.length == 0) {
                urls.push(option.initialUrl);
            }
            if (!urls.some(hasUrl)) {
                urls.push(url);
            }
            localStorage.setItem(deepLinkKey, JSON.stringify(urls));
        }
        function popUrl() {
            if (!window.Features.supportsLocalStorage()) return false;
            var urls = getUrls();
            var url = urls.pop();
            if (url == lastLoadedUrl)   // ignore current url on stack
                url = urls.pop();
            localStorage.setItem(deepLinkKey, JSON.stringify(urls));
            return url;
        }
        function hasUrl(element, index, array) {
            return (testHasUrl == element);
        }
        function loadStyle() {
            var view = $(option.contentElement);
            var viewParent = $(view).parent();
            try {
                if (view.length == 1) {
                    view.css("overflow", "auto");
                    viewParent.css("margin", "4px");
                    $("<link/>", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "css/LinkLoad.css"
                    }).appendTo("head");
                }
            } catch (e) { }
        }
        function clearStyle() {
            var view = $(option.contentElement);
            try {
                if (view.length == 1) {
                    $("<link/>", {
                        rel: "stylesheet",
                        type: "text/css",
                        href: "css/LinkUnload.css"
                    }).appendTo("head");
                }
            } catch (e) { }
        }
        function reset() {
            clearLastRootElementsCount();
            clearLocalStorage();
        }
        function clearLastRootElementsCount() {
            lastRootElementsCount = 0;
        }
        function clearLocalStorage() {
            if (window.Features.supportsLocalStorage())
                delete localStorage[deepLinkKey];
        }
        function customBackButtonHandler(e) {
            clearLastRootElementsCount();
            var url = popUrl();
            if (typeof url === "string") {
                loadUrl(url, false);
                e.cancel = true;
                return;
            }
            resetBackButton();
            clearStyle();
            catchClickDestroy();
            e.cancel = false;
        }
        function overrideBackButton() {
            if (!AcTransitMobi.app.navigatingBack.has(customBackButtonHandler))
                AcTransitMobi.app.navigatingBack.add(customBackButtonHandler);
        }
        function resetBackButton() {
            if (AcTransitMobi.app.navigatingBack.has(customBackButtonHandler))
                AcTransitMobi.app.navigatingBack.remove(customBackButtonHandler);
        }
        function back() {
            try {
                (new DevExpress.framework.dxCommand({ action: "#_back" })).execute();
            } catch (e) { }
        }
        return {
            // Public methods and variables
            CatchContentChangedEvent: function (options) {
                option = jQuery.extend({}, defaultOption);
                catchContentChanged(options);
                overrideBackButton();
            },
            CatchClick: function (options) {
                option = jQuery.extend({}, defaultOption);
                catchClick(options);
                overrideBackButton();
            },
            Reset: reset
        };
    };
    return {
        getInstance: function () {
            if (!instance) {
                instance = init();
            }
            return instance;
        }
    };
})();

// site.js -->

window.Features = window.Features || {};
window.Features.supportsLocalStorage = function () {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
}

window.utils = window.utils || {};

window.utils.wrapURLs = function (text, new_window) {

    var targetUrl = location.protocol + "//" + location.host + '/index.html?RedirUri=/$1#Article';

    var urlPattern = /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/ig;

    var target = (new_window === true || new_window == null) ? '_blank' : '';

    return text.replace(urlPattern, function (url) {
        var protocolPattern = /^(?:(?:https?|ftp):\/\/)/i;
        var href = protocolPattern.test(url) ? url : 'http://' + url;
        for (var i = 0; i <= wordPressHosts.length - 1; i++) {
            var searchUrl = new RegExp(wordPressHosts[i] + '/[?]p=(\\d+)', 'gi');
            href = href.replace(searchUrl, targetUrl);
            url = url.replace(searchUrl, targetUrl);
        }
        return '<a href="' + href + '" target="' + target + '">' + url + '</a>';
    });
};

window.utils.htmlDecode = function (input) {
    var e = document.createElement('div');
    e.innerHTML = input;
    var result = e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    delete e;
    return result;
}
window.utils.getUrlParameterByName = function (name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
window.utils.getUrlParameterByNameForHash = function (name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.hash);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
window.utils.loadGA = function () {
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
}
window.utils.triggerGA = function (page, title) {
    window.setTimeout(function () {
        if (typeof ga === "undefined") {
            window.utils.loadGA();
            ga('create', 'UA-50301758-1', 'auto');
        }
        ga('send', 'pageview', { 'page': page, 'title': title });
    }, 1);
}
window.utils.resizeCentered = function (offsetY) {
    function resize() {
        var windowWidth = document.documentElement.clientWidth;
        var windowHeight = document.documentElement.clientHeight;
        var el = $('.centered');
        var elWidth = el.width();
        var elHeight = el.height();
        el.css({
            position: 'absolute',
            top: (windowHeight / 2) - (elHeight / 2) + offsetY,
            left: (windowWidth / 2) - (elWidth / 2),
        });
    };
    resize();
    $(window).resize(function () {
        resize();
    });
}
window.utils.verticalCenterDivs = function (outer, middle, inner, hCenter, hCenterWidth) {
    function move() {
        $(outer).css("display", "table").css("position", "absolute").css("height", "100%").css("width", "100%");
        $(middle).css("display", "table-cell").css("vertical-align", "middle");
        $(inner).css("margin-left", "auto").css("margin-right", "auto");
        if (typeof hCenter !== "undefined" && hCenter)
            $(inner).css("width", hCenterWidth).css("margin", "0 auto");
    };
    move();
    $(window).resize(function () {
        move();
    });
}
window.utils.resizeHeight = function () {
    function resize() {
        var windowWidth = document.documentElement.clientWidth;
        var windowHeight = document.documentElement.clientHeight;
        var el = $('.centered');
        var elWidth = el.width();
        var elHeight = el.height();
        el.css({
            position: 'absolute',
            top: (windowHeight / 2) - (elHeight / 2) - 50,
            left: (windowWidth / 2) - (elWidth / 2),
        });
    };
    resize();
    $(window).resize(function () {
        resize();
    });
}
window.utils.GetAppliesToLine = function (Terms) {
    var lines = '';
    for (var i = 0; i <= Terms.length - 1; i++) {
        if (lines == '')
            lines = Terms[i].Name;
        else
            lines = lines + ", " + Terms[i].Name;
    }
    return lines;
}
window.utils.fixContent = function (content) {
    var result = '<pre id="ArticleContent">' + content + '</pre>';
    //var allLines = content.split(/[\r\n]{4}/g);
    //for (var i in allLines) {
    //    var isEmpty = allLines[i].trim() == '';
    //    result += isEmpty ? '' : '<p>' + allLines[i].replace(/[\r\n]{2}/g, '\r\n<br />') + '</p>\r\n\r\n';
    //}
    return result;
}
window.utils.fixUrls = function (content) {
    var result = utils.fixContent(content);
    var targetUrl = currentHost + '/index.html?RedirUri=/$1#Article';
    for (var i = 0; i <= wordPressHosts.length - 1; i++) {
        var search = new RegExp(wordPressHosts[i] + '/[?]p=(\\d+)', 'gi');
        result = result.replace(search, targetUrl);
    }
    return result;
}
window.utils.QueryString = function (key) {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars[key];
}
window.utils.initialLoad = function () {
    try {
        if (typeof window.utils.QueryString('debug') === 'string') {
            $("#debugButton").attr("style", "display:visible");//.click(function() {
            //$('<script/>', {
            //    type: 'text/javascript',
            //    src: 'http://stevesouders.com/mobileperf/mobileperfbkm.js'
            //}).appendTo("body");
            //});
        }
    } catch (e) { }
}
window.utils.isApp= function() {
    var app = window.utils.QueryString('app');
    if (app != null) {
        var s = app.split('#');
        return s[0] == '1';
    }
    return false;
}
if (window.utils.isApp()) {
    $("body").addClass("app");
}


window.utils.GotoView = function (url) {
    try {
        (new DevExpress.framework.dxCommand({ action: url })).execute();
    } catch (e) { }
}

window.utils.LoadDeviceStyle = function () {
    var device = DevExpress.devices.current();
    switch (device.platform) {
        case 'android':
            $("<link/>", {
                rel: "stylesheet",
                type: "text/css",
                href: "css/dx.android.holo-light2.css"
            }).appendTo("head");
            break;
        case 'ios':
            $("<link/>", {
                rel: "stylesheet",
                type: "text/css",
                href: "css/dx.ios.default.css"
            }).appendTo("head");
            break;
        case 'tizen':
            $("<link/>", {
                rel: "stylesheet",
                type: "text/css",
                href: "css//dx.tizen.white.css"
            }).appendTo("head");
            break;
        case 'win8':
            $("<link/>", {
                rel: "stylesheet",
                type: "text/css",
                href: "css/dx.win8.white.css"
            }).appendTo("head");
            break;
        case 'generic':
            window.setTimeout(function () {
                $("<link/>", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: "css/dx.desktop.default.css"
                }).appendTo("head");
            }, 1);
            window.setTimeout(function () {
                $("<link/>", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: "css/dx.generic.light.css"
                }).appendTo("head");
            }, 1);
            break;
    }
    try {
        if ($('#loadingSpinner').length > 0)
            $('#loadingSpinner').remove();
    } catch (e) { }
}
window.utils.LoadDeviceStyle();

// app.config.js

function getQueryStringValue(key) {
    return unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

window.AcTransitMobi = $.extend(true, window.AcTransitMobi, {
    "config": {
        "navigationType": "navbar",
        "navigation": [
            {
                title: "Home",
                action: "#home",
                icon: "home",
                "background-color": "blue"
            },
            {
                title: "Feedback",
                action: "#Feedback",
                iconSrc: "Images/contact_small.png",
                alt:"Feedback"
            },
            {
                title: "Careers",
                action: "https://www.governmentjobs.com/careers/actransit",
                iconSrc: "images/careers-small.png",
                alt:"Careers"
            },
            {
                title: "Full Site",
                action: mainDomain + (decodeURIComponent(utils.getUrlParameterByName("ReturnUri").replace(/\+/g, " ")) || utils.getUrlParameterByName("RedirUri") || utils.getUrlParameterByNameForHash("RedirUri")),
                icon: "globe"
            }
        ]
    }
});

// index.js

window.AcTransitMobi = window.AcTransitMobi || {};

var Zoom = {
    enableViewPort: 'width=device-width, minimum-scale=1.0, maximum-scale=10.0, initial-scale=1.0',
    disableViewPort: 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0',

    enable: function () {
        var me = Zoom;
        var viewportmeta = document.querySelector('meta[name="viewport"]');
        if (viewportmeta) {
            viewportmeta.content = me.enableViewPort;
        }
    },
    disable: function () {
        var me = Zoom;
        var viewportmeta = document.querySelector('meta[name="viewport"]');
        if (viewportmeta) {
            viewportmeta.content = me.disableViewPort;
        }
    },
    isEnabled: function () {
        try {
            var me = Zoom;
            var viewportmeta = document.querySelector('meta[name="viewport"]');
            if (typeof viewportmeta === "undefined" || viewportmeta == null) return false;
            return viewportmeta.content == me.enableViewPort;
        } catch (e) {
            return false;
        }
    }
};

$(function () {
    // Uncomment the line below to disable platform-specific look and feel and to use the Generic theme for all devices
    // DevExpress.devices.current({ platform: "generic" });
    AcTransitMobi.app = new DevExpress.framework.html.HtmlApplication({
        namespace: AcTransitMobi,
        navigationType: AcTransitMobi.config.navigationType,
        navigation: AcTransitMobi.config.navigation,
        viewPort: { allowZoom: true, allowPan: true }
    });

    try {
        Zoom.disable();
    }
    catch (e) {
    }
    AcTransitMobi.app.router.register(":view/:id", { view: "home", id: undefined });
    //AcTransitMobi.app.router.register(":view/:rt/:stpid/:tripid/", { view: "RealTimeDetailsByStop", rt: undefined, stpid: undefined, tripid: undefined });
    AcTransitMobi.app.router.register(":view/:rt/:rtdir/:stpid/", { view: "RealTimeDetailsByStop", rt: undefined, stpid: undefined, rtdir: undefined });

    AcTransitMobi.app.currentViewModel = null;

    AcTransitMobi.app.navigate();
    (function () {
        // Validation plugin support code
        var temp = window.document.createElement("div");

        function getObservableForProp(element, widgetName, propName) {
            temp.setAttribute("data-bind", element.getAttribute('data-bind'));
            var o = ko.bindingProvider.instance.getBindings(temp, ko.contextFor(element));
            return o[widgetName][propName];
        }

        var makedxBindingHandlerValidatable = function (handlerName) {

            var init = ko.bindingHandlers[handlerName].init;

            ko.bindingHandlers[handlerName].init = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

                init(element, valueAccessor, allBindingsAccessor);

                valueAccessor = function () { return getObservableForProp(element, handlerName, "value"); };
                return ko.bindingHandlers.validationCore.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
            };
        };
        // Enable validation for any particular bindings if needed
        // NOTE: bindings MUST have valid "value" property
        makedxBindingHandlerValidatable("dxTextBox");
        makedxBindingHandlerValidatable("dxNumberBox");
        makedxBindingHandlerValidatable("dxTextArea");
        makedxBindingHandlerValidatable("dxLookup");
    })();
});

if (!Object.keys) {
    Object.keys = function (obj) {
        var keys = [];

        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                keys.push(i);
            }
        }

        return keys;
    };
}

// db.js -->

(function () {
    "use strict";

    AcTransitMobi.LostItems = function () {
        var lostFoundItems = "Select...:|Bags and Luggage: Backpack; Briefcase; Duffle bag; Lunchbox; Messenger Bag; Shopping Bag; Suitcase; Tote Bag; Other |Bank Cards and IDs: Debit/Credit Card; Drivers License; Membership Card/ID; Passport; School ID; State ID; Work ID/Badge; Other |Clothing: Gloves; Hat; Jacket/Coat; Pants; Scarf; Shirt; Shoes/Boots; Sweatshirt/Hoodie; Uniform; Other |Electronics: Accessory (cables, cases, etc.); Audio Player; Cell Phone; eReader (Kindle, etc.); Headphones/Earbuds; Laptop; Media (DVD, Flash Drive, etc.); Tablet; Video Game; Other |Jewelry and Cash: U.S. Currency; Foreign Currency; Bracelet; Earrings; Necklace; Ring; Watch; Other |Medical: Cane; Crutches; Hearing Aid; Medication; Walker; Other |Musical Instruments: Flute; Guitar; Saxophone; Trombone; Trumpet; Violin/Viola; Other |Personal Items: Eyeglasses; Keys; Purse; Wallet; Sunglasses; Umbrella; Other |Printed Materials: Artwork; Book; Event Tickets; Folder/Binder; Notebook; Paperwork/Documents; Photos; Other |Sporting Equipment and Toys: Bicycle; Bike Lock; Fitness Tracker/Watch; Helmet; Skateboard; Scooter; Toy; Uniform/Shoes; Water Bottle; Other |Transit Tickets and Passes: Adult Clipper Card; Youth Clipper Card; Senior Clipper Card; RTC Card; Paper Pass; Other Agencys Pass or Ticket |Other: Weapon; Perishables/Food; Tools; Other"
        var lostFoundCategories = lostFoundItems.split('|');
        var lostFound = {};
        for (var i = 0; i < lostFoundCategories.length; i++) {
            var keyValueDelim = lostFoundCategories[i].indexOf(':');
            if (keyValueDelim == -1) continue;
            var category = jQuery.trim(lostFoundCategories[i].substring(0, keyValueDelim));
            var types = jQuery.trim(lostFoundCategories[i].substring(keyValueDelim + 1));
            lostFound[category] = types.split(';');
            for (var j = 0; j < lostFound[category].length; j++)
                lostFound[category][j] = jQuery.trim(lostFound[category][j]);
        }
        return lostFound;
    }

    AcTransitMobi.db = {
        "sampleData": new DevExpress.data.DataSource({
            /// Implementation of load operation. Accepts a bag of "load options" (object) which are: sort, filter, group, select, skip, take. 
            /// Must return array or promise(array).
            load: function (loadOptions) {
                return $.ajax("/data/sampleData.json");
            },
            /// User implementation of loading single item by key. Accepts key value.
            /// Must return object or promise(object).
            byKey: function (key) {
                throw new Error("Not implemented");
            },
            /// User implementation of insertion. Accepts bag of data values. 
            /// Return value is not required. If present must be key value or promise of key value.
            insert: function (values) {
                throw new Error("Not implemented");
            },
            /// User implementation of update. Accepts key and bag of data values (object key, object values). 
            /// If returns promise, then considered async, otherwise return value is ignored.
            update: function (key, values) {
                throw new Error("Not implemented");
            },
            /// User implementation of remove. Accepts key value.
            /// If returns promise, then considered async, otherwise return value is ignored.
            remove: function (key) {
                throw new Error("Not implemented");
            },
            /// User implementation of total count evaluation. Accepts arguments same as load. 
            /// Must return Number or promise(Number)
            totalCount: function (options) {
                throw new Error("Not implemented");
            },
        }),
        "logoItem": function (a, b, c) {            
            var view = AcTransitMobi.app.navigationManager.currentUri;
            if ($.inArray(view, ["", "home"]) != -1)
                return { location: 'center', template: 'header-logo', options: { visible: true } };                    
            else if (view && (
                        view.toString().indexOf('actrealtime') == 0 ||
                        view && view.toString().indexOf('RealTimeDetailsByStop') == 0
                )) {                
                return { location: 'right', template: 'actrealtime-header', visible: true, options: { visible: true } };
            }
              
            return { location: 'center', template: 'generic-header', visible: true, options: { visible: true } };
            //return { visible: false };
        },
        //Datasource for State......
        dsState: [
       { name: "Alabama", id: "AL" },
       { name: "Alaska", id: "AK" },
       { name: "American Samoa", id: "AS" },
       { name: "Arizona", id: "AZ" },
       { name: "Arkansas", id: "AR" },
       { name: "California", id: "CA" },
       { name: "Colorado", id: "CO" },
       { name: "Connecticut", id: "CT" },
       { name: "Delaware", id: "DE" },
       { name: "District of Columbia", id: "DC" },
       { name: "Federated States of Micronesia", id: "FM" },
       { name: "Florida", id: "FL" },
       { name: "Georgia", id: "GA" },
       { name: "Guam", id: "GU" },
       { name: "Hawaii", id: "HI" },
       { name: "Idaho", id: "ID" },
       { name: "Illinois", id: "IL" },
       { name: "Indiana", id: "IN" },
       { name: "Iowa", id: "IA" },
       { name: "Kansas", id: "KS" },
       { name: "Kentucky", id: "KY" },
       { name: "Louisiana", id: "LA" },
       { name: "Maine", id: "ME" },
       { name: "Marshall Islands", id: "MH" },
       { name: "Maryland", id: "MD" },
       { name: "Massachusetts", id: "MA" },
       { name: "Michigan", id: "MI" },
       { name: "Minnesota", id: "MN" },
       { name: "Mississippi", id: "MS" },
       { name: "Missouri", id: "MO" },
       { name: "Montana", id: "MT" },
       { name: "Nebraska", id: "NE" },
       { name: "Nevada", id: "NV" },
       { name: "New Hampshire", id: "NH" },
       { name: "New Jersey", id: "NJ" },
       { name: "New Mexico", id: "NM" },
       { name: "New York", id: "NY" },
       { name: "North Carolina", id: "NC" },
       { name: "North Dakota", id: "ND" },
       { name: "Northern Mariana Islands", id: "MP" },
       { name: "Ohio", id: "OH" },
       { name: "Oklahoma", id: "OK" },
       { name: "Oregon", id: "OR" },
       { name: "Palau", id: "PW" },
       { name: "Pennsylvania", id: "PA" },
       { name: "Puerto Rico", id: "PR" },
       { name: "Rhode Island", id: "RI" },
       { name: "South Carolina", id: "SC" },
       { name: "South Dakota", id: "SD" },
       { name: "Tennessee", id: "TN" },
       { name: "Texas", id: "TX" },
       { name: "Utah", id: "UT" },
       { name: "Vermont", id: "VT" },
       { name: "Virgin Islands", id: "VI" },
       { name: "Virginia", id: "VA" },
       { name: "Washington", id: "WA" },
       { name: "West Virginia", id: "WV" },
       { name: "Wisconsin", id: "WI" },
       { name: "Wyoming", id: "WY" }

        ],
        //DataSource for FeedBack view
        dsFeedBack: [
            { id: 1, name: "Report an Incident or General Comment", action: "incident" },
            { id: 4, name: "Report a Lost Item", action: "lostfound" },
            { id: 5, name: "Report Dirty Bus Shelter", action: "busshelter" }
        ],
        //dsFeedBack: [
        //    { id: 1, name: "Report an Incident or General Comment", action: "incident" },
        //    { id: 2, name: "Ask a Question", action: "ask" },
        //    { id: 3, name: "Make a Suggestion", action: "suggestion" },
        //    { id: 4, name: "Report a Lost Item", action: "lostfound" }
        //],
        //DataSource for LineDescrption......
        AllLineDescription: [{ KeyValue: { Key: "local1", Value: "Local" } },
            { KeyValue: { "Key": "Transbay", "Value": "Transbay" } },
            { KeyValue: { "Key": "All Nighter", "Value": "All Nighter" } },
            { KeyValue: { "Key": "Service to Schools", "Value": "Service to Schools" } },
            { KeyValue: { "Key": "Early Bird", "Value": "Early Bird" } }],

        dsResponseVia: [
        { name: "None", id: 0 },
        { name: "Phone", id: 2 },
        { name: "Email", id: 3 }
        ],

        //DataSource for Category.........
        //dataSourceCategory: [{ Value: "Local", id: 1 },
        //{ Value: "Transbay", id: 2 },
        //{ Value: "All Nighter", id: 3 },
        //{ Value: "School", id: 4 },
        //{ Value: "Early Bird", id: 6 },
        //{ Value: "All Lines", id: 5 },
        //]
    };
})();

// NavbarLayout.js -->

(function ($, DX, undefined) {
    var HAS_NAVBAR_CLASS = "has-navbar",
        HAS_TOOLBAR_CLASS = "has-toolbar",
        HAS_TOOLBAR_BOTTOM_CLASS = "has-toolbar-bottom",
        TOOLBAR_BOTTOM_ACTIVE_CLASS = "dx-appbar-active",
        SEMI_HIDDEN_CLASS = "semi-hidden",
        TOOLBAR_BOTTOM_SELECTOR = ".layout-toolbar-bottom.win8",
        ACTIVE_PIVOT_ITEM_SELECTOR = ".dx-pivot-item:not(.dx-pivot-item-hidden)",
        LAYOUT_FOOTER_SELECTOR = ".layout-footer",
        ACTIVE_TOOLBAR_SELECTOR = ".dx-active-view .dx-toolbar";
    DX.framework.html.NavBarController = DX.framework.html.DefaultLayoutController.inherit({
        _getLayoutTemplateName: function () {
            return "navbar"
        },
        _createNavigation: function (navigationCommands) {
            this.callBase(navigationCommands);
            var $navbar = this._$mainLayout.find(".navbar-container");
            if ($navbar.length && navigationCommands) {
                var container = $navbar.dxCommandContainer("instance");
                this._commandManager._arrangeCommandsToContainers(navigationCommands, [container]);
                this._$mainLayout.addClass(HAS_NAVBAR_CLASS)
            }
        },
        _showViewImpl: function (viewInfo) {
            var self = this;
            return self.callBase.apply(self, arguments).done(function () {
                var $toolbar = self._$mainLayout.find(LAYOUT_FOOTER_SELECTOR).find(ACTIVE_TOOLBAR_SELECTOR),
                    isToolbarEmpty = !$toolbar.length || !$toolbar.dxToolbar("instance").option("visible");
                self._$mainLayout.toggleClass(HAS_TOOLBAR_CLASS, !isToolbarEmpty)
            })
        }
    });
    popupWebAppVisible = ko.observable(false);
    $(document).ready(function () {
        AcTransitMobi.app.viewShown.add(function (args) {
            var isApp = window.utils.isApp();
            var viewModel = args.viewInfo.model,
                uri = args.viewInfo.uri,
                direction = args.direction;
            var dev = DevExpress.devices.current();
            if (dev.win8) return;               
            //$(".dx-content-placeholder-content").attr("style", "height: 80%; bottom: 59px;");
            var uri = args.viewInfo.uri;
            if (uri.indexOf("/") > -1)
                uri = args.viewInfo.uri.split("/")[0];
            if ($.inArray(uri, ["LineMap"]) !== -1 || args.viewInfo.uri.indexOf("NoFooter") > -1) {
                $(".layout-footer").hide();
                $(".dx-theme-generic .navbar-layout .layout-content").css("bottom", "0");
                $(".navbar-layout.has-navbar .layout-content").css("bottom", "0");
            }
            else {
                $(".layout-footer").show();
                $(".dx-theme-generic .navbar-layout .layout-content").css("bottom", $(".navbar-layout .layout-footer").height());
                $(".navbar-layout.has-navbar .layout-content").css("bottom", $(".navbar-layout .layout-footer").height());
            }

            if (isApp) {
                $(".dx-content-placeholder-content").attr("style", "bottom: 5px;");
            }

            var isHomePage = (($.inArray(args.viewInfo.uri, ["", "home"]) !== -1));
            $(".header-logo-image").css("display", (isHomePage ? "block" : "none"));
            if (isHomePage) {
                popupWebAppVisible(true);
                try {
                    addToHomescreen({
                        skipFirstVisit: true,
                        maxDisplayCount: 1,
                        debug: true
                    });
                }
                catch (e) { }
            }
        });
    });
    homeViewShow = function () {
        localStorage.setItem("seenPopupWebAppCount", 0);
        //AcTransitMobi.app.navigate({ view: "home" });
        location.href = "index.html";
    }
    goBack = function (e) {
        parent.history.back();
    }
    linkOpenNewTabforeFullSite = function (data) {
        window.open(mainDomain, '_blank');
    }
    DX.framework.html.layoutControllers.push({
        navigationType: "navbar",
        platform: "ios",
        controller: new DX.framework.html.NavBarController
    });
    DX.framework.html.layoutControllers.push({
        navigationType: "navbar",
        platform: "android",
        controller: new DX.framework.html.NavBarController
    });
    DX.framework.html.layoutControllers.push({
        navigationType: "navbar",
        platform: "tizen",
        controller: new DX.framework.html.NavBarController
    });
    DX.framework.html.layoutControllers.push({
        navigationType: "navbar",
        platform: "generic",
        controller: new DX.framework.html.NavBarController
    });
    DX.framework.html.layoutControllers.push({
        navigationType: "split",
        platform: "win8",
        phone: false,
        root: true,
        controller: new DX.framework.html.NavBarController
    });
})(jQuery, DevExpress);

// PivotLayout.js -->

(function ($, DX, undefined) {
    var HAS_TOOLBAR_BOTTOM_CLASS = "has-toolbar-bottom",
        TOOLBAR_BOTTOM_SELECTOR = ".layout-toolbar-bottom",
        ACTIVE_PIVOT_ITEM_SELECTOR = ".dx-pivot-item:not(.dx-pivot-item-hidden)",
        LAYOUT_FOOTER_SELECTOR = ".layout-footer";
    DX.framework.html.PivotLayoutController = DX.framework.html.DefaultLayoutController.inherit({
        init: function (options) {
            this.callBase(options);
        },
        _getLayoutTemplateName: function () {
            return "pivot";
        },
        _createNavigation: function (navigationCommands) {
            var self = this;
            this.$root = $("<div/>").addClass("pivot-layout").appendTo(this._$hiddenBag);
            this.$pivot = $("<div/>").appendTo(this.$root).dxPivot({
                itemRender: function (itemData, itemIndex, itemElement) {
                    var emptyLayout = self._createEmptyLayout();
                    emptyLayout.find(".layout-footer").remove();
                    emptyLayout.appendTo(itemElement);
                }
            }).dxCommandContainer({ id: 'global-navigation' });
            this.$footer = self._createEmptyLayout().find(".layout-footer").insertAfter(this.$pivot);
            var container = this.$pivot.dxCommandContainer("instance");
            this._commandManager._arrangeCommandsToContainers(navigationCommands, [container]);
        },
        _getRootElement: function () {
            return this.$root;
        },
        _getViewFrame: function (viewInfo) {
            var $result = this.$pivot.find(ACTIVE_PIVOT_ITEM_SELECTOR);
            $result = $result.add(this.$footer);
            return $result
        },
        _showViewImpl: function (viewInfo, direction) {
            this._showViewElements(viewInfo.renderResult.$markup);
            this._changeView(viewInfo);
            this._changeAppbar();
            return $.Deferred().resolve().promise();
        },
        _changeAppbar: function () {
            var $appbar = this.$footer.find(".dx-active-view " + TOOLBAR_BOTTOM_SELECTOR),
                appbar = $appbar.data("dxToolbar");
            if (appbar)
                this._refreshAppbarVisibility(appbar, this.$root);
        },
        _refreshAppbarVisibility: function (appbar, $container) {
            var isAppbarNotEmpty = false;
            $.each(appbar.option("items"), function (index, item) {
                if (item.visible) {
                    isAppbarNotEmpty = true;
                    return false;
                }
            });
            $container.toggleClass(HAS_TOOLBAR_BOTTOM_CLASS, isAppbarNotEmpty);
            appbar.option("visible", isAppbarNotEmpty);
        },
        _hideView: function (viewInfo) {
            this.callBase.apply(this, arguments);
            this._changeAppbar();
        }
    });
    DX.framework.html.layoutControllers.push({
        navigationType: "navbar",
        platform: "win8",
        phone: true,
        root: true,
        controller: new DX.framework.html.PivotLayoutController
    });
})(jQuery, DevExpress);

// SimpleLayout.js -->

//(function ($, DX, undefined) {
//    DX.framework.html.SimpleLayoutController = DX.framework.html.DefaultLayoutController.inherit({
//        _getLayoutTemplateName: function () {
//            return "simple";
//        }
//    });
//    var HAS_TOOLBAR_BOTTOM_CLASS = "has-toolbar-bottom",
//        TOOLBAR_BOTTOM_SELECTOR = ".layout-toolbar-bottom";
//    DX.framework.html.Win8SimpleLayoutController = DX.framework.html.SimpleLayoutController.inherit({
//        _showViewImpl: function (viewInfo) {
//            var self = this,
//                result = self.callBase.apply(self, arguments),
//                $frame = self._getViewFrame(),
//                $appbar = $frame.find(TOOLBAR_BOTTOM_SELECTOR);
//            $appbar.each(function (i, element) {
//                var $element = $(element);
//                appbar = $element.dxToolbar("instance");
//                if (appbar) {
//                    self._refreshAppbarVisibility(appbar, $frame);
//                    appbar.optionChanged.add(function(optionName, optionValue) {
//                        if (optionName === "items")
//                            self._refreshAppbarVisibility(appbar, $frame);
//                    });
//                }
//            });
//            return result;
//        },
//        _refreshAppbarVisibility: function (appbar, $content) {
//            var isAppbarNotEmpty = false;
//            $.each(appbar.option("items"), function (index, item) {
//                if (item.visible) {
//                    isAppbarNotEmpty = true;
//                    return false;
//                }
//            });
//            $content.toggleClass(HAS_TOOLBAR_BOTTOM_CLASS, isAppbarNotEmpty);
//            appbar.option("visible", isAppbarNotEmpty);
//        }
//    });

//    DX.framework.html.layoutControllers.push({
//        navigationType: "navbar",
//        platform: "win8",
//        root: false,
//        phone: true,
//        controller: new DX.framework.html.Win8SimpleLayoutController
//    });
//    DX.framework.html.layoutControllers.push({
//        navigationType: "navbar",
//        platform: "android",
//        root: false,
//        controller: new DX.framework.html.SimpleLayoutController
//    });
//    DX.framework.html.layoutControllers.push({
//        navigationType: "simple",
//        platform: "ios",
//        controller: new DX.framework.html.SimpleLayoutController
//    });
//    DX.framework.html.layoutControllers.push({
//        navigationType: "simple",
//        platform: "android",
//        controller: new DX.framework.html.SimpleLayoutController
//    });
//    DX.framework.html.layoutControllers.push({
//        navigationType: "simple",
//        platform: "tizen",
//        controller: new DX.framework.html.SimpleLayoutController
//    });
//    DX.framework.html.layoutControllers.push({
//        navigationType: "simple",
//        platform: "generic",
//        controller: new DX.framework.html.SimpleLayoutController
//    });
//    DX.framework.html.layoutControllers.push({
//        navigationType: "simple",
//        platform: "win8",
//        phone: true,
//        controller: new DX.framework.html.Win8SimpleLayoutController
//    });
//})(jQuery, DevExpress);



///-------------------------------------------------------Created specially for Contactus, under the Test --------------------------------------

var ACTransit = {
    MenuButton: function MenuButton(objectToMove) {
        var _menu;
        var _menuStr;
        var _objectToMove;
        var _alreadyMoved = false;
        this.initial = function (objectToMove) {
            _objectToMove = objectToMove;
            _menuStr = "<div class='ACTransit MenuButton navbar'><div class='navbar-header'><button type='button' class='navbar-toggle' title='Menu'><span class='sr-only'>Toggle navigation</span><span class='icon-bar'></span><span class='icon-bar'></span><span class='icon-bar'></span></button></div><div class='dropdown'></div></div>";
        };
        this.moveToMenu = function () {
            if (_alreadyMoved) return;
            var me = this;
            _menu = $(_menuStr).insertBefore($(_objectToMove));
            try {
                var holder = $(".dropdown", _menu);
                $("div.navbar-header>button", _menu).click(null, function () {
                    me.close();
                });
                $(_objectToMove).click(function () {
                    me.close();
                });
                $(_objectToMove).detach();
                $(_objectToMove).appendTo(holder);
            }
            catch (e) {
                alert(e.message);
            }
            _alreadyMoved = true;
        }
        ;
        this.close = function () {
            $(".dropdown", _menu).slideToggle();
        };
        this.undo = function () {
            if (!_alreadyMoved) return;
            $("div.navbar-header>button", _menu).unbind('click');
            $(_objectToMove).detach();
            $(_objectToMove).insertAfter($(_menu));
            $(_menu).detach();
            _alreadyMoved = false;
        };
        return this.initial(objectToMove);
    }
}
///-------------------------------------------------------Created specially for Contactus, under the Test --------------------------------------

/*
	lazyLoadGoogleMaps v1.0.1, updated 2015-11-07
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
    http://osvaldas.info/lazy-loading-google-maps
*/

window.googleMapsScriptLoaded = function () {
    $(window).trigger('googleMapsScriptLoaded');
};

; (function ($, window, document, undefined) {
    'use strict';

    var $window = $(window),
		$body = $('body'),
		windowHeight = $window.height(),
		windowScrollTop = 0,

		debounce = function (delay, fn) {
		    var timer = null;
		    return function () {
		        var context = this, args = arguments;
		        clearTimeout(timer);
		        timer = setTimeout(function () { fn.apply(context, args); }, delay);
		    };
		},
		throttle = function (delay, fn) {
		    var last, deferTimer;
		    return function () {
		        var context = this, args = arguments, now = +new Date;
		        if (last && now < last + delay) {
		            clearTimeout(deferTimer);
		            deferTimer = setTimeout(function () { last = now; fn.apply(context, args); }, delay);
		        }
		        else {
		            last = now;
		            fn.apply(context, args);
		        }
		    };
		},

		apiScriptLoaded = false,
		apiScriptLoading = false,
		$containers = $([]),

		init = function (callback) {
		    windowScrollTop = $window.scrollTop();

		    $containers.each(function () {
		        var $this = $(this),
					thisOptions = $this.data('options');

		        if ($this.offset().top - windowScrollTop > windowHeight * 1)
		            return true;

		        if (!apiScriptLoaded && !apiScriptLoading) {
		            var apiArgs =
					{
					    callback: 'googleMapsScriptLoaded',
					    signed_in: thisOptions.signed_in
					};

		            if (thisOptions.api_key) apiArgs.key = thisOptions.api_key;
		            if (thisOptions.libraries) apiArgs.libraries = thisOptions.libraries;
		            if (thisOptions.language) apiArgs.language = thisOptions.language;
		            if (thisOptions.region) apiArgs.region = thisOptions.region;
		            if (thisOptions.sensor) apiArgs.sensor = thisOptions.sensor;

		            $body.append('<script src="https://maps.googleapis.com/maps/api/js?v=3&' + $.param(apiArgs) + '"></script>');
		            apiScriptLoading = true;
		        }

		        if (!apiScriptLoaded) return true;

		        var map = new google.maps.Map(this, { zoom: thisOptions.zoom });
		        if (thisOptions.callback !== false)
		            thisOptions.callback(this, map);

		        $containers = $containers.not($this);
		    });
		};

    $window
	.on('googleMapsScriptLoaded', function () {
	    apiScriptLoaded = true;
	    init();
	})
	.on('scroll', throttle(500, init))
	.on('resize', debounce(1000, function () {
	    windowHeight = $window.height();
	    init();
	}));

    $.fn.lazyLoadGoogleMaps = function (options) {
        options = $.extend(
					{
					    api_key: false,
					    libraries: false,
					    signed_in: false,
					    language: false,
					    region: false,
					    callback: false,
					    sensor: false,
					},
					options);

        this.each(function () {
            var $this = $(this);
            $this.data('options', options);
            $containers = $containers.add($this);
        });

        init();

        this.debounce = debounce;
        this.throttle = throttle;

        return this;
    };

})(jQuery, window, document);


AcTransitMobi.FindMe = {
    options: {},
    toRad: function(Value) {
        return Value * Math.PI / 180;
    },
    calcDistance:function(lat1, lon1, lat2, lon2) {
        var R = 6371; // km
        var dLat = AcTransitMobi.FindMe.toRad(lat2 - lat1);
        var dLon = AcTransitMobi.FindMe.toRad(lon2 - lon1);
        var lat1 = AcTransitMobi.FindMe.toRad(lat1);
        var lat2 = AcTransitMobi.FindMe.toRad(lat2);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d;
    },
    getLocation: function(callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(callback);
        } else {
            console.error("Geolocation is not supported by this browser")
            callback(null); // Geolocation is not supported by this browser.
        }
    },
    watchPosition: function (callback) {
        if (navigator.geolocation) {
            options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };
            return navigator.geolocation.watchPosition(callback, function() {callback(null);}, options);
        } else {
            console.error("Geolocation is not supported by this browser")
            callback(null); // Geolocation is not supported by this browser.
            return -1;
        }
    },
    clearWatch: function(handle) {
        if (navigator.geolocation && handle!=-1) {
            navigator.geolocation.clearWatch(handle);
        } else {
        }
    },
    start: function (options) {
        var me = this;
        me.WATCH_TIMEOUT = 500, me.CHECK_TIMEOUT = 5000, me.MinAvgCount = 8, me.avgPos = [], me.MIN_ACCURACY = 30, me.MAXIMUM_AGE = 10000;
        $.extend(me.options, options);
        var mapOptions = {
            api_key: HOME.API_KEY,
            libraries: 'geometry', // libraries to load, i.e. 'geometry,places'
            signed_in: false, // sign-in on a map enabled/disabled
            language: 'en-US',
            region: 'US',
            offsetWidth: 0,
            zoom: HOME.zoom,
            callback: me.initApi,
            sensor: true
        };
        //me.scroll(false);
        if (!me.aborted || !me.completed)
            $(me.options.canvas).lazyLoadGoogleMaps(mapOptions);
        me.aborted = false;
        me.completed = true;
    },
    aborted: false,
    completed: true,
    end: function () {
        var me = this;
        clearInterval(me.timer1);
        navigator.geolocation.clearWatch(me.watchId);
    },
    abort: function (options) {
        var me = this;
        me.aborted = true;
        $.extend(me.options, options);
        me.end();
        //me.scroll(true);
    },
    scroll: function (enabled) {
        var me = this;
        me.options.scrolling(enabled);
    },
    initApi: function (container, map) {
        console.log("FindMe ready");
        AcTransitMobi.FindMe.initMap(container, map);
    },
    getCentroid: function (arr) {
        var latXTotal = 0, latYTotal = 0, lonDegreesTotal = 0, currentLatLong;
        for (var i = 0; currentLatLong = arr[i]; i++) {
            var latDegrees = currentLatLong.lat();
            var lonDegrees = currentLatLong.lng();
            var latRadians = Math.PI * latDegrees / 180;
            latXTotal += Math.cos(latRadians);
            latYTotal += Math.sin(latRadians);
            lonDegreesTotal += lonDegrees;
        }
        var finalLatRadians = Math.atan2(latYTotal, latXTotal);
        var finalLatDegrees = finalLatRadians * 180 / Math.PI;
        var finalLonDegrees = lonDegreesTotal / arr.length;
        return new google.maps.LatLng(finalLatDegrees, finalLonDegrees);
    },
    bestPosition: function (pos) {
        var me = this;
        if (pos)
            me.avgPos.push(pos);
        return me.avgPos.length >= me.MinAvgCount ? me.getCentroid(me.avgPos) : null;
    },
    initMap: function (container, map) {
        var me = this;
        me.map = map;
        if (!navigator.geolocation) {
            alert("Geolocation disabled");
            return;
        }
        var marker = new google.maps.Marker({
            map: map,
            draggable: true
        });
        me.marker = marker;
        var info = new google.maps.InfoWindow({ map: map });
        var posOptions = {
            enableHighAccuracy: true,
            timeout: me.WATCH_TIMEOUT,
            maximumAge: me.MAXIMUM_AGE
        };
        var watchRunning = false;

        me.displayCurrPos = false;
        me.watchId = navigator.geolocation.watchPosition(function (currPos) {
            watchRunning = true;
            try {
                var currLatLng = new google.maps.LatLng(currPos.coords.latitude, currPos.coords.longitude);
                if (currPos.coords.accuracy <= me.MIN_ACCURACY) {
                    var bestPos = me.bestPosition(currLatLng);
                    if (bestPos == null) {
                        if (me.avgPos.length == 1)
                            me.geocodePosition(map, currLatLng, marker, info, "Locating..");
                        return;
                    }
                    me.end();
                    me.geocodePosition(map, bestPos, marker, info);
                } else {
                    if (!me.displayCurrPos) {
                        me.displayCurrPos = true;
                        me.geocodePosition(map, currLatLng, marker, info, "Locating..");
                    }
                }
            }
            finally {
                watchRunning = false;
            }
        }, function () {
            me.geocodePosition(map, marker.getPosition(), marker, info, "GPS disabled.");
        }, posOptions);

        google.maps.event.addListener(marker, 'dragstart', function () {
            me.end();
            //me.scroll(false);
        });
        google.maps.event.addListener(marker, 'dragend', function () {
            me.avgPos = []; // marker moved, throw away averages
            me.geocodePosition(map, marker.getPosition(), marker, info);
        });
        // taking too long? cut back duration
        me.timer1 = setInterval(function () {
            if (watchRunning)
                return;
            me.MinAvgCount = Math.floor(me.MinAvgCount / 2);
            var bestPos = me.bestPosition();
            if (bestPos == null)
                return;
            // quit averaging
            me.end();
            if (!isNaN(bestPos.lng()))
                me.geocodePosition(map, bestPos, marker, info);
            else
                me.geocodePosition(map, marker.getPosition(), marker, info, 'GPS failed.  <button onClick=AcTransitMobi.FindMe.start()> Retry? </button>');
        }, me.CHECK_TIMEOUT);
    },
    useDirectionsAPI: false,
    geocodePosition: function (map, pos, marker, info, msg) {
        var me = this;
        me.info = info;
        var mLatLong = pos;
        if (me.aborted) return;
        marker.setPosition(mLatLong);
        map.setCenter(mLatLong);
        if (typeof msg !== "undefined") {
            me.info.setContent(msg);
            me.info.open(map, marker);
            me.completed = false;
            return;
        }
        if (me.snapToRoute(marker))
            return;
        // otherwise, lookup street address
        setLocation = function (address, addressLatLong) {
            address = address.replace(", USA", "").replace(/, CA \d+/g, "") + '  <button onClick=AcTransitMobi.FindMe.start()> Refresh? </button>';
            marker.setPosition(addressLatLong);
            map.setCenter(addressLatLong);
            me.info.setContent(address);
            me.info.open(map, marker);
            me.options.address(address);
            //me.scroll(true);
            console.log("new lat/lng: " + addressLatLong.lat() + "," + addressLatLong.lng());
            me.options.nearbyStops(addressLatLong.lat(), addressLatLong.lng());
            me.completed = true;
        }
        if (me.useDirectionsAPI) {
            var directionsService = new google.maps.DirectionsService();
            var request = {
                origin: mLatLong || marker.getPosition(),
                destination: mLatLong || marker.getPosition(),
                travelMode: google.maps.DirectionsTravelMode.DRIVING
            };
            directionsService.route(request, function (response, status) {
                if (me.aborted) return;
                if (status == google.maps.DirectionsStatus.OK) {
                    var address = response.routes[0].legs[0].start_address;
                    var addressLatLong = response.routes[0].legs[0].start_location;
                    setLocation(address, addressLatLong);
                } else {
                    console.log('directionsService failed: ' + status);
                }
            });
        }
        else {
            var geocoder = new google.maps.Geocoder;
            var addressLatLong = mLatLong || marker.getPosition();
            geocoder.geocode({ 'location': mLatLong || marker.getPosition() }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        var address = results[0].formatted_address;
                        setLocation(address, addressLatLong);
                    } else {
                        console.log('No results found');
                    }
                } else {
                    console.log('Geocoder failed due to: ' + status);
                }
            });
        }
    },
    snapToRoute: function (marker) {
        var me = this;
        // if marker placed on top of another stopMarker, assume same stop
        var nearStopMarkers = me.stopMarker.filter(function (item) {
            item.dist = google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), item.position);
            return item.dist < 25;
        });
        if (nearStopMarkers.length > 0) {
            nearStopMarkers.sort(function (a, b) {
                if (a.dist < b.dist) return -1;
                if (a.dist > b.dist) return 1;
                return 0;
            });
            var stopMarker = nearStopMarkers[0];
            var stop = me.stops.filter(function (item) {
                return stopMarker.title == me.getStopTitle(item);
            });
            if (stop.length == 1) {
                me.options.address(stop[0].StopDescription.replace(":", " and ") + " (" + stop[0].Id511 + ")");
                me.options.routes('e.g. ' + stop[0].FlagRoute);
                marker.setPosition(stopMarker.position);
                me.map.setCenter(stopMarker.position);
                me.info.setContent(me.options.address());
                console.log("snap lat/lng: " + stopMarker.position.lat() + "," + stopMarker.position.lng());
                //me.scroll(true);
                return true;
            }
        }
        return false;
    },
    stopInfo: [],
    stopMarker: [],
    stops: [],
    showNearbyStops: function (stops) {
        var me = this;
        me.stops = stops;
        console.log("Stop count: " + stops.length);
        // clear any previous markers
        for (var i = 0; i < me.stopMarker.length; i++) {
            if (me.stopMarker[i]) {
                if (me.stopMarker[i].infoWindow) {
                    me.stopMarker[i].infoWindow.setMap(null);
                    me.stopMarker[i].infoWindow = null;
                }
                me.stopMarker[i].setMap(null);
            }
        }
        me.stopInfo = [];
        me.stopMarker = [];
        for (var i = 0; i < stops.length; i++) {
            var m = new google.maps.Marker({
                position: new google.maps.LatLng(stops[i].Latitude, stops[i].Longitude),
                map: me.map,
                title: me.getStopTitle(stops[i]),
                icon: "./images/Bus_icon_black.jpg"
            });
            var iw = new google.maps.InfoWindow({
                content: '<div class="info"><p>' + me.getStopTitle(stops[i]) + '</p><p>Routes: ' + stops[i].FlagRoute + '</p><p>Distance: ' + Math.round((stops[i].Distance / 1609.344) * 5280) + 'ft</p></div>',
            });
            me.stopMarkerInfo(m, iw, me.map);
            me.stopMarker.push(m);
            me.stopInfo.push(iw);
        }
        me.snapToRoute(me.marker);
    },
    stopMarkerInfo: function (marker, infoWindow, map) {
        marker.addListener('click', function () {
            var imap = infoWindow.getMap();
            if (imap !== null && typeof imap !== "undefined")
                infoWindow.close();
            else
                infoWindow.open(map, marker);
        });
    },
    getStopTitle: function (stop) {
        return stop.StopDescription.replace(":", " and ") + (stop.Corner !== null ? ' (' + stop.Corner + ' corner)' : '');
    }

}

function getOccupancyTitle(d){
    if (d.attribute && d.attribute.EstimatedOccupancyStatus){
        return (d.attribute.EstimatedOccupancyStatus || "");
        // var estimatedOccupancyStatus=(d.attribute.EstimatedOccupancyStatus || "").toLowerCase();
        // switch (estimatedOccupancyStatus){
        //     case "empty":
        //     case "manyseatsavailable":
        //         return "Not Crowded"; //"many seats available";
        //     case "fewseatsavailable":
        //         return "Some Crowding";// "some seats available";
        //     case "full":
        //         return "Crowded";//"no seats available";
        // }    
    }
    return "";
}
ko.components.register('vehicle-box', {
    viewModel: function(params) {
        // Data: value is either null, 'like', or 'dislike'
        var baseImageUrl='images/bustime/';
        this.data = params.data;         
        this.showPli = params.showPli;
        // Behaviors
        this.getVehicleInfo = function() {
            var p=this.data;
            if (p!=null)
                return p.vid;
            return '';
        }.bind(this);
        this.getOccupancyInfo = function() {            
            var p=this.data;            
            if (p!=null && p.attribute && p.attribute.EstimatedOccupancyPercentage && p.attribute.EstimatedOccupancyPercentage!=null)
                return p.attribute.EstimatedOccupancyPercentage + "% full";
            return '';
        }.bind(this);

        this.getImageAlt = function() {
            var p=this.data;
            return getOccupancyTitle(p);
            // if (p!=null && p.attribute && p.attribute.EstimatedOccupancyStatus && p.attribute.EstimatedOccupancyStatus!=null)
            //     return p.vid + ' ' + p.attribute.EstimatedOccupancyStatus;                
            // return '';
        }.bind(this);
        this.getImageSrc = function() {            
            var p=this.data;
            //var n="";
            // if (p!=null && p.attribute && p.attribute.EstimatedOccupancyPercentage && p.attribute.EstimatedOccupancyPercentage!=null){
            //     var percent=p.attribute.EstimatedOccupancyPercentage;                
            //     if (percent<=10)
            //         n= OccupancyImages.manySeatsAvailable;
            //     else if (percent<=80)
            //         n= OccupancyImages.fewSeatsAvailable;
            //     else 
            //         n=OccupancyImages.full;
            //     return baseImageUrl + n;
            // }            
            if (p!=null && p.attribute && p.attribute.EstimatedOccupancyStatus && p.attribute.EstimatedOccupancyStatus!=null){
                var s=p.attribute.EstimatedOccupancyStatus.toLowerCase().replaceAll(' ','');
                switch(s){
                    case 'empty':
                    case 'notcrowded':
                        return baseImageUrl + OccupancyImages.empty;
                    case 'manyseatsavailable':
                        return baseImageUrl + OccupancyImages.manySeatsAvailable;                        
                    case 'somecrowding':
                    case 'fewseatsavailable':
                        return baseImageUrl + OccupancyImages.fewSeatsAvailable;
                    case 'full':
                    case 'crowded':
                        return baseImageUrl + OccupancyImages.full;
                    default:            
                        return baseImageUrl + p.attribute.EstimatedOccupancyStatus.toLowerCase() +".png";
                }                
            }
        }.bind(this);
        this.hasAPC=function(){
            var p=this.data;
            return  p!=null && p.attribute && 
                (
                    (p.attribute.EstimatedOccupancyPercentage!==undefined && p.attribute.EstimatedOccupancyPercentage!=null) ||
                    (p.attribute.EstimatedOccupancyStatus!==undefined && p.attribute.EstimatedOccupancyStatus!=null)
                );
        }
    },    
    template:
        // '<div style="flex:1; flex-direction:row;display:flex;align-content: flex-end"> \
        //     <div class="vehiclebox" style="flex:1"><label data-bind="text:getVehicleInfo()"></label></div> \
        //     <div class="vehiclebox" data-bind="visible: hasAPC()"><label data-bind="text:getOccupancyInfo()"></label></div> \
        // </div>'    
        '<div class="vehiclebox" style="flex:1; flex-direction:row;display:flex;align-content: flex-end;height:24px;"> \
            <div style="flex:1;align-items: center;align-self: center"><label data-bind="text:getVehicleInfo()"></label></div> \
            <div data-bind="visible: hasAPC()" style="margin-left:5px;flex:1;align-items: center;align-self: center"><img data-bind="visible: hasAPC(), attr:{src: getImageSrc(), title:getImageAlt(), alt:getImageAlt()} "  style="width:25px;height:20px;" /></div>\
        </div>'
});

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var actransit;
(function (actransit) {
    var maps;
    (function (maps) {
        var Map = (function () {
            function Map(map, stopIconUrl, stopIconLargeUrl, stopIconDisabledUrl, stopIconLargeDisabledUrl, busIconUrl, myLocationIcon, isLeaflet, isMapGl) {
                this.map = map;
                this.stopIconUrl = stopIconUrl;
                this.stopIconLargeUrl = stopIconLargeUrl;
                this.stopIconDisabledUrl = stopIconDisabledUrl;
                this.stopIconLargeDisabledUrl = stopIconLargeDisabledUrl;
                this.busIconUrl = busIconUrl;
                this.myLocationIcon = myLocationIcon;
                this.isLeaflet = isLeaflet;
                this.isMapGl = isMapGl;
                this.stopIcon = this.stopIconUrl;
                this.stopIconLarge = this.stopIconLargeUrl;
                this.stopDisabledIcon = this.stopIconDisabledUrl;
                this.stopDisabledIconLarge = this.stopIconLargeDisabledUrl;
                this.busIconSize = [32, 32];
                this.myLocationIconSize = [16, 28];
                this.busIcon = this.busIconUrl;
                this.defaultZoom = 12;
                this.centerZoom = 16;
                this.noZoom = false;
                this.youAreHereInfoWindow = null;
                this.data = {
                    myLocation: null,
                    stops: [],
                    vehicles: [],
                    overlays: [],
                    patterns: []
                };
                this.styles = {
                    default: [
                        {
                            featureType: "transit.station.bus",
                            stylers: [{ "visibility": "off" }]
                        }
                    ],
                    hide: [
                        {
                            featureType: 'poi',
                            stylers: [{ visibility: 'default' }]
                        },
                        {
                            featureType: "transit.station.bus",
                            stylers: [{ "visibility": "off" }]
                        }
                    ]
                };
                this.config = {
                    center: { lat: 37.805281, lng: -122.268523 },
                    zoom: this.defaultZoom,
                    styles: this.styles['hide']
                };
                this.symbols = {};
                this.getDataArray = function (type) {
                    switch (type) {
                        case "stops":
                        case "stop":
                            return this.data.stops;
                        case "overlay":
                        case "overlays":
                            return this.data.overlays;
                        default:
                            return this.data.vehicles;
                    }
                };
                this.imageArcCache = {};
                if (typeof (this.isLeaflet) === 'undefined')
                    this.isLeaflet = false;
                if (typeof (this.isMapGl) === 'undefined')
                    this.isMapGl = false;
                if (this.isLeaflet == true && this.isMapGl == true)
                    this.isLeaflet = false;
            }
            Map.prototype.mapRightClicked = function (event) { };
            ;
            Map.prototype.init = function (enablePointOfInterest) {
                var _this = this;
                var me = this;
                enablePointOfInterest = enablePointOfInterest || false;
                this.currentStopIcon = this.defaultZoom > 14 ? this.stopIconLarge : this.stopIcon;
                this.currentStopIconSize = this.defaultZoom > 14 ? [15, 26] : [4, 4];
                this.currentStopDisabledIcon = this.defaultZoom > 14 ? this.stopIconLargeDisabledUrl : this.stopIconDisabledUrl;
                this.currentStopDisabledIconSize = this.defaultZoom > 14 ? [15, 26] : [4, 4];
                if (this.isLeaflet) {
                    this.map.on('contextmenu', function (e) { _this.mapRightClicked(e); });
                    this.map.on('zoomend', function (e) { _this.zoomChanged(e); });
                }
                else if (this.isMapGl) {
                    this.map.on('contextmenu', function (e) { _this.mapRightClicked(e); });
                    this.map.on('zoomend', function (e) { _this.zoomChanged(e); });
                }
                else {
                    google.maps.event.addListener(this.map, 'rightclick', function (e) { _this.mapRightClicked(e); });
                    google.maps.event.addListener(this.map, 'zoom_changed', function (e) { _this.zoomChanged(e); });
                }
                { }
                if (enablePointOfInterest) {
                    var button = $('<div style="display: inline-block;"><label class="checkbox-inline poi-selector"><input type="checkbox">Points Of Interest</label></div>');
                    button.click(function () { _this.enablePOI(button); });
                    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(button[0]);
                }
            };
            ;
            Map.prototype.setDefaultZooming = function (value) {
                this.noZoom = !value;
            };
            Map.prototype.setMapRightClicked = function (func) {
                this.mapRightClicked = func;
            };
            ;
            Map.prototype.setCenter = function (lat, lng) {
                if (this.isLeaflet) {
                    this.map.setView(L.latLng(lat, lng), this.centerZoom);
                }
                else if (this.isMapGl) {
                    this.map.setCenter([lng, lat]);
                    this.map.setZoom(this.centerZoom);
                }
                else {
                    this.map.setCenter(new google.maps.LatLng(lat, lng));
                    this.map.setZoom(this.centerZoom);
                }
            };
            ;
            Map.prototype.getCenter = function () {
                return this.map.getCenter();
            };
            ;
            Map.prototype.getVehicleMarker = function (vid) {
                for (var i = 0; i < this.data.vehicles.length; i++) {
                    var v = this.data.vehicles[i];
                    if (v.vehicle.vid == vid)
                        return v;
                }
                return null;
            };
            ;
            Map.prototype.addOrUpdateVehicles = function (vehicles, clickDelegate) {
                var markersToDelete = [];
                for (var i = 0; i < this.data.vehicles.length; i++) {
                    var v = this.data.vehicles[i];
                    var found = false;
                    for (var j = 0; j < vehicles.length; j++) {
                        if (v.vehicle.vid == vehicles[j].vid) {
                            found = true;
                            break;
                        }
                    }
                    if (!found)
                        markersToDelete.push(v);
                }
                for (var i = 0; i < markersToDelete.length; i++) {
                    this.removeMarker(markersToDelete[i]);
                }
                for (var i = 0; i < vehicles.length; i++)
                    this.addOrUpdateVehicle(vehicles[i], {}, clickDelegate);
            };
            Map.prototype.addOrUpdateVehicle = function (vehicle, tag, clickDelegate) {
                return __awaiter(this, void 0, void 0, function () {
                    var image, i, v, title, marker, el;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, this.createBusImage(this.busIconUrl, 'orange', vehicle.hdg)];
                            case 1:
                                image = _a.sent();
                                for (i = 0; i < this.data.vehicles.length; i++) {
                                    v = this.data.vehicles[i];
                                    if (v && v.vehicle.vid == vehicle.vid) {
                                        this.setMarker(v, vehicle.lat, vehicle.lon, image, null);
                                        return [2];
                                    }
                                }
                                title = "Vehicle: " + vehicle.vid;
                                marker = this.createMarker(vehicle.lat, vehicle.lon, title, image, this.busIconSize, { vehicle: vehicle });
                                if (clickDelegate) {
                                    if (this.isLeaflet)
                                        marker.on('click', function () { clickDelegate(marker, vehicle, tag); });
                                    else if (this.isMapGl) {
                                        el = marker.getElement();
                                        $(el).on('click', function () { clickDelegate(marker, vehicle, tag); });
                                    }
                                    else
                                        marker.addListener('click', function () { clickDelegate(marker, vehicle, tag); });
                                }
                                this.data.vehicles.push(marker);
                                return [2, marker];
                        }
                    });
                });
            };
            Map.prototype.isStopActive = function (stop) {
                if (typeof stop.dtrrem === "undefined" || stop.dtrrem == null || stop.dtrrem.length == 0)
                    return true;
                return false;
            };
            Map.prototype.addOrUpdateStops = function (stops, clickDelegate) {
                var markersToDelete = [];
                for (var i = 0; i < this.data.stops.length; i++) {
                    var s = this.data.stops[i];
                    var found = false;
                    for (var j = 0; j < stops.length; j++) {
                        if (s.stop.stpid == stops[j].stpid) {
                            found = true;
                            break;
                        }
                    }
                    if (!found)
                        markersToDelete.push(s);
                }
                for (var i = 0; i < markersToDelete.length; i++)
                    this.removeMarker(markersToDelete[i]);
                for (var i = 0; i < stops.length; i++) {
                    var s = stops[i];
                    var e = this.isStopActive(s);
                    this.addOrUpdateStop(s, {}, e, clickDelegate);
                }
            };
            Map.prototype.addOrUpdateStop = function (stop, tag, enabled, clickDelegate) {
                if (typeof enabled === "undefined")
                    enabled = true;
                var imageUrl = enabled ? this.currentStopIcon : this.currentStopDisabledIcon;
                var imageSize = enabled ? this.currentStopIconSize : this.currentStopDisabledIconSize;
                for (var i = 0; i < this.data.stops.length; i++) {
                    var s = this.data.stops[i];
                    if (s && s.stop.vid == stop.stpid) {
                        this.setMarker(s, stop.lat, stop.lon, imageUrl);
                        return;
                    }
                }
                var title = stop.stpid + " (" + stop.stpnm + ")";
                var marker = this.createMarker(stop.lat, stop.lon, title, imageUrl, imageSize, { stop: stop, disabled: !enabled });
                if (clickDelegate) {
                    if (this.isLeaflet)
                        marker.on('click', function () { clickDelegate(marker, stop, tag); });
                    else if (this.isMapGl) {
                        var el = marker.getElement();
                        $(el).on('click', function () { clickDelegate(marker, stop, tag); });
                    }
                    else
                        marker.addListener('click', function () { clickDelegate(marker, stop, tag); });
                }
                this.data.stops.push(marker);
                return marker;
            };
            ;
            Map.prototype.setMyLocation = function (lat, lng, title, tag, clickDelegate) {
                title = title || "Your are here";
                if (this.data.myLocation == null) {
                    var marker = this.createMarker(lat, lng, title, this.myLocationIcon, this.myLocationIconSize);
                    this.data.myLocation = marker;
                }
                else
                    this.setMarker(this.data.myLocation, lat, lng, null, title);
            };
            ;
            Map.prototype.createMarker = function (lat, lng, title, iconUrl, iconSize, tag) {
                var marker;
                if (this.isLeaflet) {
                    var image = L.icon({ iconUrl: iconUrl, iconSize: iconSize });
                    var options = {};
                    options.icon = image;
                    options.title = title;
                    marker = L.marker(L.latLng(lat, lng), options);
                    for (var i in tag) {
                        if (tag.hasOwnProperty(i)) {
                            marker[i] = tag[i];
                        }
                    }
                    marker.addTo(this.map);
                }
                else if (this.isMapGl) {
                    var el = document.createElement('img');
                    el.src = iconUrl;
                    el.style.width = iconSize[0] + 'px';
                    el.style.height = iconSize[1] + 'px';
                    marker = new mapboxgl.Marker(el).setLngLat([lng, lat]);
                    for (var i in tag) {
                        if (tag.hasOwnProperty(i)) {
                            marker[i] = tag[i];
                        }
                    }
                    marker.addTo(this.map);
                }
                else {
                    var image = { url: iconUrl };
                    var options = tag || {};
                    options.title = title;
                    options.icon = image;
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(lat, lng),
                        map: this.map,
                        title: title,
                        icon: image
                    });
                }
                return marker;
            };
            ;
            Map.prototype.setMarker = function (marker, lat, lng, iconUrl, title) {
                if (this.isLeaflet) {
                    marker.setLatLng(L.latLng(lat, lng));
                    if (typeof iconUrl !== 'undefined' && iconUrl != null && iconUrl != '') {
                        var image = L.icon({ iconUrl: iconUrl });
                        marker.setIcon(image);
                    }
                    if (typeof title !== 'undefined' && title != null)
                        marker.title = title;
                }
                else if (this.isMapGl) {
                    if (vehicleMotionEnabled) {
                        var devider_1 = 50;
                        var curLoc_1 = marker.getLngLat();
                        var lngSteps_1 = (lng - curLoc_1.lng) / devider_1;
                        var latSteps_1 = (lat - curLoc_1.lat) / devider_1;
                        var i_1 = 0;
                        var intHwnd_1 = setInterval(function () {
                            i_1++;
                            try {
                                if (i_1 >= (devider_1 - 1)) {
                                    clearTimeout(intHwnd_1);
                                    marker.setLngLat([lng, lat]);
                                }
                                else {
                                    var longitude = (i_1 * lngSteps_1) + curLoc_1.lng;
                                    var latitude = (i_1 * latSteps_1) + curLoc_1.lat;
                                    marker.setLngLat([longitude, latitude]);
                                }
                            }
                            catch (_a) { }
                        }, (1000 / devider_1));
                    }
                    else {
                        marker.setLngLat([lng, lat]);
                    }
                    var el = marker.getElement();
                    if (typeof iconUrl !== 'undefined' && iconUrl != null && iconUrl != '')
                        el.src = iconUrl;
                    if (typeof title !== 'undefined' && title != null)
                        el.title = title;
                }
                else {
                    marker.setPosition(new google.maps.LatLng(lat, lng));
                    if (typeof iconUrl !== 'undefined' && iconUrl != '') {
                        var image = { url: iconUrl };
                        marker.setIcon(image);
                    }
                    if (typeof title !== 'undefined' && title != null)
                        marker.setTitle(title);
                }
            };
            Map.prototype.addCircle = function (lat, lng, strokeColor, radius) {
                var circle;
                if (this.isLeaflet) {
                    circle = L.circle(L.latLng(lat, lng), {
                        radius: parseInt(radius) / 2,
                        color: strokeColor || "#0000FF",
                        opacity: 0.8,
                        weight: 2,
                        fillColor: "#0099dd",
                        fillOpacity: 0.3,
                    }).addTo(this.map);
                }
                else if (this.isMapGl) {
                    var sourceId = 'source_circle_100';
                    var layerId = sourceId;
                    if (!this.map.getSource(sourceId))
                        this.map.addSource(sourceId, this.createGeoJSONCircle([lng, lat], 0.1));
                    if (!this.map.getLayer(sourceId))
                        this.map.addLayer({
                            "id": layerId,
                            "type": "line",
                            "source": sourceId,
                            "layout": {},
                            "paint": {
                                "line-color": "red",
                            }
                        });
                }
                else {
                    circle = new google.maps.Circle({
                        center: new google.maps.LatLng(lat, lng),
                        map: this.map,
                        radius: parseInt(radius) / 2,
                        strokeColor: strokeColor || "#0000FF",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#0099dd",
                        fillOpacity: 0.3,
                        circle: true
                    });
                }
                this.data.overlays.push(circle);
            };
            ;
            Map.prototype.panToBounds = function (sw, ne) {
                if (sw.lat == 1000 || ne.lat == 1000)
                    return;
                this.map.fitBounds(new google.maps.LatLngBounds(sw, ne), 10);
            };
            ;
            Map.prototype.removeMarker = function (marker) {
                var type = "vehicle";
                if (marker.stop)
                    type = "stop";
                else if (marker.circle)
                    type = "overlay";
                var arr = this.getDataArray(type);
                var posision = this.isLeaflet ? marker.getLatLng() : (this.isMapGl ? marker.getLngLat() : marker.getPosition());
                var i = arr.length - 1;
                for (; i >= 0; i--) {
                    var m = arr[i];
                    var mPos = this.isLeaflet ? m.getLatLng() : (this.isMapGl ? m.getLngLat() : m.getPosition());
                    if (mPos.lat == posision.lat && mPos.lng == posision.lng) {
                        if (this.isLeaflet || this.isMapGl) {
                            arr[i].remove();
                        }
                        else
                            arr[i].setMap(null);
                        arr.splice(i, 1);
                    }
                }
            };
            ;
            Map.prototype.enablePOI = function (checkboxDiv) {
                var checkbox = checkboxDiv.find("input")[0];
                if (checkbox.checked) {
                    this.map.setOptions({ styles: this.styles['default'] });
                }
                else {
                    this.map.setOptions({ styles: this.styles['hide'] });
                }
            };
            Map.prototype.clearMarkers = function (type) {
                if (!this.noZoom)
                    this.map.setZoom(this.defaultZoom);
                if (!type) {
                    this.clearMarkers("stop");
                    this.clearMarkers("vehicle");
                    this.clearMarkers("overlay");
                    return;
                }
                ;
                var arr = this.getDataArray(type);
                for (var i = 0; i < arr.length; i++) {
                    if (this.isLeaflet || this.isMapGl)
                        arr[i].remove();
                    else
                        arr[i].setMap(null);
                }
                arr.length = 0;
            };
            ;
            Map.prototype.createPoint = function (lat, lng) {
                if (this.isLeaflet)
                    return [lat, lng];
                else if (this.isMapGl)
                    return [lng, lat];
                return new google.maps.LatLng(lat, lng);
            };
            Map.prototype.createPolyline = function (patternId, path, color, opacity, weight) {
                if (this.isLeaflet) {
                    return L.polyline(path, {
                        color: color,
                        opacity: opacity,
                        weight: weight,
                    }).addTo(this.map);
                }
                else if (this.isMapGl) {
                    var layer = this.map.getSource(patternId.toString());
                    if (typeof layer === 'undefined' || layer == null) {
                        layer = {
                            "id": patternId.toString(),
                            "type": "line",
                            "source": {
                                "type": "geojson",
                                "data": {
                                    "type": "FeatureCollection",
                                    "features": [
                                        {
                                            "type": "Feature",
                                            "properties": {
                                                "color": color
                                            },
                                            "geometry": {
                                                "type": "LineString",
                                                "coordinates": path
                                            }
                                        }
                                    ]
                                }
                            },
                            "paint": {
                                "line-width": weight,
                                "line-color": [
                                    "get",
                                    "color"
                                ]
                            }
                        };
                        this.map.addLayer(layer);
                    }
                    return layer;
                }
                else {
                    return new google.maps.Polyline({
                        path: path,
                        strokeColor: color,
                        strokeOpacity: opacity,
                        strokeWeight: weight,
                        map: this.map
                    });
                }
            };
            Map.prototype.addPattern = function (patternId, coords, route, color) {
                var path = [];
                for (var i = 0; i < coords.length; i++) {
                    var lng = coords[i].lon ? coords[i].lon : coords[i].lng;
                    path.push(this.createPoint(coords[i].lat, lng));
                }
                var polyline = this.createPolyline(patternId, path, color, 0.8, 2);
                this.data.patterns.push({ patternId: patternId, polyline: polyline });
            };
            ;
            Map.prototype.clearPatterns = function () {
                var i = this.data.patterns.length - 1;
                for (; i >= 0; i--) {
                    if (this.isLeaflet) {
                        this.data.patterns[i].polyline.remove();
                    }
                    else if (this.isMapGl) {
                        var pId = this.data.patterns[i].patternId.toString();
                        if (!this.map.getLayer(pId))
                            this.map.removeLayer(pId);
                    }
                    else
                        this.data.patterns[i].polyline.setMap(null);
                    this.data.patterns.splice(i, 1);
                }
                if (!this.noZoom)
                    this.map.setZoom(this.defaultZoom);
            };
            ;
            Map.prototype.zoomChanged = function (event) {
                var me = this;
                var zoom = this.map.getZoom();
                if ((zoom > 14 && this.currentStopIcon != this.stopIconLarge) || (zoom <= 14 && this.currentStopIcon != this.stopIcon)) {
                    this.currentStopIcon = zoom > 14 ? this.stopIconLarge : this.stopIcon;
                    this.currentStopIconSize = zoom > 14 ? [15, 26] : [4, 4];
                    this.currentStopDisabledIcon = zoom > 14 ? this.stopIconLargeDisabledUrl : this.stopIconDisabledUrl;
                    this.currentStopDisabledIconSize = zoom > 14 ? [15, 26] : [4, 4];
                    this.updateStops();
                }
                this.noZoom = true;
            };
            Map.prototype.dispose = function () {
            };
            Map.prototype.updateStops = function () {
                try {
                    var image, imageDisabled;
                    if (this.isLeaflet) {
                        image = L.icon({ iconUrl: this.currentStopIcon, iconSize: this.currentStopIconSize });
                        imageDisabled = L.icon({ iconUrl: this.currentStopDisabledIcon, iconSize: this.currentStopDisabledIconSize });
                    }
                    else {
                        image = { url: this.currentStopIcon };
                        imageDisabled = { url: this.currentStopDisabledIcon };
                    }
                    for (var i = 0; i < this.data.stops.length; i++) {
                        var disabled = this.data.stops[i].disabled;
                        var img = disabled ? imageDisabled : image;
                        var size = disabled ? this.currentStopDisabledIconSize : this.currentStopIconSize;
                        if (this.isMapGl) {
                            var e = this.data.stops[i].getElement();
                            e.src = img.url;
                            e.style.width = size[0] + 'px';
                            e.style.height = size[1] + 'px';
                        }
                        else
                            this.data.stops[i].setIcon(img);
                    }
                }
                catch (e) {
                    console.error("updateStops:" + e);
                }
            };
            ;
            Map.prototype.loadImage = function (url) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2, new Promise(function (r) { var i = new Image(); i.onload = (function () { return r(i); }); i.src = url; })];
                    });
                });
            };
            Map.prototype.createBusImage = function (busUrl, color, angle) {
                return __awaiter(this, void 0, void 0, function () {
                    var img, cacheKey, result, width, canvas, context, x, y, arrowWidth, arrowHeight, xt, yt;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, this.loadImage(busUrl)];
                            case 1:
                                img = _a.sent();
                                cacheKey = color + (angle ? "_" + angle : "");
                                result = this.imageArcCache[cacheKey];
                                if (result !== undefined && result != null)
                                    return [2, result];
                                width = 32;
                                canvas = document.createElement('canvas');
                                canvas.width = width;
                                canvas.height = width;
                                context = canvas.getContext("2d", {});
                                x = canvas.width / 2;
                                y = (canvas.height - 4) / 2;
                                arrowWidth = 10;
                                arrowHeight = 15;
                                context.drawImage(img, 0, 0);
                                xt = x;
                                yt = y + (arrowHeight / 3);
                                context.translate(xt, yt);
                                context.rotate(angle * Math.PI / 180);
                                context.translate(-xt, -yt);
                                this.drawArrow(context, x, y, arrowWidth, arrowHeight, color);
                                result = canvas.toDataURL("image/png", 1.0);
                                this.imageArcCache[cacheKey] = result;
                                return [2, result];
                        }
                    });
                });
            };
            Map.prototype.drawArrow = function (context, x, y, arrowWidth, arrowHeight, color) {
                var xWidth = 3 + arrowWidth / 2;
                var tail = 12;
                context.beginPath();
                context.moveTo(x, y - (arrowHeight * 1 / 10));
                context.lineTo(x - xWidth, y + (arrowHeight / 4));
                context.lineTo(x + xWidth, y + (arrowHeight / 4));
                context.moveTo(x - 2, y + (arrowHeight / 4));
                context.lineTo(x - 2, y + tail);
                context.lineTo(x + 2, y + tail);
                context.lineTo(x + 2, y + (arrowHeight / 4));
                context.fillStyle = color;
                context.fill();
            };
            Map.prototype.createGeoJSONCircle = function (center, radiusInKm, points) {
                if (!points)
                    points = 64;
                var coords = {
                    latitude: center[1],
                    longitude: center[0]
                };
                var km = radiusInKm;
                var ret = [];
                var distanceX = km / (111.320 * Math.cos(coords.latitude * Math.PI / 180));
                var distanceY = km / 110.574;
                var theta, x, y;
                for (var i = 0; i < points; i++) {
                    theta = (i / points) * (2 * Math.PI);
                    x = distanceX * Math.cos(theta);
                    y = distanceY * Math.sin(theta);
                    ret.push([coords.longitude + x, coords.latitude + y]);
                }
                ret.push(ret[0]);
                return {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": [{
                                "type": "Feature",
                                "geometry": {
                                    "type": "Polygon",
                                    "coordinates": [ret]
                                }
                            }]
                    }
                };
            };
            ;
            return Map;
        }());
        maps.Map = Map;
    })(maps = actransit.maps || (actransit.maps = {}));
})(actransit || (actransit = {}));
var BusTimeApi = (function () {
    function BusTimeApi(baseUrl) {
        this.baseUrl = baseUrl;
        this.useJsonP = false;
        this.newWay = (this.baseUrl.indexOf("transit/actrealtime") > 0 || this.baseUrl.indexOf("/ACTransit.Transit.API/actrealtime") > 0);
        this.apiUrl = this.baseUrl + "";
        this.getRoutesUrl = this.apiUrl + (this.newWay ? "line" : "getroutes");
        this.getPatternssUrl = this.apiUrl + (this.newWay ? "pattern" : "getpatterns");
        this.getDirectionsUrl = this.apiUrl + (this.newWay ? "direction" : "getdirections");
        this.getStopsUrl = this.apiUrl + (this.newWay ? "stop" : "getstops");
        this.getPredictionsUrl = this.apiUrl + (this.newWay ? "prediction" : "getpredictions");
        this.getVehiclesUrl = this.apiUrl + (this.newWay ? "vehicle" : "getvehicles");
        this.getServiceBulletinsUrl = this.apiUrl + (this.newWay ? "servicebulletin" : "getservicebulletins");
        this.getDetoursUrl = this.apiUrl + (this.newWay ? "detour" : "getdetours");
        this.getStopRoutesUrl = busTimeSchedule + "stops/";
        this.getVehicleAttributesUrl = busTimeSchedule + "vehicle/";
        this.getRoutesCacheDuration = 600;
        this.getPatternsCacheDuration = 600;
        this.getDirectionsCacheDuration = 600;
        this.getStopsCacheDuration = 120;
        this.getServiceBulletinsCacheDuration = 600;
        this.getDetoursCacheDuration = 120;
        this.routeKey = (this.newWay ? "rt" : "route");
        this.routesKey = (this.newWay ? "rt" : "routes");
        this.stopKey = (this.newWay ? "stpid" : "stopId");
        this.stopsKey = (this.newWay ? "stpid" : "stopIds");
        this.directionKey = (this.newWay ? "rtdir" : "directionId");
        this.dirKey = (this.newWay ? "dir" : "directionId");
        this.vehiclesKey = (this.newWay ? "vid" : "vehicles");
        this.apiToken = this.newWay ? busTimeApiToken : "";
        this.appender = "?";
    }
    BusTimeApi.prototype.getRoutes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getRoutesUrl;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        return [4, this.getGeneric(url, "routes")];
                    case 1:
                        result = _a.sent();
                        CustomCache.add(url, result, this.getRoutesCacheDuration);
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getRoutesDictionary = function () {
        return __awaiter(this, void 0, void 0, function () {
            var routesProm, routes, result, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getRoutes()];
                    case 1:
                        routesProm = _a.sent();
                        routes = routesProm.response;
                        result = {};
                        for (i = 0; i < routes.length; i++) {
                            result[routes[i].rt] = routes[i];
                        }
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getRoute = function (rt) {
        return __awaiter(this, void 0, void 0, function () {
            var routesProm, routes, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getRoutes()];
                    case 1:
                        routesProm = _a.sent();
                        routes = routesProm.response;
                        for (i = 0; i < routes.length; i++) {
                            if (routes[i].rt == rt)
                                return [2, routes[i]];
                        }
                        return [2, null];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getDirections = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = encodeURIComponent(route);
                        url = this.getDirectionsUrl + this.appender + this.routeKey + "=" + route;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        return [4, this.getGeneric(url, "directions")];
                    case 1:
                        result = _a.sent();
                        CustomCache.add(url, result, this.getDirectionsCacheDuration);
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getPatterns = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = encodeURIComponent(route);
                        url = this.getPatternssUrl + this.appender + this.routeKey + "=" + route;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        return [4, this.getGeneric(url, "ptr")];
                    case 1:
                        result = _a.sent();
                        CustomCache.add(url, result, this.getPatternsCacheDuration);
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getVehicles = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = encodeURIComponent(route);
                        return [4, this.getGeneric(this.getVehiclesUrl + this.appender + this.routeKey + "=" + route, "vehicle")];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getVehiclesByIds = function (vids) {
        return __awaiter(this, void 0, void 0, function () {
            var str, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = '';
                        for (i = 0; i < vids.length; i++) {
                            if (str != '')
                                str += ',';
                            str += vids[i];
                        }
                        str = encodeURIComponent(str);
                        return [4, this.getGeneric(this.getVehiclesUrl + this.appender + this.vehiclesKey + "=" + str, "vehicle")];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getStops = function (route, directionId, stpIds) {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stpIds = stpIds || "";
                        route = encodeURIComponent(route);
                        directionId = encodeURIComponent(directionId);
                        stpIds = encodeURIComponent(stpIds);
                        url = this.getStopsUrl + this.appender + this.routeKey + "=" + route + "&" + this.dirKey + "=" +
                            directionId + "&" + this.stopsKey + "=" + stpIds;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        return [4, this.getGeneric(url, "stops")];
                    case 1:
                        result = _a.sent();
                        if (result != null && result.error == null && result.response.length > 0)
                            CustomCache.add(url, result, this.getStopsCacheDuration);
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getPredictions = function (stopId, routes, vehicles) {
        return __awaiter(this, void 0, void 0, function () {
            var predictions, vids, attributes, _loop_1, filteredAattributes, attribute, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        routes = routes || "";
                        stopId = encodeURIComponent(stopId);
                        routes = encodeURIComponent(routes);
                        vehicles = encodeURIComponent(vehicles);
                        return [4, this.getGeneric(this.getPredictionsUrl + this.appender + this.stopKey + "=" + stopId + "&" + this.routesKey + "=" +
                                routes + "&" + this.vehiclesKey + "=" + vehicles, "prd")];
                    case 1:
                        predictions = _a.sent();
                        if (!(predictions != null && predictions.response)) return [3, 3];
                        vids = predictions.response.distinctBy(['vid']).map(function (p) { return p.vid; });
                        return [4, this.getVehiclesAttributes(vids)];
                    case 2:
                        attributes = _a.sent();
                        _loop_1 = function (i) {
                            var p = predictions.response[i];
                            filteredAattributes = attributes.response.filter(function (a) { return a["VehicleId"] == p.vid; }) || [];
                            attribute = filteredAattributes.length > 0 ? filteredAattributes[0] : null;
                            p.attribute = attribute;
                        };
                        for (i in predictions.response) {
                            _loop_1(i);
                        }
                        _a.label = 3;
                    case 3: return [2, predictions];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getVehiclesAttributes = function (vIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Array.isArray(vIds))
                    vIds = vIds.map(function (d) { return encodeURIComponent(d); }).toString();
                return [2, this.getGeneric(this.getVehicleAttributesUrl + vIds + "/realtimeattributes", null, false)];
            });
        });
    };
    BusTimeApi.prototype.getServiceBulletins = function (route, directionId, stpIds) {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = route || "";
                        directionId = directionId || "";
                        stpIds = stpIds || "";
                        route = encodeURIComponent(route);
                        directionId = encodeURIComponent(directionId);
                        stpIds = encodeURIComponent(stpIds);
                        url = this.getServiceBulletinsUrl + this.appender + this.routeKey + "=" + route + "&" + this.directionKey + "=" + directionId + "&" + this.stopKey + "=" + stpIds;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        return [4, this.getGeneric(url, "sb")];
                    case 1:
                        result = _a.sent();
                        CustomCache.add(url, result, this.getServiceBulletinsCacheDuration);
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getServiceBulletinsAsDeferred = function (route, directionId, stpIds) {
        var _this = this;
        var p = $.Deferred();
        route = route || "";
        directionId = directionId || "";
        stpIds = stpIds || "";
        route = encodeURIComponent(route);
        directionId = encodeURIComponent(directionId);
        stpIds = encodeURIComponent(stpIds);
        var url = this.getServiceBulletinsUrl + this.appender + this.routeKey + "=" + route + "&" + this.directionKey + "=" + directionId + "&" + this.stopKey + "=" + stpIds;
        var cachedResult = CustomCache.get(url);
        if (cachedResult != null) {
            p.resolve(cachedResult.response || []);
            return p;
        }
        this.getGeneric(url, "sb").then(function (data) {
            data = data || { response: [], error: null };
            var sbs = data.response || [];
            sbs.sort(function (item1, item2) { return item1.mod > item2.mod ? -1 : 1; });
            data.response = sbs;
            CustomCache.add(url, data, _this.getServiceBulletinsCacheDuration);
            p.resolve(data.response);
        }).catch(function () {
            p.reject();
        });
        return p;
    };
    ;
    BusTimeApi.prototype.getStopRoutes = function (stop) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.getStopRoutesUrl + stop + "/routes";
                        return [4, this.getGeneric(url, "")];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getDetours = function (route, directionId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = route || "";
                        directionId = directionId || "";
                        route = encodeURIComponent(route);
                        directionId = encodeURIComponent(directionId);
                        url = this.getDetoursUrl + this.appender + this.routeKey + "=" + route + "&" + this.directionKey + "=" + directionId;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        return [4, this.getGeneric(url, "dtrs")];
                    case 1:
                        result = _a.sent();
                        CustomCache.add(url, result, this.getDetoursCacheDuration);
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getDetoursForStop = function (stpId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, p1, p2, stopsResponse, detoursResponse, stops, detours, stop, i, detourId, j;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        p1 = this.getStops("", "", stpId);
                        p2 = this.getDetours("", "");
                        return [4, p1];
                    case 1:
                        stopsResponse = _a.sent();
                        return [4, p2];
                    case 2:
                        detoursResponse = _a.sent();
                        if (detoursResponse == null || detoursResponse.response == null || detoursResponse.response.length == 0)
                            return [2, result];
                        if (stopsResponse == null || stopsResponse.response == null || stopsResponse.response.length == 0) {
                            console.error("stop " + stpId + " not found!");
                            return [2, result];
                        }
                        stops = stopsResponse.response;
                        detours = detoursResponse.response;
                        stop = stops[0];
                        if (typeof stop !== "undefined" && typeof stop.dtrrem !== "undefined" && stop.dtrrem.length > 0) {
                            for (i = 0; i < stop.dtrrem.length; i++) {
                                detourId = stop.dtrrem[i];
                                for (j = 0; j < detours.length; j++) {
                                    if (detours[j].id == detourId) {
                                        result.push(detours[j]);
                                        break;
                                    }
                                }
                            }
                        }
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getDetoursByStop = function (stop) {
        return __awaiter(this, void 0, void 0, function () {
            var result, p, detoursResponse, detours, i, detourId, j;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        p = this.getDetours("", "");
                        return [4, p];
                    case 1:
                        detoursResponse = _a.sent();
                        if (detoursResponse == null || detoursResponse.response == null || detoursResponse.response.length == 0)
                            return [2, result];
                        detours = detoursResponse.response;
                        if (typeof stop !== "undefined" && typeof stop.dtrrem !== "undefined" && stop.dtrrem.length > 0) {
                            for (i = 0; i < stop.dtrrem.length; i++) {
                                detourId = stop.dtrrem[i];
                                for (j = 0; j < detours.length; j++) {
                                    if (detours[j].id == detourId) {
                                        result.push(detours[j]);
                                        break;
                                    }
                                }
                            }
                        }
                        return [2, result];
                }
            });
        });
    };
    ;
    BusTimeApi.prototype.getGeneric = function (url, resultObjectName, useJsonP) {
        return __awaiter(this, void 0, void 0, function () {
            var me, data, d, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (useJsonP === undefined)
                            useJsonP = this.useJsonP;
                        return [4, this.get(url, useJsonP)];
                    case 1:
                        data = _a.sent();
                        d = (resultObjectName != null && resultObjectName != "") ? data["bustime-response"] : data;
                        result = (resultObjectName != null && resultObjectName != "") ? d[resultObjectName] : d;
                        return [2, {
                                response: result,
                                error: d["error"]
                            }];
                }
            });
        });
    };
    BusTimeApi.prototype.get = function (url, useJsonP) {
        return __awaiter(this, void 0, void 0, function () {
            var p;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p = new Promise(function (resolve, reject) {
                            var ajaxProm;
                            if (typeof _this.apiToken !== "undefined" && _this.apiToken != "") {
                                if (url.indexOf('?') > 0)
                                    url += "&token=" + _this.apiToken;
                                else
                                    url += "?token=" + _this.apiToken;
                            }
                            if (useJsonP) {
                                ajaxProm = $.ajax({
                                    url: url,
                                    type: 'GET',
                                    crossDomain: true,
                                    contentType: "application/json; charset=utf-8",
                                    dataType: "jsonp",
                                    success: function (data) { },
                                    error: function (e) {
                                        console.error(e);
                                    }
                                });
                            }
                            else {
                                ajaxProm = $.ajax({
                                    url: url,
                                    type: 'GET',
                                    crossDomain: true,
                                    contentType: "application/json; charset=utf-8",
                                    dataType: 'json',
                                    success: function (data) { },
                                    error: function (e) {
                                        console.error(url);
                                        console.error(e);
                                    }
                                });
                            }
                            ajaxProm.done(function (data) {
                                setTimeout(function () {
                                    resolve(data);
                                }, 100);
                            }).fail(function (err) { reject(err); });
                        });
                        return [4, p];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    return BusTimeApi;
}());
var Server = (function () {
    function Server() {
    }
    Server.getNearbyStops = function (lat, long, count) {
        return __awaiter(this, void 0, void 0, function () {
            var url, p;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        count = count || 10;
                        url = 'schedule/nearby-stops?latitude=' + lat + '&longitude=' + long + '&count=' + count;
                        p = new Promise(function (resolve, reject) {
                            $.ajax({
                                url: service + url,
                                contentType: "text/plain; charset=utf-8"
                            })
                                .done(function (data) { resolve(data); })
                                .fail(function (jqXHR, textStatus, errorThrown) {
                                reject();
                            });
                        });
                        return [4, p];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Server.getAllStops = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, cachedResult, p, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = busTimeSchedule + "stops";
                        url += "?token=" + busTimeApiToken;
                        cachedResult = CustomCache.get(url);
                        if (cachedResult != null)
                            return [2, cachedResult];
                        p = new Promise(function (resolve, reject) {
                            $.ajax({
                                url: url,
                                contentType: "text/plain; charset=utf-8"
                            })
                                .done(function (data) { resolve(data); })
                                .fail(function (jqXHR, textStatus, errorThrown) {
                                reject();
                            });
                        });
                        return [4, p];
                    case 1:
                        result = _a.sent();
                        CustomCache.add(url, result, 3600);
                        return [2, result];
                }
            });
        });
    };
    return Server;
}());
var CustomCache = (function () {
    function CustomCache() {
    }
    CustomCache.add = function (key, value, expiresInSecond) {
        expiresInSecond = expiresInSecond || 60;
        this._cache[key] = { key: key, value: value, expires: this.addSeconds(expiresInSecond) };
    };
    CustomCache.exists = function (key) {
        var now = new Date().getTime();
        var v = this._cache[key];
        if (v != null && v.expires != null) {
            if (v.expires.getTime() < now) {
                delete this._cache[key];
                return false;
            }
            return true;
        }
        return false;
    };
    CustomCache.get = function (key) {
        var now = new Date().getTime();
        var v = this._cache[key];
        if (v != null && v.expires != null) {
            if (v.expires.getTime() < now) {
                delete this._cache[key];
                return null;
            }
            return v.value;
        }
        return null;
    };
    CustomCache.clear = function () {
        this._cache = {};
    };
    CustomCache.addSeconds = function (seconds) {
        var d = new Date();
        d.setSeconds(d.getSeconds() + seconds);
        return d;
    };
    CustomCache._cache = {};
    return CustomCache;
}());
var BaseHandler = (function () {
    function BaseHandler(name) {
        this.errors = [];
        this.running = false;
        this.paused = false;
        this.nearByRefreshRate = 15000;
        this.byLinePredictionRefreshRate = 15000;
        this.FavoritePredictionRefreshRate = 15000;
        this.routesRefreshRate = 600000;
        this.byStopMapRefreshRate = 15000;
        this.MapPatternRefreshRate = 600000;
        this.MapStopsRefreshRate = 600000;
        this.MapVehiclePopupRefreshRate = this.byStopMapRefreshRate;
        this.MapStopPopupRefreshRate = this.byStopMapRefreshRate;
        this.genericNetworkErrorMessage = "Network error. please try again later.";
        if (typeof name !== "undefined" && name != null)
            this.name = name;
        this.errors = [];
    }
    BaseHandler.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.running) return [3, 2];
                        this.running = false;
                        this.paused = false;
                        return [4, this._stop()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    BaseHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errors = [];
                        if (!this.running) return [3, 5];
                        if (!this.paused) return [3, 2];
                        return [4, this._continue(args)];
                    case 1:
                        _a.sent();
                        this.paused = false;
                        this.stateDataChanged();
                        return [3, 4];
                    case 2: return [4, this._update(args)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3, 7];
                    case 5: return [4, this._initial(args)];
                    case 6:
                        _a.sent();
                        this.running = true;
                        this.paused = false;
                        _a.label = 7;
                    case 7: return [2];
                }
            });
        });
    };
    BaseHandler.prototype.pause = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.running) {
                    this.paused = true;
                    this._pause();
                }
                return [2];
            });
        });
    };
    BaseHandler.prototype.isRunning = function () {
        return this.running;
    };
    BaseHandler.prototype.isPaused = function () {
        if (this.running)
            return this.paused;
        return false;
    };
    BaseHandler.prototype.stateDataChanged = function () {
        if (this.onStateDataChanged != null)
            this.onStateDataChanged(this, this.stateData, this.errors);
    };
    BaseHandler.prototype.getDistance = function (stops, stpid) {
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i];
            if (typeof stop_1.Id511 !== 'undefined') {
                if (stop_1.Id511 == stpid)
                    return (stop_1.Distance * 0.000621371).toFixed(2);
            }
            else {
                if (stop_1.StopId == stpid)
                    return (stop_1.Distance * 1.0).toFixed(2);
            }
        }
        return "";
    };
    BaseHandler.prototype.appendErrors = function (errors) {
        if (errors != null) {
            if (!Array.isArray(errors))
                this.errors.push(errors);
            else {
                for (var prop in errors) {
                    if (errors.hasOwnProperty(prop)) {
                        this.appendErrors(errors[prop]);
                    }
                }
            }
        }
    };
    BaseHandler.prototype.filterPatternsByDirections = function (direction, patterns) {
        var result = [];
        direction = direction || '';
        for (var i = 0; i < patterns.length; i++) {
            var p = patterns[i];
            if (direction == '' || p.rtdir == direction)
                result.push(p);
        }
        return result;
    };
    BaseHandler.busTimeApi = new BusTimeApi(busTimeBase);
    return BaseHandler;
}());
var FindCurrentLocationHandler = (function (_super) {
    __extends(FindCurrentLocationHandler, _super);
    function FindCurrentLocationHandler(name) {
        var _this = _super.call(this, name || "findCurrentLocation") || this;
        _this.name = "findCurrentLocation";
        _this._dataRefreshed = false;
        _this._dataRefreshedTime = 0;
        return _this;
    }
    FindCurrentLocationHandler.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this);
            return [2];
        }); });
    };
    FindCurrentLocationHandler.prototype._initial = function (args) {
        this.startWatch();
    };
    FindCurrentLocationHandler.prototype._update = function (args) {
    };
    FindCurrentLocationHandler.prototype._stop = function () {
        AcTransitMobi.FindMe.clearWatch(this.watchPositionHandle);
        this._dataRefreshedTime = 0;
    };
    FindCurrentLocationHandler.prototype._pause = function () {
        AcTransitMobi.FindMe.clearWatch(this.watchPositionHandle);
        this._dataRefreshedTime = 0;
    };
    FindCurrentLocationHandler.prototype._continue = function (args) {
        this.startWatch();
    };
    FindCurrentLocationHandler.prototype._getData = function (args) {
        return this.stateData;
    };
    FindCurrentLocationHandler.prototype.startWatch = function () {
        var _this = this;
        this.watchPositionHandle = AcTransitMobi.FindMe.watchPosition(function (position) {
            _this._dataRefreshed = true;
            _this.errors = [];
            if (position != null) {
                _this.stateData = position;
            }
            else {
                _this.stateData = null;
                _this.appendErrors('Location Services not enabled for website.');
            }
            _this.stateDataChanged();
        });
    };
    return FindCurrentLocationHandler;
}(BaseHandler));
var NearByHandler = (function (_super) {
    __extends(NearByHandler, _super);
    function NearByHandler(name) {
        var _this = _super.call(this, name || "nearBy") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    NearByHandler.prototype.run = function (position) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, position);
            return [2];
        }); });
    };
    NearByHandler.prototype._initial = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._position = position;
                        return [4, this.refresh(position)];
                    case 1:
                        _a.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    NearByHandler.prototype._update = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._position = position;
                return [2];
            });
        });
    };
    NearByHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = [];
        this.stateDataChanged();
    };
    NearByHandler.prototype._pause = function () {
        this.stopInterval();
    };
    NearByHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.startInterval();
                return [2];
            });
        });
    };
    NearByHandler.prototype.refresh = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.getStops(position)];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4, this._getData()];
                    case 2:
                        _a.stateData = _b.sent();
                        return [2];
                }
            });
        });
    };
    NearByHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var result, stopsStr, i, predictions, grouped, key, stopId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (this._stops == null || this._stops.length == 0)
                            return [2, result];
                        stopsStr = '';
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this._stops.length)) return [3, 4];
                        if (stopsStr != "")
                            stopsStr += ",";
                        stopsStr += this._stops[i].StopId;
                        if (!((i > 0 && ((i + 1) % 10) == 0) || (i == this._stops.length - 1))) return [3, 3];
                        return [4, this.busTimeApi.getPredictions(stopsStr, "", "")];
                    case 2:
                        predictions = _a.sent();
                        if (predictions != null && predictions.response != null) {
                            grouped = predictions.response.groupBy('stpid');
                            for (key in grouped) {
                                if (grouped.hasOwnProperty(key)) {
                                    stopId = grouped[key].key;
                                    result.push({
                                        stpid: stopId,
                                        distance: this.getDistance(this._stops, stopId),
                                        predictions: grouped[key].items
                                    });
                                }
                            }
                        }
                        stopsStr = '';
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3, 1];
                    case 4: return [2, result];
                }
            });
        });
    };
    NearByHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.getStops(this._position)];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4, this._getData()];
                    case 2:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.nearByRefreshRate);
    };
    NearByHandler.prototype.stopInterval = function () {
        clearInterval(this._intervalHandle);
    };
    NearByHandler.prototype.getStops = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4, this.getNearbyStops(position)];
                    case 1:
                        _a._stops = _b.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _b.sent();
                        this.appendErrors("Could not get stops near you. Please try again later.");
                        console.error(e_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    NearByHandler.prototype.getNearbyStops = function (position) {
        return __awaiter(this, void 0, void 0, function () {
            var maxStopCount, distanceMoved, recalculate, stops, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maxStopCount = 30;
                        distanceMoved = 0;
                        if (this._previouPositionUsed != null)
                            distanceMoved = AcTransitMobi.FindMe.calcDistance(position.coords.latitude, position.coords.longitude, this._previouPositionUsed.coords.latitude, this._previouPositionUsed.coords.longitude);
                        recalculate = this._previouPositionUsed == null || distanceMoved > 0.05;
                        if (!recalculate) return [3, 3];
                        return [4, Server.getAllStops()];
                    case 1:
                        stops = _a.sent();
                        return [4, this.reCalculateResults(position, stops)];
                    case 2:
                        result = (_a.sent()) || [];
                        this._previouPositionUsed = position;
                        return [2, result.slice(0, result.length > maxStopCount ? maxStopCount : result.length)];
                    case 3: return [2, this._stops];
                }
            });
        });
    };
    NearByHandler.prototype.swap = function (items, leftIndex, rightIndex) {
        var temp = items[leftIndex];
        items[leftIndex] = items[rightIndex];
        items[rightIndex] = temp;
    };
    NearByHandler.prototype.partition = function (items, left, right) {
        var pivot = items[Math.floor((right + left) / 2)].Distance, i = left, j = right;
        while (i <= j) {
            while (items[i].Distance < pivot) {
                i++;
            }
            while (items[j].Distance > pivot) {
                j--;
            }
            if (i <= j) {
                this.swap(items, i, j);
                i++;
                j--;
            }
        }
        return i;
    };
    NearByHandler.prototype.quickSort = function (items, left, right) {
        var index;
        if (items.length > 1) {
            index = this.partition(items, left, right);
            if (left < index - 1) {
                this.quickSort(items, left, index - 1);
            }
            if (index < right) {
                this.quickSort(items, index, right);
            }
        }
        return items;
    };
    NearByHandler.prototype.asyncForEach = function (array, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = 0;
                        _a.label = 1;
                    case 1:
                        if (!(index < array.length)) return [3, 4];
                        return [4, callback(array[index], index, array)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        index++;
                        return [3, 1];
                    case 4: return [2];
                }
            });
        });
    };
    NearByHandler.prototype.reCalculateResults = function (position, items) {
        return __awaiter(this, void 0, void 0, function () {
            var newItems, resultsSorted;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newItems = [];
                        return [4, this.asyncForEach(items, function (item) { return __awaiter(_this, void 0, void 0, function () {
                                var distance;
                                return __generator(this, function (_a) {
                                    distance = AcTransitMobi.FindMe.calcDistance(position.coords.latitude, position.coords.longitude, item.Latitude, item.Longitude);
                                    item.Distance = distance;
                                    delete (item.ScheduledTime);
                                    newItems.push(item);
                                    return [2];
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        resultsSorted = this.quickSort(newItems, 0, newItems.length - 1);
                        return [2, resultsSorted];
                }
            });
        });
    };
    return NearByHandler;
}(BaseHandler));
var SelectLineHandler = (function (_super) {
    __extends(SelectLineHandler, _super);
    function SelectLineHandler(name) {
        var _this = _super.call(this, name || "selectLineHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    SelectLineHandler.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this);
            return [2];
        }); });
    };
    SelectLineHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    SelectLineHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    SelectLineHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = [];
        this.stateDataChanged();
    };
    SelectLineHandler.prototype._pause = function () { this.stopInterval(); };
    SelectLineHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        this.startInterval();
                        return [2];
                }
            });
        });
    };
    SelectLineHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.busTimeApi.getRoutes()];
                    case 1:
                        result = (_a.sent()) || { response: [], error: null };
                        result.response = result.response || [];
                        this.appendErrors(result.error);
                        return [2, result.response.routeSort()];
                    case 2:
                        e_2 = _a.sent();
                        console.log(e_2);
                        this.appendErrors("Couldn't get the list of lines. Please try again later.");
                        return [2, null];
                    case 3: return [2];
                }
            });
        });
    };
    SelectLineHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        return [2];
                }
            });
        }); }, this.routesRefreshRate);
    };
    SelectLineHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    return SelectLineHandler;
}(BaseHandler));
var SelectDirectionHandler = (function (_super) {
    __extends(SelectDirectionHandler, _super);
    function SelectDirectionHandler(name) {
        var _this = _super.call(this, name || "selectDirectionHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    SelectDirectionHandler.prototype.run = function (route) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, route);
            return [2];
        }); });
    };
    SelectDirectionHandler.prototype._initial = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._route = route;
                        _a = this;
                        return [4, this._getData(route)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    SelectDirectionHandler.prototype._update = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._route = route;
                        _a = this;
                        return [4, this._getData(route)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    SelectDirectionHandler.prototype._stop = function () {
        this.stateData = [];
        this.stateDataChanged();
    };
    SelectDirectionHandler.prototype._pause = function () { };
    SelectDirectionHandler.prototype._continue = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData(route)];
                    case 1:
                        _a.stateData = _b.sent();
                        return [2];
                }
            });
        });
    };
    SelectDirectionHandler.prototype._getData = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (route == null)
                            return [2, []];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.busTimeApi.getDirections(route.rt)];
                    case 2:
                        result = (_a.sent()) || { response: [], error: null };
                        result.response = result.response || [];
                        this.appendErrors(result.error);
                        return [2, result.response];
                    case 3:
                        e_3 = _a.sent();
                        this.appendErrors("Couldn't get the list of directions. Please try again later.");
                        return [2, []];
                    case 4: return [2];
                }
            });
        });
    };
    return SelectDirectionHandler;
}(BaseHandler));
var SelectStopHandler = (function (_super) {
    __extends(SelectStopHandler, _super);
    function SelectStopHandler(name) {
        var _this = _super.call(this, name || "selectStopHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    SelectStopHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, args);
            return [2];
        }); });
    };
    SelectStopHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData(args)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    SelectStopHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData(args)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    SelectStopHandler.prototype._stop = function () {
        this.stateData = [];
        this.stateDataChanged();
    };
    SelectStopHandler.prototype._pause = function () { };
    SelectStopHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData(args)];
                    case 1:
                        _a.stateData = _b.sent();
                        return [2];
                }
            });
        });
    };
    SelectStopHandler.prototype.getStopOrderInPatterns = function (stpid, patterns) {
        for (var i = 0; i < patterns.length; i++) {
            var pts = patterns[i];
            for (var j = 0; j < pts.pt.length; j++) {
                var p = pts.pt[j];
                if (typeof p.stpid !== 'undefined' && p.stpid == stpid)
                    return p.seq;
            }
        }
        return 100000;
    };
    SelectStopHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var route, direction, byLineSorted, stops, stopsResult, patternsResult, allPatterns, patterns, i, stop_2, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = args.route || null;
                        direction = args.direction || null;
                        byLineSorted = args.lineSorted || false;
                        if (route == null || direction == null || direction.id == '')
                            return [2, []];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4, this.busTimeApi.getStops(route.rt, direction.id, '')];
                    case 2:
                        stopsResult = (_a.sent()) || { response: [], error: null };
                        stopsResult.response = stopsResult.response || [];
                        this.appendErrors(stopsResult.error);
                        stops = stopsResult.response;
                        if (!byLineSorted) return [3, 4];
                        return [4, this.busTimeApi.getPatterns(route.rt)];
                    case 3:
                        patternsResult = _a.sent();
                        patternsResult.response = patternsResult.response || [];
                        allPatterns = patternsResult.response;
                        patterns = this.filterPatternsByDirections(direction.id, allPatterns);
                        for (i = 0; i < stops.length; i++) {
                            stop_2 = stops[i];
                            stop_2.lineSeq = this.getStopOrderInPatterns(stop_2.stpid, patterns);
                        }
                        stops.sort(function (a, b) { return a.lineSeq - b.lineSeq; });
                        return [3, 5];
                    case 4:
                        stops.sort(function (a, b) {
                            if (a.stpnm == b.stpnm)
                                return 0;
                            if (a.stpnm > b.stpnm)
                                return 1;
                            return -1;
                        });
                        _a.label = 5;
                    case 5: return [2, stops];
                    case 6:
                        e_4 = _a.sent();
                        console.error(e_4);
                        this.appendErrors("Couldn't get the list of stops. Please try again later.");
                        return [2, []];
                    case 7: return [2];
                }
            });
        });
    };
    return SelectStopHandler;
}(BaseHandler));
var ByLinePredictionHandler = (function (_super) {
    __extends(ByLinePredictionHandler, _super);
    function ByLinePredictionHandler(name) {
        var _this = _super.call(this, name || "byLinePredictionHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    ByLinePredictionHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                _super.prototype.run.call(this, args);
                return [2];
            });
        });
    };
    ByLinePredictionHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    ByLinePredictionHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    ByLinePredictionHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    ByLinePredictionHandler.prototype._pause = function () {
        this.stopInterval();
    };
    ByLinePredictionHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData(args)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        return [2];
                }
            });
        });
    };
    ByLinePredictionHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var route, direction, stop, busStop, predictionsProm, detoursProm, serviceBulletinsProm, predictionsResult, serviceBulletinsResult, data, serviceBulletins, predictions, otherLinesPredictions, i, item, detours;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = this._route;
                        direction = this._direction;
                        stop = this._busStop;
                        this.errors = [];
                        if (stop == null || stop.stpid == null || stop.stpid == '')
                            return [2, this.createEmptyResult()];
                        return [4, this.busTimeApi.getStops(null, null, stop.stpid)];
                    case 1:
                        busStop = _a.sent();
                        if (busStop.error != null && busStop.error.length > 0) {
                            this.appendErrors(busStop.error);
                            return [2, this.createEmptyResult()];
                        }
                        predictionsProm = this.busTimeApi.getPredictions(stop.stpid, '', '') || { response: [], error: null };
                        detoursProm = this.busTimeApi.getDetoursByStop(stop) || [];
                        route = route || {};
                        direction = direction || {};
                        serviceBulletinsProm = this.busTimeApi.getServiceBulletins(route.rt || '', direction.id || '', stop.stpid || '') || { response: [], error: null };
                        return [4, predictionsProm];
                    case 2:
                        predictionsResult = _a.sent();
                        return [4, serviceBulletinsProm];
                    case 3:
                        serviceBulletinsResult = _a.sent();
                        predictionsResult.response = predictionsResult.response || [];
                        serviceBulletinsResult.response = serviceBulletinsResult.response || [];
                        this.appendErrors(predictionsResult.error);
                        data = predictionsResult.response;
                        serviceBulletins = serviceBulletinsResult.response;
                        predictions = [];
                        otherLinesPredictions = [];
                        for (i = 0; i < data.length; i++) {
                            item = data[i];
                            if (route != null && direction != null && item.rt == route.rt && item.rtdir == direction.id)
                                predictions.push(item);
                            else
                                otherLinesPredictions.push(item);
                        }
                        return [4, detoursProm];
                    case 4:
                        detours = _a.sent();
                        return [2, {
                                predictions: predictions,
                                otherRoutesPredictions: otherLinesPredictions,
                                detours: detours,
                                serviceBulletins: serviceBulletins
                            }];
                }
            });
        });
    };
    ByLinePredictionHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = { route: null, direction: null, stop: null };
        if ((this._route == null && args.route != null) || (this._route != null && args.route != null && this._route.rt != args.route.rt))
            changed = true;
        if ((this._direction == null && args.direction != null) || (this._direction != null && args.direction != null && this._direction.id != args.direction.id))
            changed = true;
        if ((this._busStop == null && args.stop != null) || (this._busStop != null && args.stop != null && this._busStop.stpid != args.stop.stpid))
            changed = true;
        this._route = args.route;
        this._direction = args.direction;
        this._busStop = args.stop;
        return changed;
    };
    ByLinePredictionHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData(null)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.byLinePredictionRefreshRate);
    };
    ByLinePredictionHandler.prototype.stopInterval = function () {
        clearInterval(this._intervalHandle);
    };
    ByLinePredictionHandler.prototype.createEmptyResult = function () {
        return {
            otherRoutesPredictions: [],
            predictions: [],
            detours: [],
            serviceBulletins: []
        };
    };
    return ByLinePredictionHandler;
}(BaseHandler));
var FavoritePredictionHandler = (function (_super) {
    __extends(FavoritePredictionHandler, _super);
    function FavoritePredictionHandler(name) {
        var _this = _super.call(this, name || "FavoritePredictionHandler") || this;
        _this._args = [];
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    FavoritePredictionHandler.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                args = this.getBookmarks();
                _super.prototype.run.call(this, args);
                return [2];
            });
        });
    };
    FavoritePredictionHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    FavoritePredictionHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    FavoritePredictionHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    FavoritePredictionHandler.prototype._pause = function () { this.stopInterval(); };
    FavoritePredictionHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        return [2];
                }
            });
        });
    };
    FavoritePredictionHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = [{ route: null, direction: null, stop: null }];
        this._args = args;
        return changed;
    };
    FavoritePredictionHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.FavoritePredictionRefreshRate);
    };
    FavoritePredictionHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    FavoritePredictionHandler.prototype.createEmptyResult = function () {
        return [];
    };
    FavoritePredictionHandler.prototype.filter = function (args, predictionResult) {
        var predictions = [];
        args = args || { route: null, direction: null, stop: null };
        if (args.stop != null && args.stop.stpid != null && args.stop.stpid != '') {
            var data = predictionResult.response || [];
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (args.stop.stpid == item.stpid &&
                    (args.route == null || (args.route != null && item.rt == args.route.rt)) &&
                    (args.direction == null || (args.direction != null && item.rtdir == args.direction.id))) {
                    predictions.push(item);
                }
            }
        }
        return {
            direction: args.direction,
            predictions: predictions,
            route: args.route,
            stop: args.stop
        };
    };
    FavoritePredictionHandler.prototype.getBookmarks = function () {
        var elligibleBookMarks = [];
        var bookMarks = window.getBookMarks() || [];
        for (var i = 0; i < bookMarks.length; i++) {
            var b = bookMarks[i];
            if (b != null && b.toLowerCase().startsWith('#realtimedetailsbystop')) {
                var parts = b.split('/');
                if (parts.length >= 4) {
                    var a = {
                        route: { rt: decodeURIComponent(parts[1]) },
                        direction: { id: decodeURIComponent(parts[2]) },
                        stop: { stpid: decodeURIComponent(parts[3]) }
                    };
                    elligibleBookMarks.push(a);
                }
            }
        }
        return elligibleBookMarks;
    };
    FavoritePredictionHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var stopsStr, counter, result, temp, i, a, stopResult, stops, predictionResult, j, k, f;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        args = args || this._args;
                        stopsStr = "";
                        counter = 0;
                        result = [];
                        temp = [];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < args.length)) return [3, 5];
                        a = args[i];
                        temp.push(a);
                        if (stopsStr != '' && !stopsStr.endsWith(','))
                            stopsStr += ',';
                        if (a.stop !== null && stopsStr.indexOf(a.stop.stpid) == -1)
                            stopsStr += a.stop.stpid;
                        counter++;
                        if (!(counter >= 10 || i == args.length - 1)) return [3, 4];
                        return [4, this.busTimeApi.getStops("", "", stopsStr)];
                    case 2:
                        stopResult = _a.sent();
                        stops = stopResult.response || [];
                        return [4, this.busTimeApi.getPredictions(stopsStr, '', '')];
                    case 3:
                        predictionResult = (_a.sent()) || { response: [], error: null };
                        for (j = 0; j < temp.length; j++) {
                            for (k = 0; k < stops.length; k++) {
                                if (stops[k].stpid == temp[j].stop.stpid) {
                                    temp[j].stop = stops[k];
                                    break;
                                }
                            }
                            f = this.filter(temp[j], predictionResult);
                            result.push(f);
                        }
                        stopsStr = "";
                        temp = [];
                        counter = 0;
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3, 1];
                    case 5: return [2, result];
                }
            });
        });
    };
    return FavoritePredictionHandler;
}(BaseHandler));
var MapPredictionHandler = (function (_super) {
    __extends(MapPredictionHandler, _super);
    function MapPredictionHandler(name) {
        var _this = _super.call(this, name || "byStopMapPredictionHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    MapPredictionHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, args);
            return [2];
        }); });
    };
    MapPredictionHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapPredictionHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapPredictionHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    MapPredictionHandler.prototype._pause = function () { this.stopInterval(); };
    MapPredictionHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        return [2];
                }
            });
        });
    };
    MapPredictionHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = { route: null, direction: null, stop: null };
        if (args == null)
            args = { route: null, direction: null, stop: null };
        if ((this._route == null && args.route != null) || (this._route != null && args.route != null && this._route.rt != args.route.rt))
            changed = true;
        if ((this._direction == null && args.direction != null) || (this._direction != null && args.direction != null && this._direction.id != args.direction.id))
            changed = true;
        if ((this._busStop == null && args.stop != null) || (this._busStop != null && args.stop != null && this._busStop.stpid != args.stop.stpid))
            changed = true;
        this._route = args.route;
        this._direction = args.direction;
        this._busStop = args.stop;
        return changed;
    };
    MapPredictionHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.byStopMapRefreshRate);
    };
    MapPredictionHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    MapPredictionHandler.prototype.createEmptyResult = function () {
        return {
            serviceBulletins: [],
            predictions: [],
            detours: [],
            vehicles: []
        };
    };
    MapPredictionHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var route, direction, stop, busStop, predictionsProm, detoursProm, serviceBulletinsProm, predictionResult, data, predictions, otherLinesPredictions, vIds, i, item, detours, serviceBulletinsResult, serviceBulletins, allVehicles, vehiclesProm, vehiclesResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = this._route;
                        direction = this._direction;
                        stop = this._busStop;
                        this.errors = [];
                        if (stop == null || stop.stpid == null || stop.stpid == '')
                            return [2, this.createEmptyResult()];
                        return [4, this.busTimeApi.getStops(null, null, stop.stpid)];
                    case 1:
                        busStop = _a.sent();
                        if (busStop.error != null && busStop.error.length > 0) {
                            this.appendErrors(busStop.error);
                            return [2, this.createEmptyResult()];
                        }
                        predictionsProm = this.busTimeApi.getPredictions(stop.stpid, '', '') || { response: [], error: null };
                        detoursProm = this.busTimeApi.getDetoursByStop(stop) || [];
                        serviceBulletinsProm = this.busTimeApi.getServiceBulletins(route.rt, direction.id, stop.stpid) || { response: [], error: null };
                        return [4, predictionsProm];
                    case 2:
                        predictionResult = _a.sent();
                        predictionResult.response = predictionResult.response || [];
                        this.appendErrors(predictionResult.error);
                        data = predictionResult.response;
                        predictions = [];
                        otherLinesPredictions = [];
                        vIds = [];
                        for (i = 0; i < data.length; i++) {
                            item = data[i];
                            if (route != null && direction != null && item.rt == route.rt && item.rtdir == direction.id) {
                                vIds.push(item.vid);
                                predictions.push(item);
                            }
                        }
                        return [4, detoursProm];
                    case 3:
                        detours = _a.sent();
                        return [4, serviceBulletinsProm];
                    case 4:
                        serviceBulletinsResult = _a.sent();
                        this.appendErrors(serviceBulletinsResult.error);
                        serviceBulletinsResult.response = serviceBulletinsResult.response || [];
                        serviceBulletins = serviceBulletinsResult.response;
                        allVehicles = [];
                        if (!(vIds.length > 0)) return [3, 6];
                        vehiclesProm = this.busTimeApi.getVehiclesByIds(vIds);
                        return [4, vehiclesProm];
                    case 5:
                        vehiclesResult = _a.sent();
                        this.appendErrors(vehiclesResult.error);
                        vehiclesResult.response = vehiclesResult.response || [];
                        allVehicles = vehiclesResult.response;
                        _a.label = 6;
                    case 6: return [2, {
                            predictions: predictions,
                            serviceBulletins: serviceBulletins,
                            detours: detours,
                            vehicles: allVehicles
                        }];
                }
            });
        });
    };
    return MapPredictionHandler;
}(BaseHandler));
var MapPatternsHandler = (function (_super) {
    __extends(MapPatternsHandler, _super);
    function MapPatternsHandler(name) {
        var _this = _super.call(this, name || "byStopMapHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    MapPatternsHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, args);
            return [2];
        }); });
    };
    MapPatternsHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapPatternsHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapPatternsHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    MapPatternsHandler.prototype._pause = function () {
        this.stopInterval();
    };
    MapPatternsHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        this.startInterval();
                        if (!changed) return [3, 2];
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    MapPatternsHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = { route: null, direction: null, stop: null };
        if ((this._route == null && args.route != null) || (this._route != null && args.route != null && this._route.rt != args.route.rt))
            changed = true;
        if ((this._direction == null && args.direction != null) || (this._direction != null && args.direction != null && this._direction.id != args.direction.id))
            changed = true;
        if ((this._busStop == null && args.stop != null) || (this._busStop != null && args.stop != null && this._busStop.stpid != args.stop.stpid))
            changed = true;
        this._route = args.route;
        this._direction = args.direction;
        this._busStop = args.stop;
        return changed;
    };
    MapPatternsHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.MapPatternRefreshRate);
    };
    MapPatternsHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    MapPatternsHandler.prototype.createEmptyResult = function () {
        return {
            patterns: []
        };
    };
    MapPatternsHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var route, direction, stop, isValid, routesProm, routesResult, currentRoute, patternProm, patternResult, allPatterns, patterns, allRoutes, i, i, tag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = this._route;
                        direction = this._direction;
                        stop = this._busStop;
                        this.errors = [];
                        isValid = true;
                        if (route == null || route.rt == null || route.rt == '')
                            isValid = false;
                        if (direction == null || direction.id == null || direction.id == '')
                            isValid = false;
                        if (stop == null || stop.stpid == null || stop.stpid == '')
                            isValid = false;
                        if (!isValid)
                            return [2, this.createEmptyResult()];
                        routesProm = null;
                        routesResult = null;
                        currentRoute = null;
                        if (typeof route.rtclr !== 'undefined' && route.rtclr != '')
                            currentRoute = route;
                        patternProm = this.busTimeApi.getPatterns(route.rt);
                        if (currentRoute == null)
                            routesProm = this.busTimeApi.getRoutes();
                        return [4, patternProm];
                    case 1:
                        patternResult = _a.sent();
                        if (!(currentRoute == null)) return [3, 3];
                        return [4, routesProm];
                    case 2:
                        routesResult = _a.sent();
                        _a.label = 3;
                    case 3:
                        this.appendErrors(patternResult.error);
                        patternResult.response = patternResult.response || [];
                        allPatterns = patternResult.response;
                        patterns = this.filterPatternsByDirections(direction.id, allPatterns);
                        if (currentRoute == null) {
                            routesResult.response = routesResult.response || [];
                            allRoutes = routesResult.response;
                            for (i = 0; i < allRoutes.length; i++) {
                                if (allRoutes[i].rt == route.rt) {
                                    currentRoute = allRoutes[i];
                                    break;
                                }
                            }
                        }
                        for (i = 0; i < patterns.length; i++) {
                            tag = currentRoute != null ? { route: currentRoute } : { route: { rt: route.rt, rtclr: '' } };
                            patterns[i].tag = tag;
                        }
                        return [2, {
                                patterns: patterns
                            }];
                }
            });
        });
    };
    return MapPatternsHandler;
}(BaseHandler));
var MapStopsHandler = (function (_super) {
    __extends(MapStopsHandler, _super);
    function MapStopsHandler(name) {
        var _this = _super.call(this, name || "byStopMapHandler") || this;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    MapStopsHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, args);
            return [2];
        }); });
    };
    MapStopsHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapStopsHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapStopsHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    MapStopsHandler.prototype._pause = function () { this.stopInterval(); };
    MapStopsHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        this.startInterval();
                        if (!changed) return [3, 2];
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    MapStopsHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = { route: null, direction: null, stop: null };
        if ((this._route == null && args.route != null) || (this._route != null && args.route != null && this._route.rt != args.route.rt))
            changed = true;
        if ((this._direction == null && args.direction != null) || (this._direction != null && args.direction != null && this._direction.id != args.direction.id))
            changed = true;
        if ((this._busStop == null && args.stop != null) || (this._busStop != null && args.stop != null && this._busStop.stpid != args.stop.stpid))
            changed = true;
        this._route = args.route;
        this._direction = args.direction;
        this._busStop = args.stop;
        return changed;
    };
    MapStopsHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.MapStopsRefreshRate);
    };
    MapStopsHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    MapStopsHandler.prototype.createEmptyResult = function () {
        return {
            stops: [],
        };
    };
    MapStopsHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var route, direction, stop, isValid, stopsProm, stopsResult, stops;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        route = this._route;
                        direction = this._direction;
                        stop = this._busStop;
                        this.errors = [];
                        isValid = true;
                        if (route == null || route.rt == null || route.rt == '')
                            isValid = false;
                        if (direction == null || direction.id == null || direction.id == '')
                            isValid = false;
                        if (stop == null || stop.stpid == null || stop.stpid == '')
                            isValid = false;
                        if (!isValid)
                            return [2, this.createEmptyResult()];
                        stopsProm = this.busTimeApi.getStops(route.rt, direction.id, '');
                        return [4, stopsProm];
                    case 1:
                        stopsResult = _a.sent();
                        this.appendErrors(stopsResult.error);
                        stopsResult.response = stopsResult.response || [];
                        stops = stopsResult.response;
                        return [2, {
                                stops: stops
                            }];
                }
            });
        });
    };
    return MapStopsHandler;
}(BaseHandler));
var MapVehiclePopupHandler = (function (_super) {
    __extends(MapVehiclePopupHandler, _super);
    function MapVehiclePopupHandler(name) {
        var _this = _super.call(this, name || "byStopMapHandler") || this;
        _this.popupOpen = false;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    MapVehiclePopupHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, args);
            return [2];
        }); });
    };
    MapVehiclePopupHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapVehiclePopupHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapVehiclePopupHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    MapVehiclePopupHandler.prototype._pause = function () { this.stopInterval(); };
    MapVehiclePopupHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        return [2];
                }
            });
        });
    };
    MapVehiclePopupHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = { vid: '' };
        if ((this._vid == null && args.vid != null) || (this._vid != args.vid))
            changed = true;
        this._vid = args.vid;
        return changed;
    };
    MapVehiclePopupHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData()];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.MapVehiclePopupRefreshRate);
    };
    MapVehiclePopupHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    MapVehiclePopupHandler.prototype.createEmptyResult = function () {
        return {
            predictions: []
        };
    };
    MapVehiclePopupHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var vid, isValid, predictionsProm, predictionsResult, predictions, routesDic, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vid = this._vid;
                        this.errors = [];
                        isValid = true;
                        if (vid == null || vid == '')
                            isValid = false;
                        if (!isValid)
                            return [2, this.createEmptyResult()];
                        predictionsProm = this.busTimeApi.getPredictions('', '', vid);
                        return [4, predictionsProm];
                    case 1:
                        predictionsResult = _a.sent();
                        predictionsResult.response = predictionsResult.response || [];
                        this.appendErrors(predictionsResult.error);
                        predictions = predictionsResult.response;
                        routesDic = this.busTimeApi.getRoutesDictionary();
                        for (i = 0; i < predictions.length; i++) {
                            predictions[i].tag = routesDic[predictions[i].rt];
                        }
                        return [2, {
                                predictions: predictions
                            }];
                }
            });
        });
    };
    return MapVehiclePopupHandler;
}(BaseHandler));
var MapStopPopupHandler = (function (_super) {
    __extends(MapStopPopupHandler, _super);
    function MapStopPopupHandler(name) {
        var _this = _super.call(this, name || "byStopMapHandler") || this;
        _this.popupOpen = false;
        _this.busTimeApi = BaseHandler.busTimeApi;
        return _this;
    }
    MapStopPopupHandler.prototype.run = function (args) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            _super.prototype.run.call(this, args);
            return [2];
        }); });
    };
    MapStopPopupHandler.prototype._initial = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData(this._args)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.startInterval();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapStopPopupHandler.prototype._update = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setLocalVariables(args);
                        _a = this;
                        return [4, this._getData(this._args)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        });
    };
    MapStopPopupHandler.prototype._stop = function () {
        this.stopInterval();
        this.stateData = this.createEmptyResult();
        this.stateDataChanged();
    };
    MapStopPopupHandler.prototype._pause = function () { this.stopInterval(); };
    MapStopPopupHandler.prototype._continue = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var changed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        changed = this.setLocalVariables(args);
                        this.startInterval();
                        if (!changed) return [3, 2];
                        _a = this;
                        return [4, this._getData(this._args)];
                    case 1:
                        _a.stateData = _b.sent();
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    MapStopPopupHandler.prototype.setLocalVariables = function (args) {
        var changed = false;
        if (args == null)
            args = { stpid: '', rt: '', rtdir: '' };
        this._args = this._args || { stpid: '', rt: '', rtdir: '' };
        if (this._args.stpid != args.stpid)
            changed = true;
        if (this._args.rt != args.rt)
            changed = true;
        if (this._args.rtdir != args.rtdir)
            changed = true;
        this._args = args;
        return changed;
    };
    MapStopPopupHandler.prototype.startInterval = function () {
        var _this = this;
        this._intervalHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this._getData(this._args)];
                    case 1:
                        _a.stateData = _b.sent();
                        this.stateDataChanged();
                        return [2];
                }
            });
        }); }, this.MapStopPopupRefreshRate);
    };
    MapStopPopupHandler.prototype.stopInterval = function () { clearInterval(this._intervalHandle); };
    MapStopPopupHandler.prototype.createEmptyResult = function () {
        return {
            predictions: [],
            stop: null,
            currentRoute: null
        };
    };
    MapStopPopupHandler.prototype._getData = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var isValid, stpid, rt, rtdir, routeProm, stopsProm, predictionsProm, stopsResult, predictionsResult, route, stops, predictions, routesDic, stop, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errors = [];
                        isValid = true;
                        if (args.stpid == null || args.stpid == '')
                            isValid = false;
                        if (!isValid)
                            return [2, this.createEmptyResult()];
                        stpid = args.stpid;
                        rt = args.rt;
                        rtdir = args.rtdir;
                        routeProm = this.busTimeApi.getRoute(rt);
                        stopsProm = this.busTimeApi.getStops('', '', stpid);
                        predictionsProm = this.busTimeApi.getPredictions(stpid, '', '');
                        return [4, stopsProm];
                    case 1:
                        stopsResult = _a.sent();
                        return [4, predictionsProm];
                    case 2:
                        predictionsResult = _a.sent();
                        return [4, routeProm];
                    case 3:
                        route = _a.sent();
                        stopsResult.response = stopsResult.response || [];
                        predictionsResult.response = predictionsResult.response || [];
                        this.appendErrors(stopsResult.error);
                        this.appendErrors(predictionsResult.error);
                        stops = stopsResult.response;
                        predictions = predictionsResult.response;
                        return [4, this.busTimeApi.getRoutesDictionary()];
                    case 4:
                        routesDic = _a.sent();
                        stop = stops.length >= 0 ? stops[0] : null;
                        for (i = 0; i < predictions.length; i++) {
                            predictions[i].tag = routesDic[predictions[i].rt];
                        }
                        return [2, {
                                predictions: predictions,
                                stop: stop,
                                currentRoute: route
                            }];
                }
            });
        });
    };
    return MapStopPopupHandler;
}(BaseHandler));
var RealTimeStateHandler = (function () {
    function RealTimeStateHandler() {
    }
    RealTimeStateHandler.findCurrentLocationHandler = new FindCurrentLocationHandler();
    RealTimeStateHandler.nearByHandler = new NearByHandler();
    RealTimeStateHandler.selectLineHandler = new SelectLineHandler();
    RealTimeStateHandler.selectDirectionHandler = new SelectDirectionHandler();
    RealTimeStateHandler.selectStopHandler = new SelectStopHandler();
    RealTimeStateHandler.byLinePredictionHandler = new ByLinePredictionHandler("byLinePredictionHandler");
    RealTimeStateHandler.byStopPredictionHandler = new ByLinePredictionHandler("byStopPredictionHandler");
    RealTimeStateHandler.mapPredictionHandler = new MapPredictionHandler();
    RealTimeStateHandler.mapPatternsHandler = new MapPatternsHandler();
    RealTimeStateHandler.mapStopsHandler = new MapStopsHandler();
    RealTimeStateHandler.mapVehiclePopupHandler = new MapVehiclePopupHandler();
    RealTimeStateHandler.mapStopPopupHandler = new MapStopPopupHandler();
    RealTimeStateHandler.favoritePredictionHandler = new FavoritePredictionHandler();
    return RealTimeStateHandler;
}());
AcTransitMobi.actrealtime = function (params) {
    var viewModel = {
        NearbyTab: 0,
        FavoritesTab: 1,
        ByLineTab: 2,
        ByStopIdTab: 3,
        cacheKey: 'mobile.spa.rti',
        viewModelLoaded: false,
        selectedTab: ko.observable(0),
        tabHeight: ko.observable(0),
        locationNotSupported: ko.observable(false),
        noDataFound: ko.observable(false),
        routes: ko.observable([]),
        directions: ko.observable([]),
        stops: ko.observable([]),
        predictionsFavorites: ko.observable([]),
        predictions: ko.observable([]),
        predictionsByStop: ko.observable([]),
        predictionsOtherLines: ko.observable([]),
        detours: ko.observable([]),
        serviceBulletins: ko.observable([]),
        selectedRoute: ko.observable(null),
        selectedDirection: ko.observable(null),
        selectedStop: ko.observable(null),
        enteredStop: ko.observable(''),
        enteredStopError: ko.observable(''),
        byLineError: ko.observable(''),
        nearByError: ko.observable(''),
        stopsSorted: ko.observable(false),
        helpVisible: ko.observable(false),
        subscriptions: [],
        favIcons: ko.observable({}),
        tabs: [
            { text: "Nearby", icon: "clock" },
            { text: "Favorites", icon: "favorites" },
            { text: "By Line", icon: "find" },
            { text: "By Stop ID", icon: "map" }
        ],
        viewShowing: function () {
            viewModel.noDataFound(false);
        },
        viewHidden: function () {
            AcTransitMobi.app.currentViewModel = null;
            viewModel.pause();
        },
        viewDisposing: function () {
            viewModel.dispose();
        },
        viewLoaded: function () {
            return __awaiter(this, void 0, void 0, function () {
                var value, bookmarks;
                return __generator(this, function (_a) {
                    viewModel.subscriptions.push(viewModel.selectedTab.subscribe(viewModel.onTabChanged));
                    viewModel.subscriptions.push(viewModel.stopsSorted.subscribe(viewModel.onStopsSorted));
                    value = viewModel.loadStorage(viewModel.cacheKey);
                    if (value != null) {
                        if (typeof value.lineSorted !== 'undefined')
                            viewModel.stopsSorted(value.lineSorted);
                        if (value.rt != '')
                            RealTimeStateHandler.selectLineHandler.defaultValue = value.rt;
                        if (value.rt != '' && value.rtdir != '')
                            RealTimeStateHandler.selectDirectionHandler.defaultValue = value.rtdir;
                        if (value.rt != '' && value.rtdir != '' && value.stpid != '')
                            RealTimeStateHandler.selectStopHandler.defaultValue = value.stpid;
                        if (value.enteredStpid != '')
                            RealTimeStateHandler.byStopPredictionHandler.defaultValue = value.enteredStpid;
                    }
                    bookmarks = RealTimeStateHandler.favoritePredictionHandler.getBookmarks() || [];
                    if (bookmarks.length > 0)
                        viewModel.selectedTab(viewModel.FavoritesTab);
                    return [2];
                });
            });
        },
        viewShown: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            window.utils.triggerGA('/index.html#actrealtime', '#ACTRealTime');
                            AcTransitMobi.app.currentViewModel = viewModel;
                            if (!!viewModel.viewModelLoaded) return [3, 2];
                            return [4, viewModel.viewLoaded()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            viewModel.viewModelLoaded = true;
                            this.tabHeight($("#actrealtimeTab").height());
                            RealTimeStateHandler.findCurrentLocationHandler.onStateDataChanged = function (state, stateData) {
                                if (stateData != null) {
                                    viewModel.locationNotSupported(false);
                                    RealTimeStateHandler.nearByHandler.run(stateData);
                                }
                                else
                                    viewModel.locationNotSupported(true);
                            };
                            RealTimeStateHandler.nearByHandler.onStateDataChanged = function (state, predictions) {
                                if (predictions != null && predictions.length > 0) {
                                    viewModel.noDataFound(false);
                                    viewModel.nearByError('');
                                    predictions.sort(function (a, b) {
                                        return a.distance < b.distance ? -1 : 1;
                                    });
                                    predictions.distinctByForGroupBy("predictions", ["rt", "rtdir"]);
                                    _this.predictionsByStop(predictions);
                                }
                                else {
                                    viewModel.noDataFound(true);
                                    viewModel.predictionsByStop([]);
                                    state.errors = state.errors || [];
                                    viewModel.nearByError((state.errors.length > 0 ? getError(state.errors[0]) : ''));
                                }
                            };
                            RealTimeStateHandler.selectLineHandler.onStateDataChanged = function (state, stateData) {
                                stateData = stateData || [];
                                state.errors = state.errors || [];
                                viewModel.byLineError((stateData.length == 0 && state.errors.length > 0 ? getError(state.errors[0]) : ''));
                                _this.routes(stateData);
                                var v = _this.findInArray(stateData, 'rt', state.defaultValue);
                                if (v != null) {
                                    _this.selectedRoute(v);
                                    _this.routeChanged();
                                }
                            };
                            RealTimeStateHandler.selectDirectionHandler.onStateDataChanged = function (state, stateData) {
                                stateData = stateData || [];
                                state.errors = state.errors || [];
                                viewModel.byLineError((stateData.length == 0 && state.errors.length > 0 ? getError(state.errors[0]) : ''));
                                _this.directions(stateData);
                                if (stateData != null && stateData.length > 0) {
                                    var v = _this.findInArray(stateData, 'id', state.defaultValue);
                                    if (v != null) {
                                        _this.selectedDirection(v);
                                        _this.directionChanged();
                                    }
                                }
                            };
                            RealTimeStateHandler.selectStopHandler.onStateDataChanged = function (state, stateData) {
                                state.errors = state.errors || [];
                                viewModel.byLineError((stateData.length == 0 && state.errors.length > 0 ? getError(state.errors[0]) : ''));
                                _this.stops(stateData);
                                var v = _this.findInArray(stateData, 'stpid', state.defaultValue);
                                if (v != null) {
                                    _this.selectedStop(v);
                                    _this.stopChanged();
                                }
                            };
                            RealTimeStateHandler.byLinePredictionHandler.onStateDataChanged = function (state, stateData) {
                                if (viewModel.selectedTab() == viewModel.ByLineTab) {
                                    stateData = stateData || { predictions: [], otherRoutesPredictions: [], detours: [], serviceBulletins: [] };
                                    _this.detours(stateData.detours || []);
                                    _this.serviceBulletins(stateData.serviceBulletins || []);
                                    _this.predictions(stateData.predictions || []);
                                    _this.predictionsOtherLines(stateData.otherRoutesPredictions || []);
                                }
                            };
                            RealTimeStateHandler.byStopPredictionHandler.onStateDataChanged = function (state, stateData) {
                                if (viewModel.selectedTab() == viewModel.ByStopIdTab) {
                                    stateData = stateData || { predictions: [], otherRoutesPredictions: [], detours: [], serviceBulletins: [] };
                                    _this.detours(stateData.detours || []);
                                    _this.serviceBulletins(stateData.serviceBulletins || []);
                                    _this.predictions(stateData.otherRoutesPredictions || []);
                                    _this.enteredStopError((state.errors != null && state.errors.length > 0) ? getError(state.errors[0]).msg : '');
                                    if (state.defaultValue != null)
                                        _this.enteredStop(state.defaultValue);
                                }
                            };
                            RealTimeStateHandler.favoritePredictionHandler.onStateDataChanged = function (state, stateData) {
                                stateData = stateData || [];
                                viewModel.predictionsFavorites(stateData);
                            };
                            viewModel.run();
                            return [2];
                    }
                });
            });
        },
        onRouteChanged: function (sender) {
            if (viewModel.isCalledByScript(sender))
                return;
            viewModel.savePage();
            viewModel.routeChanged();
        },
        onDirectionChanged: function (sender) {
            if (viewModel.isCalledByScript(sender))
                return;
            viewModel.savePage();
            viewModel.directionChanged();
        },
        onStopChanged: function (sender) {
            if (viewModel.isCalledByScript(sender))
                return;
            viewModel.savePage();
            viewModel.stopChanged();
        },
        keypress: function (e) {
            if (e.jQueryEvent && e.jQueryEvent.keyCode) {
                if (e.jQueryEvent.keyCode === 13) {
                    viewModel.goClicked();
                }
            }
        },
        goClicked: function () {
            var stopId = viewModel.enteredStop();
            var byLine = viewModel.stopsSorted() || false;
            viewModel.savePage();
            RealTimeStateHandler.byStopPredictionHandler.defaultValue = null;
            RealTimeStateHandler.byStopPredictionHandler.run({ route: null, direction: null, stop: { stpid: stopId } });
        },
        routeChanged: function () {
            var route = this.selectedRoute() || { rt: '' };
            var byLine = viewModel.stopsSorted() || false;
            RealTimeStateHandler.selectLineHandler.defaultValue = null;
            RealTimeStateHandler.selectDirectionHandler.run(route);
            this.selectedDirection(null);
            this.selectedStop(null);
        },
        directionChanged: function () {
            var route = this.selectedRoute() || { rt: '' };
            var routeDirection = this.selectedDirection() || { id: '' };
            var lineSorted = viewModel.stopsSorted();
            var byLine = viewModel.stopsSorted() || false;
            RealTimeStateHandler.selectDirectionHandler.defaultValue = null;
            RealTimeStateHandler.selectStopHandler.run({ route: route, direction: routeDirection, lineSorted: lineSorted });
            this.selectedStop(null);
        },
        stopChanged: function () {
            var route = this.selectedRoute() || { rt: '' };
            var routeDirection = this.selectedDirection() || { id: '' };
            var stop = this.selectedStop() || { stpid: '' };
            var byLine = viewModel.stopsSorted() || false;
            RealTimeStateHandler.selectStopHandler.defaultValue = null;
            RealTimeStateHandler.byLinePredictionHandler.run({ route: route, direction: routeDirection, stop: stop });
        },
        tabClicked: function () {
            $("#ScrollView").dxScrollView("instance").scrollTo(0);
        },
        onTabChanged: function () {
            viewModel.run();
        },
        onTitleClicked: function () {
            viewModel.helpVisible(true);
        },
        onStopsSorted: function (e) {
            if (!viewModel.viewModelLoaded)
                return;
            var byLine = e;
            var route = viewModel.selectedRoute() || { rt: '' };
            var routeDirection = viewModel.selectedDirection() || { id: '' };
            var stop = viewModel.selectedStop() || { stpid: '' };
            viewModel.savePage();
            var stops = viewModel.stops();
            RealTimeStateHandler.selectStopHandler.defaultValue = stop.stpid;
            RealTimeStateHandler.selectStopHandler.run({ route: route, direction: routeDirection, lineSorted: byLine });
        },
        isCalledByScript: function (sender) {
            if (typeof sender === 'undefined' || sender.srcElement == null ||
                sender.srcElement.tagName == 'SCRIPT' || sender.srcElement.tagName == 'script' ||
                sender.srcElement.tagName == 'SPAN' || sender.srcElement.tagName == 'span')
                return true;
            return false;
        },
        run: function () {
            switch (viewModel.selectedTab()) {
                case viewModel.NearbyTab:
                    viewModel.noDataFound(false);
                    RealTimeStateHandler.byLinePredictionHandler.pause();
                    RealTimeStateHandler.byStopPredictionHandler.pause();
                    RealTimeStateHandler.favoritePredictionHandler.pause();
                    RealTimeStateHandler.findCurrentLocationHandler.run();
                    break;
                case viewModel.FavoritesTab:
                    RealTimeStateHandler.favoritePredictionHandler.run();
                    break;
                case viewModel.ByLineTab:
                    RealTimeStateHandler.byStopPredictionHandler.pause();
                    RealTimeStateHandler.favoritePredictionHandler.pause();
                    RealTimeStateHandler.findCurrentLocationHandler.stop();
                    RealTimeStateHandler.nearByHandler.stop();
                    RealTimeStateHandler.selectLineHandler.run();
                    RealTimeStateHandler.byLinePredictionHandler.run({ route: viewModel.selectedRoute(), direction: viewModel.selectedDirection(), stop: viewModel.selectedStop() });
                    RealTimeStateHandler.byLinePredictionHandler.stateDataChanged();
                    break;
                case viewModel.ByStopIdTab:
                    RealTimeStateHandler.byLinePredictionHandler.pause();
                    RealTimeStateHandler.selectLineHandler.pause();
                    RealTimeStateHandler.favoritePredictionHandler.pause();
                    RealTimeStateHandler.findCurrentLocationHandler.stop();
                    RealTimeStateHandler.nearByHandler.stop();
                    RealTimeStateHandler.byStopPredictionHandler.run({ route: null, direction: null, stop: { stpid: viewModel.enteredStop() } });
                    RealTimeStateHandler.byStopPredictionHandler.stateDataChanged();
                    break;
            }
        },
        routeDisplay: function (item) {
            if (item != null)
                return item.rt + ' - ' + item.rtnm;
            return '';
        },
        getRemainingTime: function (item) {
            return getRemainingTime(item);
        },
        getRemainingTimeColor: function (item) {
            return getRemainingTimeColor(item);
        },
        loadStorage: function (key) {
            var result = { tab: 0, rt: '', rtdir: '', stpid: '', enteredStpid: '', lineSorted: false };
            if (typeof (Storage) !== "undefined") {
                var v = localStorage.getItem(key) || '';
                if (v != '') {
                    var strs = v.split(',');
                    if (strs.length > 0)
                        result.tab = parseInt(strs[0], 10);
                    if (strs.length > 1)
                        result.rt = strs[1];
                    if (strs.length > 2)
                        result.rtdir = strs[2];
                    if (strs.length > 3)
                        result.stpid = strs[3];
                    if (strs.length > 4)
                        result.enteredStpid = strs[4];
                    if (strs.length > 5)
                        result.lineSorted = (strs[5] == '1' ? true : false);
                }
            }
            ;
            return result;
        },
        savePage: function () {
            var rt = (viewModel.selectedRoute() || {}).rt || '';
            var rtdir = (viewModel.selectedDirection() || {}).id || '';
            var stpid = (viewModel.selectedStop() || {}).stpid || '';
            var enteredStpid = viewModel.enteredStop() || '';
            var lineSorted = viewModel.stopsSorted() || false;
            viewModel.saveStorage(viewModel.cacheKey, { tab: viewModel.selectedTab(), rt: rt, rtdir: rtdir, stpid: stpid, enteredStpid: enteredStpid, lineSorted: lineSorted });
        },
        saveStorage: function (key, value) {
            value = value || { tab: 0, rt: '', rtdir: '', stpid: '', enteredStpid: '', lineSorted: false };
            var tab = value.tab || 0;
            var rt = value.rt || '';
            var rtdir = value.rtdir || '';
            var stpid = value.stpid || '';
            var enteredStpid = value.enteredStpid || '';
            var lineSorted = value.lineSorted || false;
            var lineSortedVal = (lineSorted ? '1' : '0');
            if (typeof (Storage) !== "undefined") {
                var value_1 = tab + "," + rt + "," + rtdir + "," + stpid + "," + enteredStpid + "," + lineSortedVal;
                localStorage.setItem(key, value_1);
            }
            ;
        },
        pause: function () {
            RealTimeStateHandler.findCurrentLocationHandler.stop();
            RealTimeStateHandler.nearByHandler.stop();
            RealTimeStateHandler.selectLineHandler.pause();
            RealTimeStateHandler.selectStopHandler.pause();
            RealTimeStateHandler.selectDirectionHandler.pause();
            RealTimeStateHandler.byLinePredictionHandler.pause();
            RealTimeStateHandler.byStopPredictionHandler.pause();
        },
        dispose: function () {
            for (var i = 0; i < viewModel.subscriptions.length; i++)
                viewModel.subscriptions[i].dispose();
            RealTimeStateHandler.findCurrentLocationHandler.stop();
            RealTimeStateHandler.nearByHandler.stop();
            RealTimeStateHandler.selectLineHandler.stop();
            RealTimeStateHandler.selectStopHandler.stop();
            RealTimeStateHandler.selectDirectionHandler.stop();
            RealTimeStateHandler.byLinePredictionHandler.stop();
            RealTimeStateHandler.byStopPredictionHandler.stop();
            viewModel.routes([]);
            viewModel.directions([]);
            viewModel.stops([]);
            viewModel.predictions([]);
            viewModel.predictionsByStop([]);
            viewModel.predictionsOtherLines([]);
            viewModel.detours([]);
            viewModel.serviceBulletins([]);
            viewModel.selectedRoute(null);
            viewModel.selectedDirection(null);
            viewModel.selectedStop(null);
            viewModel.enteredStop('');
            viewModel.enteredStopError('');
        },
        findInArray: function (arr, columnName, value) {
            arr = arr || [];
            arr != null && columnName || '';
            if (columnName != '' && typeof (value !== 'undefined')) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i][columnName] == value)
                        return arr[i];
                }
            }
            return null;
        },
        getDetourText: function (detour, dtroute) {
            var startDate = viewModel.formatDate(detour.startdt);
            var endDate = viewModel.formatDate(detour.enddt);
            return "Route " + dtroute.rt + " " + dtroute.dir + " " + startDate + " - " + endDate;
        },
        formatDate: function (dt) {
            if (dt.length != 14)
                return dt;
            var d = dt.split(' ')[0];
            var t = dt.split(' ')[1];
            if (t == "00:00")
                t = "12:00 AM";
            return d.substr(4, 2) + "/" + d.substr(6, 2) + "/" + d.substr(0, 4) + " " + t;
        },
        bookmarkPage: function (url, event) {
            if (event && event.preventDefault)
                event.preventDefault();
            if (event && event.stopPropagation)
                event.stopPropagation();
            window.removeBookMark(url);
            url = encodeURI(url);
            window.removeBookMark(url);
            var icons = viewModel.favIcons();
            icons[url] = false;
            viewModel.favIcons.valueHasMutated();
            setTimeout(function () {
                RealTimeStateHandler.favoritePredictionHandler.run();
                delete (icons[url]);
            }, 500);
            return false;
        },
        getFavIcon: function (url) {
            url = encodeURI(url);
            var icons = viewModel.favIcons();
            if (typeof icons[url] === 'undefined') {
                icons[url] = true;
            }
            return icons[url];
        },
        getDetialUrl: function (rt, directionId, stpid) {
            return "#RealTimeDetailsByStop/" + rt + "/" + encodeURIComponent(directionId) + "/" + stpid;
        }
    };
    return viewModel;
};
AcTransitMobi.RealTimeDetailsByStop = function (params) {
    var baseIconUrl = virtualDirectoryName + "/images/bustime/";
    var busIconUrl = baseIconUrl + "busiconLarge.png";
    var busStopIconLargeUrl = baseIconUrl + "stopiconlarge.png";
    var busStopIconUrl = baseIconUrl + "stopicon.png";
    var stopIconDisabledUrl = baseIconUrl + "stopicondisabled.png";
    var stopIconLargeDisabledUrl = baseIconUrl + "stopiconlargedisabled.png";
    var currentLocationIconUrl = baseIconUrl + "currentLocation.png";
    var bartIcon = virtualDirectoryName + "/images/bart.png";
    var bartJson = virtualDirectoryName + "/data/bart.json";
    var isLeafLet = false;
    var isMapGl = true;
    var map = null;
    var mapHelper = null;
    var vehiclePopupInfo;
    var stopPopupInfo;
    var viewModel = {
        currentStopId: params.stpid,
        currentRoute: params.rt,
        currentDirection: params.rtdir,
        validStop: ko.observable(true),
        hasError: ko.observable(false),
        hasParameterError: ko.observable(false),
        bartIcon: ko.observable(bartIcon),
        bartJson: ko.observable(bartJson),
        helpVisible: ko.observable(false),
        actHelpVisible: ko.observable(false),
        predictionExpired: ko.observable(false),
        pageLoading: ko.observable(true),
        predictions: ko.observableArray([]),
        serviceBulletins: ko.observableArray([]),
        markers: ko.observableArray([]),
        vehicleInfoModel: ko.observable(null),
        stopInfoModel: ko.observable(null),
        mapAutoAdjust: ko.observable(true),
        mapCenter: ko.observable({ lat: '37.806221', lng: '-122.269675' }),
        mapZoom: ko.observable(12),
        myLocation: ko.observable(null),
        bookMarked: ko.observable(false),
        mapProvider: ko.observable(isMapGl ? 'osm.vector' : (isLeafLet ? 'osm.leaflet' : ('google'))),
        osmMapType: ko.observable('positron'),
        serviceBulletinsDropdownClosed: ko.observable(true),
        serviceBulletinsDropdownClicked: function () {
            viewModel.serviceBulletinsDropdownClosed(!viewModel.serviceBulletinsDropdownClosed());
        },
        onMapReady: function (e) {
            map = e.originalMap;
            mapHelper = new actransit.maps.Map(e.originalMap, busStopIconUrl, busStopIconLargeUrl, stopIconDisabledUrl, stopIconLargeDisabledUrl, busIconUrl, currentLocationIconUrl, isLeafLet, isMapGl);
            mapHelper.init();
            if (viewModel.myLocation() != null) {
                mapHelper.setMyLocation(viewModel.myLocation().lat, viewModel.myLocation().lng);
            }
            if (isLeafLet) {
                map.on('dragstart', function () {
                    mapHelper.setDefaultZooming(false);
                    viewModel.mapAutoAdjust(false);
                });
            }
            else if (isMapGl) {
                map.on('dragstart', function () {
                    mapHelper.setDefaultZooming(false);
                    viewModel.mapAutoAdjust(false);
                });
            }
            else {
                map.addListener('dragstart', function () {
                    mapHelper.setDefaultZooming(false);
                    viewModel.mapAutoAdjust(false);
                });
            }
            viewModel.startHandlers();
        },
        viewHidden: function () {
            AcTransitMobi.app.currentViewModel = null;
            viewModel.pause();
        },
        viewDisposing: function () {
            viewModel.dispose();
        },
        viewShowing: function () {
        },
        viewShown: function () {
            setTimeout(function () {
                viewModel.viewShowInternal();
            }, 100);
        },
        viewShowInternal: function () {
            var _this = this;
            var numberOfLoads = 4;
            var numberLoaded = 0;
            var mapCentered = false;
            window.utils.triggerGA('/index.html#actrealtimedetails', '#RealTimeDetailsByStop');
            AcTransitMobi.app.currentViewModel = viewModel;
            var bm = window.isBookMarked(location.hash);
            viewModel.bookMarked(!(bm == undefined || bm == 0 || bm == false));
            RealTimeStateHandler.findCurrentLocationHandler.onStateDataChanged = function (handler, stateData) {
                numberLoaded++;
                var position = stateData;
                if (position != null) {
                    var coord = position.coords;
                    viewModel.myLocation({ lat: coord.latitude, lng: coord.longitude });
                    if (mapHelper != null) {
                        mapHelper.setMyLocation(coord.latitude, coord.longitude);
                    }
                }
                if (numberLoaded == numberOfLoads)
                    _this.pageLoading(false);
            };
            RealTimeStateHandler.mapPredictionHandler.onStateDataChanged = function (handler, stateData) {
                numberLoaded++;
                _this.predictions(stateData.predictions);
                _this.serviceBulletins(stateData.serviceBulletins);
                _this.showVehicles(stateData.vehicles);
                if (numberLoaded == numberOfLoads)
                    _this.pageLoading(false);
            };
            RealTimeStateHandler.mapPatternsHandler.onStateDataChanged = function (handler, stateData) {
                numberLoaded++;
                stateData = stateData || { patterns: [] };
                _this.showPatterns(stateData.patterns);
                if (numberLoaded == numberOfLoads)
                    _this.pageLoading(false);
            };
            RealTimeStateHandler.mapStopsHandler.onStateDataChanged = function (handler, stateData) {
                numberLoaded++;
                stateData = stateData || { stops: [] };
                _this.showStops(stateData.stops);
                var stopFound = false;
                for (var i = 0; i < stateData.stops.length; i++) {
                    var s = stateData.stops[i];
                    if (s.stpid == viewModel.currentStopId) {
                        stopFound = true;
                        mapHelper.addCircle(s.lat, s.lon, '#FF0000', 100);
                        if (!mapCentered) {
                            mapHelper.setCenter(s.lat, s.lon);
                            if (_this.isLeafLet) {
                                _this.mapCenter(L.latLng(s.lat, s.lon));
                                _this.mapZoom(mapHelper.centerZoom);
                            }
                            mapCentered = true;
                        }
                        break;
                    }
                }
                if (RealTimeStateHandler.mapStopsHandler.errors && RealTimeStateHandler.mapStopsHandler.errors.length > 0) {
                    var err = RealTimeStateHandler.mapStopsHandler.errors[0];
                    _this.hasError(true);
                    if (err.msg && err.msg == "No data found for parameter")
                        _this.hasParameterError(true);
                    else
                        _this.hasParameterError(false);
                }
                else
                    _this.hasError(false);
                _this.validStop(stopFound);
                if (numberLoaded == numberOfLoads)
                    _this.pageLoading(false);
            };
            RealTimeStateHandler.mapVehiclePopupHandler.onStateDataChanged = function (handler, stateData) {
                if (stateData == null || stateData.predictions == null || stateData.predictions.length == 0)
                    return;
                _this.vehicleInfoModel({
                    data: stateData.predictions,
                });
                var info = _this.getVehiclePopup();
                if (isLeafLet) {
                    info.setLatLng(handler.marker.getLatLng()).openOn(map);
                }
                else if (isMapGl) {
                    info.setLngLat(handler.marker.getLngLat()).addTo(map);
                }
                else
                    info.open(map, handler.marker);
            };
            RealTimeStateHandler.mapStopPopupHandler.onStateDataChanged = function (handler, stateData) {
                if (stateData == null || stateData.stop == null)
                    return;
                _this.stopInfoModel({
                    data: stateData.predictions,
                    stop: stateData.stop,
                    route: stateData.currentRoute
                });
                var info = _this.getStopPopup();
                if (isLeafLet) {
                    info.setLatLng(handler.marker.getLatLng()).openOn(map);
                }
                else if (isMapGl) {
                    info.setLngLat(handler.marker.getLngLat()).addTo(map);
                }
                else
                    info.open(map, handler.marker);
            };
            RealTimeStateHandler.findCurrentLocationHandler.run();
            viewModel.startHandlers();
        },
        startHandlers: function () {
            if (mapHelper != null) {
                var input = { route: { rt: this.currentRoute }, direction: { id: this.currentDirection }, stop: { stpid: this.currentStopId } };
                RealTimeStateHandler.mapPredictionHandler.run(input);
                RealTimeStateHandler.mapPatternsHandler.run(input);
                RealTimeStateHandler.mapStopsHandler.run(input);
            }
        },
        showPatterns: function (patterns) {
            if (mapHelper == null)
                return;
            mapHelper.clearPatterns();
            for (var i = 0; i < patterns.length; i++) {
                var p = patterns[i];
                mapHelper.addPattern(p.pid, p.pt, p.tag.route.rt, p.tag.route.rtclr);
            }
        },
        showVehicles: function (vehicles) {
            if (mapHelper == null)
                return;
            mapHelper.addOrUpdateVehicles(vehicles, this.onVehicleClicked);
        },
        showStops: function (stops) {
            if (mapHelper == null)
                return;
            mapHelper.addOrUpdateStops(stops, this.onStopClicked);
        },
        onVehicleClicked: function (marker, vehicle, tag) {
            if (RealTimeStateHandler.mapVehiclePopupHandler.popupOpen && RealTimeStateHandler.mapVehiclePopupHandler.infoWindow != null)
                RealTimeStateHandler.mapVehiclePopupHandler.infoWindow.close();
            RealTimeStateHandler.mapVehiclePopupHandler.marker = marker;
            RealTimeStateHandler.mapVehiclePopupHandler.run({ vid: vehicle.vid });
        },
        onStopClicked: function (marker, stop, tag) {
            if (RealTimeStateHandler.mapStopPopupHandler.popupOpen && RealTimeStateHandler.mapStopPopupHandler.infoWindow != null)
                RealTimeStateHandler.mapStopPopupHandler.infoWindow.close();
            RealTimeStateHandler.mapStopPopupHandler.marker = marker;
            RealTimeStateHandler.mapStopPopupHandler.run({ stpid: stop.stpid, rt: viewModel.currentRoute, rtdir: viewModel.currentDirection });
        },
        onTitleClicked: function () {
            viewModel.helpVisible(true);
        },
        getVehiclePopup: function () {
            if (vehiclePopupInfo == null) {
                if (isLeafLet) {
                    vehiclePopupInfo = L.popup({ maxWidth: 280 });
                    vehiclePopupInfo.on('remove', function () {
                        RealTimeStateHandler.mapVehiclePopupHandler.stop();
                    });
                }
                else if (isMapGl) {
                    vehiclePopupInfo = new mapboxgl.Popup();
                    vehiclePopupInfo.setMaxWidth('280px');
                    vehiclePopupInfo.on('close', function () {
                        RealTimeStateHandler.mapVehiclePopupHandler.stop();
                    });
                }
                else {
                    vehiclePopupInfo = new google.maps.InfoWindow({
                        content: ""
                    });
                    vehiclePopupInfo.addListener('closeclick', function () {
                        RealTimeStateHandler.mapVehiclePopupHandler.stop();
                    });
                }
            }
            var $popup = $("#vehiclePopup");
            if (isMapGl)
                vehiclePopupInfo.setHTML($popup.html());
            else
                vehiclePopupInfo.setContent($popup.html());
            return vehiclePopupInfo;
        },
        getStopPopup: function () {
            if (stopPopupInfo == null) {
                if (isLeafLet) {
                    stopPopupInfo = L.popup({ maxWidth: 280 });
                    stopPopupInfo.on('remove', function () {
                        RealTimeStateHandler.mapStopPopupHandler.stop();
                    });
                }
                else if (isMapGl) {
                    stopPopupInfo = new mapboxgl.Popup();
                    stopPopupInfo.setMaxWidth('90%');
                    stopPopupInfo.on('close', function () {
                        RealTimeStateHandler.mapStopPopupHandler.stop();
                    });
                }
                else {
                    stopPopupInfo = new google.maps.InfoWindow({
                        content: ""
                    });
                    stopPopupInfo.addListener('closeclick', function () {
                        RealTimeStateHandler.mapStopPopupHandler.stop();
                    });
                }
            }
            var $popup = $("#stopPopup");
            if (isMapGl)
                stopPopupInfo.setHTML($popup.html());
            else
                stopPopupInfo.setContent($popup.html());
            return stopPopupInfo;
        },
        onMinClick: function (data) {
            var vehicleMarker = mapHelper.getVehicleMarker(data.vid);
            if (vehicleMarker != null) {
                var position = isLeafLet ? vehicleMarker.getLatLng() : (isMapGl ? vehicleMarker.getLngLat() : vehicleMarker.getPosition());
                if (isLeafLet || isMapGl)
                    mapHelper.setCenter(position.lat, position.lng);
                else
                    mapHelper.setCenter(position.lat(), position.lng());
            }
        },
        onActHelpClick: function () {
            viewModel.actHelpVisible(true);
        },
        getRemainingTime: function (item) { return getRemainingTime(item); },
        getRemainingTimeColor: function (item) { return getRemainingTimeColor(item); },
        pause: function () {
            RealTimeStateHandler.findCurrentLocationHandler.stop();
            RealTimeStateHandler.mapPredictionHandler.pause();
            RealTimeStateHandler.mapPatternsHandler.pause();
            RealTimeStateHandler.mapStopsHandler.pause();
            RealTimeStateHandler.mapVehiclePopupHandler.pause();
            RealTimeStateHandler.mapStopPopupHandler.pause();
        },
        bookmarkPage: function () {
            var url = location.hash;
            if (!window.isBookMarked(url)) {
                window.addToBookMarks(url);
                this.bookMarked(true);
            }
            else {
                window.removeBookMark(url);
                this.bookMarked(false);
            }
        },
        getScheduleLink: function () {
            var day = (new Date()).getDay();
            var wd = day == 0 ? "Sundays" : (day == 6 ? "Saturdays" : "Weekday");
            return '#SchedulesTable/' + viewModel.currentRoute + '?name=' + viewModel.currentDirection + '%2C%20' + wd + '%20Schedule';
        },
        dispose: function () {
            RealTimeStateHandler.findCurrentLocationHandler.stop();
            RealTimeStateHandler.mapPredictionHandler.stop();
            RealTimeStateHandler.mapPatternsHandler.stop();
            RealTimeStateHandler.mapStopsHandler.stop();
            RealTimeStateHandler.mapVehiclePopupHandler.stop();
            RealTimeStateHandler.mapStopPopupHandler.stop();
        },
    };
    return viewModel;
};
//# sourceMappingURL=all.js.map